webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);

var bus = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a();

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/immiexperts.51f00a3.png";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(474),
  /* scopeId */
  "data-v-07686c12",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pocketlegal_logo.c1b02b2.png";

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(483),
  /* scopeId */
  "data-v-24b52929",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(405)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(508),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(403)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(504),
  /* scopeId */
  "data-v-6ac6498a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(484),
  /* scopeId */
  "data-v-2b0b7e36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(406)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(509),
  /* scopeId */
  "data-v-77348cc6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(477),
  /* scopeId */
  "data-v-10dc828a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(402)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(503),
  /* scopeId */
  "data-v-66ef4c6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(391)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(488),
  /* scopeId */
  "data-v-35e6e16e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(481),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(475),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(478),
  /* scopeId */
  "data-v-12fcd227",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(502),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(499),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(471),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(506),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(498),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(408)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(512),
  /* scopeId */
  "data-v-80d3a322",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(420)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(526),
  /* scopeId */
  "data-v-f9758fa0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */,
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_adminHome_adminHome__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_adminHome_adminHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_adminHome_adminHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_clienthome__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_clienthome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_clienthome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_users_clientMatter__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_users_clientMatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_users_clientMatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_documents_clientDocs__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_documents_clientDocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_documents_clientDocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_accounts_clientInvoices__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_accounts_clientInvoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_accounts_clientInvoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_users_user__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_users_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_users_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_users_users__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_users_users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_users_users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_users_newUser__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_users_newUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_users_newUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_users_setPassword__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_users_setPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_users_setPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_visatypes__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_visatypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_visatypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_visatypes_visatype__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_visatypes_visatype___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_visatypes_visatype__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_matters__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_matters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_matters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_matter__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_matter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_matter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_accounts_accounts__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_accounts_accounts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_accounts_accounts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_accounts_invoice__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_accounts_invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_accounts_invoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_accounts_receipt__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_accounts_receipt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_accounts_receipt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_accounts_pay__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_accounts_pay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_accounts_pay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_agreements_agreements__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_agreements_agreements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_agreements_agreements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_users_profileWrapper__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_users_profileWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_users_profileWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_vevo__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_vevo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_vevo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_docs_chooseDocCategory__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_docs_chooseDocCategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_docs_chooseDocCategory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_docs_chooseDocType__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_docs_chooseDocType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_docs_chooseDocType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_docs_edit_template__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_docs_edit_template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_docs_edit_template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_docs_makeDoc__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_docs_makeDoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_docs_makeDoc__);



























__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'active',
  routes: [{ path: '/', components: { default: __WEBPACK_IMPORTED_MODULE_2__components_adminHome_adminHome___default.a, client: __WEBPACK_IMPORTED_MODULE_3__components_clienthome___default.a } }, { path: '/visatypes', component: __WEBPACK_IMPORTED_MODULE_11__components_visatypes___default.a }, { path: '/visatype/:id', component: __WEBPACK_IMPORTED_MODULE_12__components_visatypes_visatype___default.a, props: true }, { path: '/accounts', component: __WEBPACK_IMPORTED_MODULE_15__components_accounts_accounts___default.a }, { path: '/agreements', component: __WEBPACK_IMPORTED_MODULE_19__components_agreements_agreements___default.a }, { path: '/invoices/:id', component: __WEBPACK_IMPORTED_MODULE_16__components_accounts_invoice___default.a }, { path: '/receipts/:id', component: __WEBPACK_IMPORTED_MODULE_17__components_accounts_receipt___default.a }, { path: '/matters', component: __WEBPACK_IMPORTED_MODULE_13__components_matters___default.a }, { path: '/matters/:matter_id', component: __WEBPACK_IMPORTED_MODULE_14__components_matter___default.a, props: true }, { path: '/pay', component: __WEBPACK_IMPORTED_MODULE_18__components_accounts_pay___default.a }, { path: '/userlist/:usertype', component: __WEBPACK_IMPORTED_MODULE_8__components_users_users___default.a, props: true }, { path: '/users/:id', component: __WEBPACK_IMPORTED_MODULE_7__components_users_user___default.a, props: true }, { path: '/newUser/:usertype', component: __WEBPACK_IMPORTED_MODULE_9__components_users_newUser___default.a, props: true }, { path: '/users/setpassword/:code', component: __WEBPACK_IMPORTED_MODULE_10__components_users_setPassword___default.a, props: true }, { path: '/vevo', component: __WEBPACK_IMPORTED_MODULE_21__components_vevo___default.a }, { path: '/docs/choosecategory/:to_editor/:matter_id', component: __WEBPACK_IMPORTED_MODULE_22__components_docs_chooseDocCategory___default.a, props: true }, { path: '/docs/choosetype/:to_editor/:matter_type/:matter_id', component: __WEBPACK_IMPORTED_MODULE_23__components_docs_chooseDocType___default.a, props: true }, { path: '/docs/edit/:new/:id', component: __WEBPACK_IMPORTED_MODULE_24__components_docs_edit_template___default.a, props: true }, { path: '/docs/make/:type_id/:matter_id', component: __WEBPACK_IMPORTED_MODULE_25__components_docs_makeDoc___default.a, props: true }, { path: '/clienthome', components: { client: __WEBPACK_IMPORTED_MODULE_3__components_clienthome___default.a } }, { path: '/profile', components: { default: __WEBPACK_IMPORTED_MODULE_20__components_users_profileWrapper___default.a, client: __WEBPACK_IMPORTED_MODULE_20__components_users_profileWrapper___default.a } }, { path: '/invoices', components: { client: __WEBPACK_IMPORTED_MODULE_6__components_accounts_clientInvoices___default.a } }, { path: '/documents', components: { client: __WEBPACK_IMPORTED_MODULE_5__components_documents_clientDocs___default.a } }, { path: '/client-matter/:index', components: { client: __WEBPACK_IMPORTED_MODULE_4__components_users_clientMatter___default.a } }]
}));

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(417)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(522),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





__webpack_require__(235);
__webpack_require__(234);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  },
  data: {
    validated: false,
    admin: false,
    showSidebar: screen.width > 599,
    user: null,
    pageTitle: '',
    client: {
      matters: [],
      answers: {},
      matter: null,
      ready: false
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/api/users/validated').then(function (res) {
      if (res.status === 200) {
        _this.validated = true;
        _this.user = res.data;
        _this.admin = parseInt(_this.user.level) < 5;
        if (!_this.admin) {
          _this.getClientMatters();
        }
      }
    }).catch(function (e) {
      return;
    });

    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].afterEach(function (to, from) {
      if (screen.width < 600) {
        _this.showSidebar = false;
      }
    });
  },
  methods: {
    getClientMatters: function getClientMatters() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/api/matters/clientmatters').then(function (res) {
        if (res.status === 200) {
          if (res.data) {
            _this2.client.matters = res.data;
            _this2.setupAnswers();
          }
        }
      }).catch(function (e) {
        return;
      });
    },
    setupAnswers: function setupAnswers() {
      var answers = this.client.answers;
      this.client.matters.forEach(function (m) {
        if (!m.answers || !m.answers.length) return;
        m.answers.forEach(function (a) {
          if (answers[a.ref]) {
            answers[a.ref].push(a);
          } else {
            answers[a.ref] = [a];
          }
        });
      });
      this.client.ready = true;
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sidebar__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_login__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_users_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_users_setPassword__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_users_setPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_users_setPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_agreements_agreement__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_agreements_agreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_agreements_agreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_accounts_invoice__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_accounts_invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_accounts_invoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_accounts_receipt__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_accounts_receipt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_accounts_receipt__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'app-header': __WEBPACK_IMPORTED_MODULE_0__components_header___default.a,
    'sidebar': __WEBPACK_IMPORTED_MODULE_1__components_sidebar___default.a,
    'login': __WEBPACK_IMPORTED_MODULE_2__components_users_login___default.a,
    'setpassword': __WEBPACK_IMPORTED_MODULE_3__components_users_setPassword___default.a,
    'agreement': __WEBPACK_IMPORTED_MODULE_4__components_agreements_agreement___default.a,
    'invoice': __WEBPACK_IMPORTED_MODULE_5__components_accounts_invoice___default.a,
    'receipt': __WEBPACK_IMPORTED_MODULE_6__components_accounts_receipt___default.a
  },
  computed: {
    validated: function validated() {
      return this.$root.$data.validated;
    },
    isAdmin: function isAdmin() {
      return this.$root.$data.admin;
    },
    setpwd: function setpwd() {
      return window.location.href.includes('setpassword');
    },
    agreement: function agreement() {
      return (/agreements\/\w{24}/.test(window.location.href)
      );
    },
    invoice: function invoice() {
      return (/invoices\/\w{24}/.test(window.location.href)
      );
    },
    receipt: function receipt() {
      return (/receipts\/\w{24}/.test(window.location.href)
      );
    },
    clientReady: function clientReady() {
      return this.$root.$data.client.ready;
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_accounts_adminInvoices__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_accounts_adminInvoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_accounts_adminInvoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accounts_makeInvoice__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accounts_makeInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_accounts_makeInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accounts_pay__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accounts_pay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_accounts_pay__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'agreements',
  components: {
    'invoiceList': __WEBPACK_IMPORTED_MODULE_1__components_accounts_adminInvoices___default.a,
    'makeinvoice': __WEBPACK_IMPORTED_MODULE_2__components_accounts_makeInvoice___default.a,
    'pay': __WEBPACK_IMPORTED_MODULE_3__components_accounts_pay___default.a
  },
  data: function data() {
    return {
      tab: 1,
      invoices_all: [],
      invoices_overdue: []
    };
  },

  created: function created() {
    this.$root.$data.pageTitle = 'Accounts';
    this.getInvoices();
  },
  methods: {
    getInvoices: function getInvoices() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/invoices/all').then(function (res) {
        if (res.status === 200) {
          if (res.data) _this.invoices_all = res.data;
        }
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/invoices/overdue').then(function (res) {
        if (res.status === 200) {
          if (res.data) _this.invoices_overdue = res.data;
        }
      });
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_accounts_sendInvoiceModal__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_accounts_sendInvoiceModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_accounts_sendInvoiceModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_accounts_paymentModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_accounts_paymentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_accounts_paymentModal__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'adminInvoices',
  props: ['invoices', 'showOverdue'],
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_utils___default.a],
  components: {
    'sendModal': __WEBPACK_IMPORTED_MODULE_5__components_accounts_sendInvoiceModal___default.a,
    'payModal': __WEBPACK_IMPORTED_MODULE_6__components_accounts_paymentModal___default.a
  },
  data: function data() {
    return {
      sel_grp: -1,
      sel_inv: -1,
      showSendModal: false,
      showPayModal: false,
      invoiceToSend: null,
      invoiceToPay: null,
      sending: null,
      deleted_inv: null };
  },

  computed: {
    groups: function groups() {
      var m = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
      var period = 1000 * 60 * 60 * 24 * 2;
      var now = new Date();

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.invoices), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;

          if (this.showOverdue) {
            var then = new Date(i.date);
            if (now - then < period) {
              continue;
            }
          }

          if (m.has(i.user)) {
            m.get(i.user).push(i);
          } else {
            m.set(i.user, [i]);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(m.values());
    }
  },
  methods: {
    getTitle: function getTitle(inv) {
      return inv.business ? inv.business : inv.firstname + ' ' + inv.lastname;
    },
    payments: function payments(inv) {
      return __WEBPACK_IMPORTED_MODULE_4__components_utils___default.a.methods.payments(inv);
    },
    date: function date(d) {
      return new Date(d).toLocaleDateString();
    },
    hasPayment: function hasPayment(inv) {
      return new Date(inv.last_payment).getTime() > 0;
    },
    setGrp: function setGrp(n) {
      this.sel_grp = this.sel_grp === n ? -1 : n;
    },
    setInv: function setInv(n) {
      this.sel_inv = this.sel_inv === n ? -1 : n;
    },
    c2d: function c2d(c) {
      return (c / 100).toFixed(2);
    },
    viewPdf: function viewPdf(inv, disposition) {
      var _this = this;

      if (!inv.pdf) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/pdf/make/invoices/' + inv._id).then(function (res) {
          if (res.status === 200) {
            inv.pdf = res.data;
            _this.viewPdf(inv, disposition);
          }
        });
      } else {
        var filename = 'invoice_' + inv.ref + '.pdf';
        var link = '/api/pdf/get/' + disposition + '/' + inv.pdf + '/' + filename;
        window.open(link, '_blank');
      }
    },
    viewReceipt: function viewReceipt(inv) {
      window.open('/api/invoices/getreceipt/' + inv._id, '_blank');
    },
    sendInvoice: function sendInvoice(inv) {
      this.invoiceToSend = inv;
      this.showSendModal = true;
    },
    sendReceipt: function sendReceipt(inv) {
      var _this2 = this;

      this.sending = inv;
      inv.sendError = false;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/invoices/sendreceipt/' + inv._id).then(function (res) {
        if (res.status === 200) {
          _this2.sending = null;
        }
      }).catch(function (e) {
        _this2.sending = null;
        inv.sendError = true;
        console.log(e.response.data);
      });
    },
    togglePaid: function togglePaid(inv) {
      var form = new FormData();
      form.append('id', inv._id);
      form.append('paid', inv.paid);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/invoices/togglepaid/', form).then(function (res) {
        if (res.status === 200) {
          inv.paid = !inv.paid;
        }
      });
    },
    copyLink: function copyLink(inv) {
      var link = window.location.origin + '/#/invoices/' + inv._id;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(link);
      } else {
        var el = document.getElementById(inv._id);
        var textArea = document.createElement('textarea');
        textArea.value = link;
        el.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        el.removeChild(textArea);
      }
    },
    del: function del(inv) {
      var _this3 = this;

      this.deleted_inv = inv._id;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/invoices/delete/' + inv._id).then(function (res) {
        if (res.status === 200) {
          _this3.$emit('del');
        }
      });
    },
    openPaymentModal: function openPaymentModal(inv) {
      this.invoiceToPay = inv;
      this.showPayModal = true;
    },
    closePaymentModal: function closePaymentModal() {
      this.showPayModal = false;
      this.invoiceToPay = null;
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accounts_paymentModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accounts_paymentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_accounts_paymentModal__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'clientInvoices',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_utils___default.a],
  components: { payment: __WEBPACK_IMPORTED_MODULE_2__components_accounts_paymentModal___default.a },
  data: function data() {
    return {
      invoices: [],
      sel_inv: null,
      chargeAmount: 0,
      error: '',
      stripe: null,
      card: null,
      showPay: false,
      success: false,
      loading: false
    };
  },
  created: function created() {
    this.$root.$data.pageTitle = 'Invoices';
    this.getInvoices();
  },

  computed: {
    showPayBtn: function showPayBtn() {
      var inv = this.sel_inv;
      if (!inv || inv.paid) return false;
      if (inv.plan) {
        return inv.payments.length === 0;
      }
      return true;
    }
  },
  methods: {
    getInvoices: function getInvoices() {
      var _this = this;

      var _id = this.$root.$data.user._id;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/userinvoices/' + _id).then(function (res) {
        if (res.status === 200) {
          _this.invoices = res.data;
        }
      });
    },
    date: function date(d) {
      return new Date(d).toLocaleDateString();
    },
    setInv: function setInv(inv) {
      this.sel_inv = this.sel_inv === inv ? null : inv;
    },
    c2d: function c2d(c) {
      return (c / 100).toFixed(2);
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accounts_paymentModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accounts_paymentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_accounts_paymentModal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'invoice',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_utils___default.a],
  components: { payment: __WEBPACK_IMPORTED_MODULE_2__components_accounts_paymentModal___default.a },
  data: function data() {
    return {
      inv: null,
      showPay: false,
      url: window.location.href
    };
  },
  created: function created() {
    this.getInvoice();
  },

  computed: {
    showPayBtn: function showPayBtn() {
      var inv = this.inv;
      if (!inv || inv.paid) return false;
      if (inv.plan) {
        return inv.payments.length === 0;
      }
      return true;
    },
    due: function due() {
      var period = 1000 * 60 * 60 * 24 * 14;
      var d = new Date(this.inv.date);
      d.setTime(d.getTime() + period);
      return d.toLocaleDateString('en-AU');
    },
    brand: function brand() {
      return this.inv.brand || 'pl';
    }
  },
  methods: {
    getInvoice: function getInvoice() {
      var _this = this;

      var id = /\w{24}/.exec(window.location.toString());
      if (!id) return;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/invoices/one/' + id[0]).then(function (res) {
        if (res.status === 200) {
          _this.inv = res.data;
        }
      }).catch(function (e) {
        console.log(e.response.data);
      });
    },
    date: function date(d) {
      return new Date(d).toLocaleDateString('en-AU');
    },
    c2d: function c2d(c) {
      return (c / 100).toFixed(2);
    },
    print: function print() {
      window.print();
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accounts_sendInvoiceModal__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accounts_sendInvoiceModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_accounts_sendInvoiceModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_users_searchClients__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_users_searchClients___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_users_searchClients__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'makeInvoice',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_utils___default.a],
  props: ['invoices'],
  components: {
    'sendModal': __WEBPACK_IMPORTED_MODULE_3__components_accounts_sendInvoiceModal___default.a,
    'searchClients': __WEBPACK_IMPORTED_MODULE_4__components_users_searchClients___default.a
  },
  data: function data() {
    return {
      user: null,
      isLoading: false,
      success: false,
      errormsg: null,
      visatypes: [],
      instant_payment: false,
      no_gst: false,
      othermodal: false,
      showSendModal: false,
      newInvoice: null,
      newDesc: '',
      plan: false,
      plan_initial: 0,
      plan_monthly: 0,
      invoice: {
        matter_desc: '',
        items: [],
        initial: 0,
        monthly: 0
      },
      newItem: {
        description: '',
        surcharge: false,
        cost: 0
      },
      descriptions: __WEBPACK_IMPORTED_MODULE_2__components_utils___default.a.invoiceItems()
    };
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/allvisatypes').then(function (res) {
      if (res.status === 200) {
        _this.visatypes = res.data;
      }
    });
  },
  computed: {
    totals: function totals() {
      var gst = 0;
      var total = 0;
      var surcharge = 0;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.invoice.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;

          total += i.cost;
          if (i.surcharge) {
            surcharge += i.cost;
          } else if (!this.no_gst && i.cost > 0) {
            gst += i.cost;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      gst = parseInt(gst * 0.1);
      surcharge = parseInt(surcharge * 0.014);
      total = parseInt(total + surcharge + gst);

      return [gst, surcharge, total];
    }
  },
  watch: {
    plan: function plan() {
      if (this.plan) this.instant_payment = false;
    },
    instant_payment: function instant_payment() {
      if (this.instant_payment) this.plan = false;
    }
  },
  methods: {
    selectClient: function selectClient(user) {
      this.user = user;
    },
    reset: function reset() {
      this.invoice = {
        matter_desc: '',
        items: [],
        initial: 0,
        monthly: 0
      };
      this.success = false;
      this.newInvoice = null;
      this.showSendModal = false;
      this.errormsg = null;
    },
    c2d: function c2d(c) {
      return (c / 100).toFixed(2);
    },
    addItem: function addItem() {
      if (this.newItem.description.trim() === '') {
        return;
      }
      this.newItem.cost *= 100;
      this.invoice.items.push(this.newItem);
      this.newItem = {
        description: '',
        surcharge: false,
        cost: 0
      };
    },
    selItem: function selItem() {
      if (this.newItem.description === 'Other') {
        this.othermodal = true;
      }
    },
    delItem: function delItem(i) {
      this.invoice.items.splice(i, 1);
    },
    addDesc: function addDesc() {
      this.othermodal = false;
      this.newDesc = this.newDesc.trim();
      if (this.newDesc === '') return;
      this.descriptions.push(this.newDesc);
      this.newItem.description = this.newDesc;
      this.newDesc = '';
    },
    make: function make() {
      var _this2 = this;

      this.errormsg = null;

      if (this.invoice.items.length === 0) {
        this.errormsg = 'Invoice has no items';
        return;
      }

      this.isLoading = true;

      var totals = this.totals;
      this.invoice.gst = totals[0];
      this.invoice.surcharge = totals[1];
      this.invoice.total = totals[2];
      this.invoice.outstanding = totals[2];
      if (this.plan) {
        this.invoice.initial = this.plan_initial * 100;
        this.invoice.monthly = this.plan_monthly * 100;
      }

      var u = this.user;
      var p = u.profile;

      if (p.corporate) {
        var bname = p.business.toUpperCase().replace(' &', '').split(' ');
        if (bname.length > 1) {
          this.invoice.ref = bname[0][0] + bname[1][0];
        } else {
          this.invoice.ref = bname[0][0] + (bname[0][1] || '_');
        }
      } else {
        this.invoice.ref = p.firstname[0] + (p.lastname[0] || '_');
      }

      this.invoice.user = u._id;
      this.invoice.firstname = p.firstname;
      this.invoice.lastname = p.lastname;
      this.invoice.business = p.corporate ? p.business : null;
      this.invoice.brand = p.brand || 'pl';
      this.invoice.date = new Date();
      this.invoice.plan = this.plan;
      this.invoice.instant_payment = this.instant_payment;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/invoices/new', this.invoice).then(function (res) {
        if (res.status === 200) {
          _this2.$emit('new');
          _this2.isLoading = false;
          _this2.success = true;
          _this2.newInvoice = res.data;
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_utils__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pay',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_utils___default.a],
  data: function data() {
    return {
      stripeKey: null,
      stripe: null,
      card: null,
      amount: null,
      name: '',
      email: '',
      error: '',
      success: false,
      loading: false
    };
  },

  created: function created() {
    this.$root.$data.pageTitle = 'Payment';
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/stripepk').then(function (res) {
      if (res.status === 200) {
        _this.stripeKey = res.data;
        _this.mountStripe();
      }
    });
  },
  methods: {
    mountStripe: function mountStripe() {
      var _this2 = this;

      var stripe = window.Stripe(this.stripeKey);
      var elements = stripe.elements();
      var options = {
        base: 'form-input',
        hidePostalCode: true,
        style: {
          base: {
            color: '#222222',
            fontFamily: '"Open Sans", sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '13px'
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      };
      var card = elements.create('card', options);

      card.mount('#card-element');
      card.addEventListener('change', function (_ref) {
        var error = _ref.error;

        _this2.error = error ? error.message : '';
      });

      this.stripe = stripe;
      this.card = card;
    },
    submit: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this3 = this;

        var _ref3, token, error;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.loading || this.amount <= 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                this.success = false;
                this.loading = true;
                _context.next = 6;
                return this.stripe.createToken(this.card);

              case 6:
                _ref3 = _context.sent;
                token = _ref3.token;
                error = _ref3.error;


                if (error) {
                  this.error = error.message;
                  this.loading = false;
                } else {
                  __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/charge', {
                    token: token.id,
                    amount: parseInt(this.amount * 100),
                    name: this.name,
                    email: this.email
                  }).then(function (res) {
                    _this3.loading = false;
                    if (res.status === 200) {
                      _this3.success = true;
                      _this3.card.clear();
                      _this3.amount = null;
                      _this3.error = '';
                      _this3.name = '';
                      _this3.email = '';
                      __WEBPACK_IMPORTED_MODULE_3__components_utils___default.a.methods.delay(5000, function () {
                        _this3.success = false;
                      });
                    }
                  }).catch(function (e) {
                    _this3.loading = false;
                    _this3.error = e.response.data.message;
                  });
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submit() {
        return _ref2.apply(this, arguments);
      }

      return submit;
    }()
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'paymentModal',
  props: ['invoice', 'active'],
  data: function data() {
    return {
      cardError: '',
      paymentError: '',
      stripeKey: null,
      stripe: null,
      card: null,
      showform: true,
      success: false,
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/stripepk').then(function (res) {
      if (res.status === 200) {
        _this.stripeKey = res.data;
        _this.mountStripe();
      }
    });
  },

  computed: {
    amount: function amount() {
      if (!this.invoice) return null;
      var inv = this.invoice;
      return inv.plan ? inv.initial : inv.total;
    }
  },
  methods: {
    mountStripe: function mountStripe() {
      var _this2 = this;

      var stripe = window.Stripe(this.stripeKey);
      var elements = stripe.elements();
      var options = {
        base: 'form-input',
        hidePostalCode: true
      };
      var card = elements.create('card', options);

      card.mount('#card-element');
      card.addEventListener('change', function (_ref) {
        var error = _ref.error;

        _this2.cardError = error ? error.message : '';
      });

      this.stripe = stripe;
      this.card = card;
    },
    hide: function hide() {
      this.$emit('hide');
    },
    c2d: function c2d(c) {
      return (c / 100).toFixed(2);
    },
    stripeFee: function stripeFee(total) {
      var fPercent = 0.0175;
      var fFixed = 30;
      return (total + fFixed) / (1 - fPercent) - total;
    },

    submit: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this3 = this;

        var btn, _ref3, token, error;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.loading || !this.amount)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                btn = document.getElementById('paybtn');

                btn.disabled = true;
                this.loading = true;
                this.success = false;

                _context.next = 8;
                return this.stripe.createToken(this.card);

              case 8:
                _ref3 = _context.sent;
                token = _ref3.token;
                error = _ref3.error;


                if (error) {
                  this.cardError = error.message;
                  this.loading = false;
                  btn.disabled = false;
                } else {
                  __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/invoices/charge', {
                    token: token.id,
                    user: this.invoice.user,
                    invoice: this.invoice._id,
                    desc: this.invoice.ref,
                    amount: this.amount
                  }).then(function (res) {
                    _this3.card.clear();
                    _this3.loading = false;
                    btn.disabled = false;
                    if (res.status === 200) {
                      _this3.paymentError = '';
                      _this3.success = true;
                      _this3.showform = false;
                      _this3.$emit('payment');
                    }
                  }).catch(function (e) {
                    _this3.paymentError = e.response.data.message;
                    _this3.card.clear();
                    _this3.loading = false;
                    btn.disabled = false;
                  });
                }

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submit() {
        return _ref2.apply(this, arguments);
      }

      return submit;
    }()
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'receipt',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_utils___default.a],
  data: function data() {
    return {
      inv: null,
      showPay: false
    };
  },
  created: function created() {
    this.getInvoice();
  },

  computed: {
    brand: function brand() {
      return this.inv.brand || 'pl';
    }
  },
  methods: {
    getInvoice: function getInvoice() {
      var _this = this;

      var id = /\w{24}/.exec(window.location.toString());
      if (!id) return;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/invoices/one/' + id[0]).then(function (res) {
        if (res.status === 200) {
          _this.inv = res.data;
        }
      }).catch(function (e) {
        console.log(e.response.data);
      });
    },
    date: function date(d) {
      return new Date(d).toLocaleDateString('en-AU');
    },
    paymentDate: function paymentDate(inv) {
      if (!inv.payments || inv.payments.length < 1) return '';
      return this.date(inv.payments[inv.payments.length - 1].time);
    },
    c2d: function c2d(c) {
      return (c / 100).toFixed(2);
    },
    print: function print() {
      window.print();
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_core_css__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_bubble_css__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_bubble_css__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sendInvoiceModal',
  props: ['show', 'invoice'],
  components: { quillEditor: __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__["quillEditor"] },
  data: function data() {
    return {
      sending: false,
      sendError: false,
      message: '',
      editorOptions: {
        theme: 'bubble'
      }
    };
  },

  watch: {
    invoice: function invoice() {
      this.updateMessage();
    }
  },
  methods: {
    updateMessage: function updateMessage() {
      var inv = this.invoice;
      if (!inv) return;
      var link = [window.location.origin, '/#/invoices/', inv._id].join('');
      var brand = null;

      if (inv.brand && inv.brand === 'ie') {
        brand = 'Immigration Experts';
      } else {
        brand = 'PocketLegal';
      }

      this.message = ['<p>Hi ', inv.firstname, ',</p>', '<p>We have prepared an invoice for you, which you will find attached to this email.</p>', '<p>You can pay online via the link below.</p>', '<p><a href=\'', link, '\' target=\'_blank\'>Online payment</a></p>', '<p>Regards,<br>', brand, ' Accounts</p>'].join('');
    },
    close: function close() {
      this.$emit('close');
    },
    send: function send() {
      var _this = this;

      this.sending = true;
      this.sendError = false;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/invoices/send', {
        invoiceId: this.invoice._id,
        message: this.message
      }).then(function (res) {
        if (res.status === 200) {
          _this.sending = false;
          _this.invoice.sent = true;
          _this.$emit('done');
        }
      }).catch(function (e) {
        _this.sending = false;
        _this.sendError = true;
        console.log(e.response.data);
      });
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_adminHome_calendar__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_adminHome_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_adminHome_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_adminHome_notifications__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_adminHome_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_adminHome_notifications__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'adminHome',
  components: {
    calendar: __WEBPACK_IMPORTED_MODULE_0__components_adminHome_calendar___default.a,
    notifications: __WEBPACK_IMPORTED_MODULE_1__components_adminHome_notifications___default.a
  },
  created: function created() {
    this.$root.$data.pageTitle = '';
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fullcalendar_core__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fullcalendar_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fullcalendar_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fullcalendar_daygrid__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fullcalendar_daygrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fullcalendar_daygrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fullcalendar_list__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fullcalendar_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fullcalendar_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fullcalendar_moment__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fullcalendar_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fullcalendar_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fullcalendar_core_main_css__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fullcalendar_core_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fullcalendar_core_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fullcalendar_daygrid_main_css__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fullcalendar_daygrid_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fullcalendar_daygrid_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fullcalendar_list_main_css__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fullcalendar_list_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__fullcalendar_list_main_css__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'calendar',
  mixins: ['utils'],
  data: function data() {
    return {
      calendar: null,

      view: null,
      showEventModal: false,
      showNewEventModal: false,
      chosenDay: null,
      chosenEvent: null,
      dblClickWaiting: false,
      saving: false,
      loadingEvents: true,
      newEvent: null,
      monthView: true,

      hovering: false,
      hoverTitle: '',
      hoverDetails: '',
      tempEvent: {
        id: '',
        title: '',
        allDay: true,
        startHour: 0,
        startMin: 0,
        endHour: 0,
        endMin: 0,
        extendedProps: {
          details: ''
        }
      },
      hours: {
        0: '00',
        1: '01',
        2: '02',
        3: '03',
        4: '04',
        5: '05',
        6: '06',
        7: '07',
        8: '08',
        9: '09',
        10: '10',
        11: '11',
        12: '12',
        13: '13',
        14: '14',
        15: '15',
        16: '16',
        17: '17',
        18: '18',
        19: '19',
        20: '20',
        21: '21',
        22: '22',
        23: '23'
      },
      minutes: {
        0: '00',
        5: '05',
        10: '10',
        15: '15',
        20: '20',
        25: '25',
        30: '30',
        35: '35',
        40: '40',
        45: '45',
        50: '50',
        55: '55'
      }
    };
  },
  created: function created() {
    var _this = this;

    this.resetNewEvent();
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/events/user').then(function (res) {
      if (res.status === 200) {
        _this.loadingEvents = false;
        if (res.data && _this.calendar) {
          _this.calendar.batchRendering(function () {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var e = _step.value;

                _this.calendar.addEvent({
                  id: e._id,
                  allDay: e.allDay,
                  start: new Date(e.start),
                  end: new Date(e.end),
                  title: e.title,
                  extendedProps: {
                    user: e.user,
                    matter: e.matter,
                    details: e.details,
                    hasOwner: e.hasOwner
                  }
                });
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          });
        }
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    var el = document.getElementById('calendar');

    var cal = new __WEBPACK_IMPORTED_MODULE_2__fullcalendar_core__["Calendar"](el, {
      plugins: [__WEBPACK_IMPORTED_MODULE_3__fullcalendar_daygrid___default.a, __WEBPACK_IMPORTED_MODULE_4__fullcalendar_list___default.a, __WEBPACK_IMPORTED_MODULE_5__fullcalendar_moment___default.a],
      selectable: true,
      editable: true,
      header: false,
      timezone: 'UTC',

      eventBackgroundColor: '#D04881',
      eventBorderColor: '#D04881',
      eventColor: 'blue',
      aspectRatio: screen.width < 600 ? 1.02 : 1.2,
      dayClick: function dayClick(d) {
        _this2.dayClick(d);
      },
      eventClick: function eventClick(e) {
        _this2.eventClick(e);
      },
      eventDrop: function eventDrop(e) {
        _this2.eventDrop(e);
      },
      eventMouseover: function eventMouseover(e, jsEvent) {
        _this2.eventMouseover(e, jsEvent);
      },
      eventMouseout: function eventMouseout() {
        _this2.eventMouseout();
      }
    });
    cal.render();
    this.calendar = cal;

    this.view = cal.view;
    this.chosenDay = cal.getDate();
  },

  methods: {
    today: function today() {
      this.calendar.today();
      this.chosenDay = this.calendar.getDate();
    },
    prev: function prev() {
      this.calendar.prev();
    },
    next: function next() {
      this.calendar.next();
    },
    changeView: function changeView() {
      this.monthView = !this.monthView;
      if (this.monthView) {
        this.calendar.changeView('dayGridMonth');
      } else {
        this.calendar.changeView('listWeek');
      }
    },
    dayClick: function dayClick(date) {
      var _this3 = this;

      if (this.dblClickWaiting && this.chosenDay._i === date._i) {
        this.openNewEventModal();
      } else {
        this.chosenDay = date;
        this.dblClickWaiting = true;
        __WEBPACK_IMPORTED_MODULE_6__components_utils___default.a.methods.delay(500, function () {
          _this3.dblClickWaiting = false;
        });
      }
    },
    eventClick: function eventClick(e) {
      this.chosenEvent = e.event;
      this.tempEvent = {
        id: e.event.id,
        title: e.event.title,
        allDay: e.event.allDay,
        startHour: e.event.start.getHours(),
        startMin: e.event.start.getMinutes(),
        extendedProps: {
          details: e.event.extendedProps.details
        }
      };
      if (!e.event.end) {
        this.tempEvent.endHour = 23;
        this.tempEvent.endMin = 59;
      } else {
        this.tempEvent.endHour = e.event.end.getHours();
        this.tempEvent.endMin = e.event.end.getMinutes();
      }
      this.showEventModal = true;
    },
    eventDrop: function eventDrop(e) {
      this.saveEvent(e);
    },
    eventMouseover: function eventMouseover(e, jsEvent) {
      if (!e.details || !this.monthView) return;
      var el = document.getElementById('hoverDetails');
      el.style.left = jsEvent.clientX + 'px';
      el.style.top = jsEvent.clientY + 20 + 'px';
      this.hoverTitle = e.title;
      this.hoverDetails = e.details;
      this.hovering = true;
    },
    eventMouseout: function eventMouseout() {
      this.hovering = false;
    },
    openNewEventModal: function openNewEventModal() {
      this.saving = false;
      this.showNewEventModal = true;
    },
    makeEvent: function makeEvent() {
      var _this4 = this;

      this.newEvent = {
        user: null,
        start: null,
        startHour: 0,
        startMin: 0,
        end: null,
        endHour: 0,
        endMin: 0,
        title: '',
        details: '',
        allDay: true,
        hasOwner: false };

      var e = {
        allDay: this.newEvent.allDay,
        start: new Date(this.chosenDay),
        end: new Date(this.chosenDay),
        title: this.newEvent.title,
        extendedProps: {
          user: this.newEvent.user,
          matter: this.newEvent.matter,
          details: this.newEvent.details,
          hasOwner: this.newEvent.hasOwner
        }
      };

      e.user = this.$root.$data.user._id;

      if (e.allDay) {
        e.start = this.chosenDay;
      } else {
        this.chosenDay.hour(e.startHour);
        this.chosenDay.minute(e.startMin);
        e.start = this.chosenDay;
        this.chosenDay.hour(e.endHour);
        this.chosenDay.minute(e.endMin);
        e.end = this.chosenDay;
      }

      this.saving = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/events/new', e).then(function (res) {
        if (res.status === 200) {
          _this4.saving = false;
          e._id = res.data;
          _this4.calendar.addEvent(e);
          _this4.resetNewEvent();
          _this4.showNewEventModal = false;
        }
      }).catch(function (err) {
        _this4.saving = false;
        console.log(err);
      });
    },
    updateEvent: function updateEvent() {
      var e = this.chosenEvent;
      var t = this.tempEvent;
      if (t.allDay) {
        e.setAllDay(true);
      } else {
        e.setAllDay(false);
        var start = new Date(e.start);
        var end = new Date(e.end);
        start.setHours(t.startHour);
        start.setMinutes(e.startMin);
        end.setHours(t.endHour);
        end.setMinutes(e.endMin);
        e.setStart(start);
        e.setEnd(end);
      }
    },
    saveEvent: function saveEvent(e) {
      var _this5 = this;

      this.saving = true;

      var data = {
        _id: e.id,
        user: e.user,
        matter: e.matter,
        start: e.start,
        end: e.end,
        allDay: e.allDay,
        title: e.title,
        details: e.details
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/events/update', data).then(function (res) {
        if (res.status === 200) {
          _this5.calendar.removeEvents(e._id);
          _this5.calendar.renderEvent(data, true);
          _this5.saving = false;
          _this5.showEventModal = false;
        }
      }).catch(function (err) {
        _this5.saving = false;
        console.log(err);
      });
    },
    deleteEvent: function deleteEvent() {
      var _this6 = this;

      this.saving = true;
      var e = this.chosenEvent;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/events/delete/' + e._id).then(function (res) {
        if (res.status === 200) {
          _this6.calendar.removeEvents(e._id);
          _this6.saving = false;
          _this6.showEventModal = false;
        }
      }).catch(function (err) {
        _this6.saving = false;
        console.log(err);
      });
    },
    resetNewEvent: function resetNewEvent() {
      this.newEvent = {
        user: null,
        start: null,
        startHour: 0,
        startMin: 0,
        end: null,
        endHour: 0,
        endMin: 0,
        title: '',
        details: '',
        allDay: true,
        hasOwner: false };
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_users_avatar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_users_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_users_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_utils__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notifications',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_utils___default.a],
  components: {
    avatar: __WEBPACK_IMPORTED_MODULE_1__components_users_avatar___default.a
  },
  data: function data() {
    return {
      notifications: null
    };
  },
  created: function created() {
    this.getNotifications();
  },

  methods: {
    getNotifications: function getNotifications() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/notifications/user').then(function (res) {
        if (res.status === 200) {
          _this.notifications = res.data;
        }
      }).catch(function (e) {
        console.log(e.response.data);
      });
    },
    del: function del(n) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/notifications/delete/' + n._id).then(function (res) {
        if (res.status === 200) {
          _this2.$set(n, 'hidden', true);
          __WEBPACK_IMPORTED_MODULE_2__components_utils___default.a.methods.delay(500, function () {
            var index = _this2.notifications.indexOf(n);
            _this2.notifications.splice(index, 1);
          });
        }
      });
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_utils__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'agreement',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_utils___default.a],
  data: function data() {
    return {
      id: this.$route.params.id,
      agreement: null,
      loading: false
    };
  },

  computed: {
    total: function total() {
      var _this = this;

      return this.agreement.items.reduce(function (sum, i) {
        return sum + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_this.itemtotal(i));
      }, 0).toFixed(2);
    },
    forbidden: function forbidden() {
      if (this.$root.$data.admin) return false;
      if (!this.agreement.accepted) return false;
      var a = new Date(this.agreement.accepted_at).getTime();
      var b = new Date().getTime();
      if (b - a > 1000 * 60 * 60 * 24) {
        return true;
      } else {
        return false;
      }
    },
    brand: function brand() {
      return this.agreement.brand || 'pl';
    },
    brandname: function brandname() {
      if (!this.agreement.brand) {
        return __WEBPACK_IMPORTED_MODULE_2__components_utils___default.a.brands()['pl'];
      } else {
        return __WEBPACK_IMPORTED_MODULE_2__components_utils___default.a.brands()[this.agreement.brand];
      }
    }
  },
  created: function created() {
    this.getAgreement();
    this.$root.$data.pageTitle = '';
  },

  methods: {
    getAgreement: function getAgreement() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/agreements/get/' + this.id).then(function (res) {
        if (res.status === 200) {
          _this2.agreement = res.data;
        }
      }).catch(function (e) {
        console.log(e.response.data);
      });
    },
    c2d: function c2d(d) {
      return (d / 100).toFixed(2);
    },
    itemtotal: function itemtotal(item) {
      var total = item.cost * item.quantity;
      if (this.agreement.no_gst) {
        return this.c2d(total);
      } else {
        return this.c2d(total + total / 10);
      }
    },
    accept: function accept() {
      var _this3 = this;

      if (this.loading) return;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/agreements/accept/' + this.id).then(function (res) {
        if (res.status === 200) {
          _this3.getAgreement();
          _this3.loading = false;
        }
      }).catch(function (e) {
        _this3.loading = false;
        console.log(e.response.data);
      });
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_agreements_makeAgreement__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_agreements_makeAgreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_agreements_makeAgreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_agreements_sendAgreementModal__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_agreements_sendAgreementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_agreements_sendAgreementModal__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'agreements',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_utils___default.a],
  components: {
    'makeagreement': __WEBPACK_IMPORTED_MODULE_2__components_agreements_makeAgreement___default.a,
    'sendModal': __WEBPACK_IMPORTED_MODULE_3__components_agreements_sendAgreementModal___default.a
  },
  data: function data() {
    return {
      tab: 0,
      sending: null,
      makingPdf: null,
      agreements: [],
      showSendModal: false,
      toSend: null };
  },

  created: function created() {
    this.$root.$data.pageTitle = 'Cost Agreements';
    this.getAgreements();
  },
  computed: {
    filtered: function filtered() {
      if (this.tab === 1) {
        return this.agreements.filter(function (a) {
          return !a.archived;
        });
      }
      if (this.tab === 2) {
        return this.agreements.filter(function (a) {
          return a.archived;
        });
      }
    }
  },
  methods: {
    getAgreements: function getAgreements() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/agreements/all').then(function (res) {
        if (res.status === 200) {
          _this.agreements = res.data || [];
        }
      });
    },
    del: function del(a) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/agreements/delete/' + a._id).then(function (res) {
        if (res.status === 200) {
          var index = _this2.agreements.indexOf(a);
          _this2.agreements.splice(index, 1);
        }
      });
    },

    addAgreement: function addAgreement(agreement) {
      this.agreements.splice(this.agreements.length, 0, agreement);
      this.agreements.sort(function (a, b) {
        return b.name.localeCompare(a.name);
      });
    },
    openSendModal: function openSendModal(a) {
      this.toSend = a;
      this.showSendModal = true;
    },
    closeSendModal: function closeSendModal() {
      this.showSendModal = false;
    },
    archive: function archive(a) {
      var form = new FormData();
      form.append('id', a._id);
      form.append('flag', !a.archived);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/agreements/archive/', form).then(function (res) {
        if (res.status === 200) {
          a.archived = !a.archived;
        }
      });
    },
    makePdf: function makePdf(a) {
      var _this3 = this;

      this.makingPdf = a._id;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/pdf/make/agreements/' + a._id).then(function (res) {
        if (res.status === 200) {
          if (res.data) a.pdf = res.data;
          _this3.makingPdf = null;
        }
      }).catch(function (e) {
        console.log(e.response.data);
        _this3.makingPdf = null;
      });
    },
    viewPdf: function viewPdf(a, disposition) {
      var _this4 = this;

      if (!a.pdf) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/pdf/make/agreements/' + a._id).then(function (res) {
          if (res.status === 200 && res.data) {
            a.pdf = res.data;
            _this4.viewPdf(a, disposition);
          }
        });
      } else {
        var clientName = (a.corporate ? a.business : a.name).replace(/\s/g, '_').toLowerCase();
        var date = new Date(a.date).toLocaleDateString('en-AU', {
          year: 'numeric', month: '2-digit', day: '2-digit'
        }).replace(/\//g, '');
        var fname = ['costs_agreement', clientName, date, '.pdf'].join('_');
        var link = '/api/pdf/get/' + disposition + '/' + a.pdf + '/' + fname;
        window.open(link, '_blank');
      }
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_agreements_sendAgreementModal__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_agreements_sendAgreementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_agreements_sendAgreementModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_users_searchClients__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_users_searchClients___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_users_searchClients__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'makeAgreement',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_utils___default.a],
  components: {
    'sendModal': __WEBPACK_IMPORTED_MODULE_3__components_agreements_sendAgreementModal___default.a,
    'searchClients': __WEBPACK_IMPORTED_MODULE_4__components_users_searchClients___default.a
  },
  data: function data() {
    return {
      client: null,
      visatypes: [],
      isLoading: false,
      success: false,
      othermodal: false,
      showSendModal: false,
      otheritem: '',
      withInvoice: false,

      newAgreement: null,
      agreementErr: null,
      agreement: {
        brand: '',
        email: '',
        name: '',
        business: '',
        phone: '',
        address: '',
        visatype: '',
        no_gst: false,
        items: []
      },
      newItem: {
        description: '',
        cost: 0,
        quantity: 1
      },

      newInvoice: null,
      invoiceErr: null,
      plan: false,
      plan_initial: 0,
      plan_monthly: 0,
      otherInvModal: false,
      invoice: {
        matter_desc: '',
        items: [],
        initial: 0,
        monthly: 0
      },
      newInvItem: {
        description: '',
        surcharge: false,
        cost: 0
      },
      newInvDesc: '',
      descriptions: __WEBPACK_IMPORTED_MODULE_2__components_utils___default.a.invoiceItems()
    };
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/allvisatypes').then(function (res) {
      if (res.status === 200) {
        _this.visatypes = res.data;
      }
    });
  },
  computed: {
    total: function total() {
      return this.agreement.items.reduce(function (sum, i) {
        return sum + i.cost * i.quantity;
      }, 0);
    },
    totals: function totals() {
      var gst = 0;
      var total = 0;
      var surcharge = 0;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.invoice.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;

          total += i.cost;
          if (i.surcharge) {
            surcharge += i.cost;
          } else if (!this.no_gst && i.cost > 0) {
            gst += i.cost;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      gst = parseInt(gst * 0.1);
      surcharge = parseInt(surcharge * 0.014);
      total = parseInt(total + surcharge + gst);

      return [gst, surcharge, total];
    }
  },
  methods: {
    reset: function reset() {
      this.success = false;
      this.newAgreement = null;
      this.agreementErr = null;
      this.invoiceErr = null;
      this.agreement = {
        email: '',
        name: '',
        business: '',
        phone: '',
        address: '',
        visatype: '',
        no_gst: false,
        items: []
      };
      this.invoice = {
        matter_desc: '',
        items: [],
        initial: 0,
        monthly: 0
      };
      this.newInvItem = {
        description: '',
        surcharge: false,
        cost: 0
      };
    },
    selectClient: function selectClient(user) {
      this.client = user;
    },
    selDesc: function selDesc() {
      if (this.newItem.description === 'other') {
        this.othermodal = true;
      }
    },
    addItem: function addItem() {
      if (this.newItem.description.trim() === '') {
        return;
      }
      this.newItem.cost = this.newItem.cost.toFixed(2) * 100;
      this.agreement.items.push(this.newItem);
      this.newItem = {
        description: '',
        cost: 0,
        quantity: 1
      };
    },
    delItem: function delItem(i) {
      this.agreement.items.splice(i, 1);
    },

    c2d: function c2d(c) {
      return (c / 100).toFixed(2);
    },
    selItem: function selItem() {
      if (this.newInvItem.description === 'Other') {
        this.otherInvModal = true;
      }
    },
    delInvItem: function delInvItem(i) {
      this.invoice.items.splice(i, 1);
    },
    addInvDesc: function addInvDesc() {
      this.otherInvModal = false;
      this.newInvDesc = this.newInvDesc.trim();
      if (this.newInvDesc === '') return;
      this.descriptions.push(this.newInvDesc);
      this.newInvItem.description = this.newInvDesc;
      this.newInvDesc = '';
    },
    addInvItem: function addInvItem() {
      if (this.newInvItem.description.trim() === '') {
        return;
      }
      this.newInvItem.cost *= 100;
      this.invoice.items.push(this.newInvItem);
      this.newInvItem = {
        description: '',
        surcharge: false,
        cost: 0
      };
    },
    make: function make() {
      var _this2 = this;

      if (!this.client) return;
      this.agreementErr = null;
      this.invoiceErr = null;

      if (this.agreement.items.length === 0) {
        this.agreementErr = 'Agreement has no items';
        return;
      }

      var a = this.agreement;
      var u = this.client;
      var p = u.profile;
      a.user = u._id;
      a.email = u.email;
      a.name = p.firstname + ' ' + p.lastname;
      a.business = p.business;
      a.phone = p.phone;
      a.corporate = p.corporate;
      a.brand = p.brand || 'pl';

      if (!this.withInvoice) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/agreements/new', this.agreement).then(function (res) {
          if (res.status === 200) {
            _this2.newAgreement = res.data;
            _this2.isLoading = false;
            _this2.success = true;
            _this2.$emit('new', _this2.newAgreement);
            __WEBPACK_IMPORTED_MODULE_2__components_utils___default.a.methods.delay(3000, function () {
              _this2.success = false;
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
        return;
      }

      if (this.invoice.items.length === 0) {
        this.invoiceErr = 'Invoice has no items';
        return;
      }

      var totals = this.totals;
      this.invoice.matter_desc = this.agreement.visatype;
      this.invoice.gst = totals[0];
      this.invoice.surcharge = totals[1];
      this.invoice.total = totals[2];
      this.invoice.outstanding = totals[2];

      this.invoice.user = u._id;
      this.invoice.firstname = p.firstname;
      this.invoice.lastname = p.lastname;
      this.invoice.business = p.corporate ? p.business : null;
      this.invoice.brand = p.brand || 'pl';
      this.invoice.plan = this.plan;
      if (this.plan) {
        this.invoice.initial = this.plan_initial * 100;
        this.invoice.monthly = this.plan_monthly * 100;
      }

      if (p.corporate) {
        var bname = p.business.toUpperCase().replace(' &', '').split(' ');
        if (bname.length > 1) {
          this.invoice.ref = bname[0][0] + bname[1][0];
        } else {
          this.invoice.ref = bname[0][0] + (bname[0][1] || '_');
        }
      } else {
        this.invoice.ref = p.firstname[0] + (p.lastname[0] || '_');
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/agreements/newinv', {
        agreement: this.agreement,
        invoice: this.invoice
      }).then(function (res) {
        if (res.status === 200) {
          _this2.newAgreement = res.data.agreement;
          _this2.newInvoice = res.data.invoice;
          _this2.isLoading = false;
          _this2.success = true;
          _this2.$emit('new', _this2.newAgreement);
          __WEBPACK_IMPORTED_MODULE_2__components_utils___default.a.methods.delay(3000, function () {
            _this2.success = false;
          });
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_core_css__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_bubble_css__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_bubble_css__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sendAgreementModal',
  props: ['show', 'agreement', 'invoice'],
  components: { quillEditor: __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__["quillEditor"] },
  data: function data() {
    return {
      sending: false,
      sendError: false,
      message: '',
      attachments: [],
      editorOptions: {
        theme: 'bubble'
      },
      files: [{
        listname: 'Sponsorship Obligations',
        filename: 'Sponsorship Obligations',
        path: '482/sponsorship-obligations.pdf' }, {
        listname: 'TSS Visa Fact Sheet',
        filename: 'TSS Visa Fact Sheet',
        path: '482/TSS-Visa-Fact-Sheet.pdf'
      }]
    };
  },

  watch: {
    agreement: function agreement() {
      this.updateMessage();
    }
  },
  methods: {
    updateMessage: function updateMessage() {
      var a = this.agreement;
      if (!a) return;
      var name = a.name.split(' ')[0];
      var brand = null;

      if (a.brand && a.brand === 'ie') {
        brand = 'Immigration Experts';
      } else {
        brand = 'PocketLegal';
      }

      if (this.invoice) {
        var link = [window.location.origin, '/#/invoices/', this.invoice._id].join('');
        this.message = ['<p>Hi ', name, ',</p>', '<p>We have prepared a Costs Agreement for you, which you will find attached to this email.</p>', '<p>To have us commence work on your matter right away, please make the payment contained in the attached invoice.</p>', '<p>If preferred, you can <a href=\'', link, '\' target=\'_blank\'>click here to pay online</a></p>', '<p>Regards,<br>', brand, '</p>'].join('');
      } else {
        this.message = ['<p>Hi ', name, ',</p>', '<p>We have prepared and attached a costs agreement for you.</p>', '<p>Regards,<br>', brand, '</p>'].join('');
      }
    },
    close: function close() {
      this.$emit('close');
    },
    send: function send() {
      var _this = this;

      this.sending = true;
      this.sendError = false;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/agreements/send', {
        agreementId: this.agreement._id,
        message: this.message,
        sendInvoice: this.invoice !== null,
        files: this.attachments.map(function (i) {
          return _this.files[i];
        })
      }).then(function (res) {
        if (res.status === 200) {
          _this.sending = false;
          _this.agreement.sent = true;
          _this.close();
        }
      }).catch(function (e) {
        _this.sending = false;
        _this.sendError = true;
        console.log(e.response.data);
      });
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'clientHome',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$root.$data.pageTitle = '';
  },

  computed: {
    user: function user() {
      return this.$root.$data.user;
    },
    matterinfo: function matterinfo() {
      var m = this.$root.$data.client.matters;
      if (m.length) {
        return m[0].visatype.info;
      } else {
        return '';
      }
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bus_js__ = __webpack_require__(16);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chooseDocCategory',
  props: ['to_editor', 'matter_id'],
  data: function data() {
    return {
      matterTypes: []
    };
  },
  created: function created() {
    this.$root.$data.pageTitle = 'Document Categories';
    this.getTypes();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__components_bus_js__["a" /* bus */].$emit('in_editor', true);
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1__components_bus_js__["a" /* bus */].$emit('in_editor', false);
  },

  methods: {
    getTypes: function getTypes() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/types/matters/all').then(function (res) {
        if (res.status === 200) {
          _this.matterTypes = res.data;
        }
      });
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bus_js__ = __webpack_require__(16);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chooseDocType',
  props: {
    to_editor: String,
    matter_type: String,
    matter_id: String
  },
  data: function data() {
    return {
      types: [],
      editing: null,
      newType: {
        matter_type: this.matter_type,
        name: ''
      }
    };
  },
  created: function created() {
    this.getTypes();
    var title = 'Draft a document';
    if (this.to_editor === 'true') title = 'Edit a Document';
    this.$root.$data.pageTitle = title;
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__components_bus_js__["a" /* bus */].$emit('in_editor', true);
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1__components_bus_js__["a" /* bus */].$emit('in_editor', false);
  },

  methods: {
    getTypes: function getTypes() {
      var _this = this;

      if (!this.matter_type) return;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/types/docs/' + this.matter_type).then(function (res) {
        if (res.status === 200) {
          _this.types = res.data;
        }
      });
    },
    saveType: function saveType(t) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/types/docs/save', t).then(function (res) {
        if (res.status === 200) {
          _this2.getTypes();
          _this2.editing = null;
          _this2.newType.name = '';
        }
      }).catch(function (e) {
        console.log(e.response.data);
      });
    },
    delType: function delType(t) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/types/docs/delete', t).then(function (res) {
        if (res.status === 200) {
          _this3.getTypes();
          _this3.editing = null;
        }
      });
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_core_css__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_bubble_css__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_bubble_css__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dispatchModal',
  props: {
    show: Boolean,
    doc: Object,
    user: Object,
    fileId: String
  },
  components: { quillEditor: __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__["quillEditor"] },
  data: function data() {
    return {
      sending: false,
      sendError: false,
      success: false,
      format: 'pdf',
      message: '',
      editorOptions: {
        theme: 'bubble'
      }
    };
  },

  watch: {
    user: function user() {
      if (this.user) {
        this.message = ['Hi ', this.user.profile.firstname, ',<br/>', 'Please find attached your ', this.doc.name, '.'].join('');
      }
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
      this.success = false;
    },
    send: function send() {
      var _this = this;

      this.sending = true;
      this.sendError = false;
      this.success = false;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/docs/send', {
        fileId: this.fileId,
        format: this.format,
        doc_name: this.doc.name,
        firstname: this.user.profile.firstname,
        email: this.user.email,
        message: this.message
      }).then(function (res) {
        if (res.status === 200) {
          _this.sending = false;
          _this.success = true;
        }
      }).catch(function (e) {
        _this.sending = false;
        _this.sendError = true;
      });
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'docMakerSection',
  props: {
    section: Object
  },
  data: function data() {
    return {
      hidden: !this.section.display
    };
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_docs_templateSection__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_docs_templateSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_docs_templateSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bus_js__ = __webpack_require__(16);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'edit_template',
  props: {
    new: String,
    id: String },
  components: {
    templateSection: __WEBPACK_IMPORTED_MODULE_1__components_docs_templateSection___default.a
  },
  data: function data() {
    return {
      isNew: false,
      errMsg: '',
      template: {
        _id: null,
        name: 'New Template',
        matter_type: this.id,
        fileId: '',
        sections: []
      }
    };
  },

  created: function created() {
    var _this = this;

    this.$root.$data.pageTitle = 'Edit Template';
    this.isNew = this.new === 'true';
    if (!this.isNew) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/docs/template/' + this.id).then(function (res) {
        if (res.status === 200) {
          _this.template = res.data;
        }
      }).catch(function (e) {
        console.log(e.response.data);
      });
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__components_bus_js__["a" /* bus */].$emit('in_editor', true);
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_2__components_bus_js__["a" /* bus */].$emit('in_editor', false);
  },

  methods: {
    addSection: function addSection() {
      this.template.sections.push({
        name: 'section_name',
        pretty_name: 'Section name',
        display: false,
        fields: [{
          name: 'name',
          tag: '{{tag}}'
        }]
      });
    },
    removeSec: function removeSec(i) {
      this.template.sections.splice(i, 1);
    },
    moveSec: function moveSec(i, dir) {
      this.movePosition(this.template.sections, i, dir);
    },
    save: function save() {
      var _this2 = this;

      if (!this.template._id) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/docs/newtemplate', this.template).then(function (res) {
          if (res.status === 200) {
            console.log(res.data);
            _this2.template._id = res.data._id;
          }
        }).catch(function (e) {
          _this2.errMsg = e.response.data;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/docs/savetemplate', this.template).catch(function (e) {
          _this2.errMsg = e.response.data;
        });
      }
    },
    del: function del() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/docs/deletetemplate/' + this.template._id).then(function (res) {
        if (res.status === 200) {
          _this3.$router.go(-1);
        }
      });
    },
    movePosition: function movePosition(arr, i, dir) {
      if (dir === -1 && i === 0) return;
      if (dir === 1 && i >= arr.length - 1) return;
      var s = arr[i];
      var temp = arr[i + dir];
      if (dir === -1) {
        arr.splice(i - 1, 2, s, temp);
      } else {
        arr.splice(i, 2, temp, s);
      }
    },
    viewTemplate: function viewTemplate() {
      window.open('https://docs.google.com/document/d/' + this.template.fileId + '/edit', '_blank');
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_docs_docMakerSection__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_docs_docMakerSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_docs_docMakerSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_docs_dispatchModal__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_docs_dispatchModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_docs_dispatchModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bus_js__ = __webpack_require__(16);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'makeDoc',
  components: {
    docMakerSection: __WEBPACK_IMPORTED_MODULE_1__components_docs_docMakerSection___default.a,
    dispatchModal: __WEBPACK_IMPORTED_MODULE_2__components_docs_dispatchModal___default.a
  },
  props: {
    type_id: String,
    matter_id: String
  },
  data: function data() {
    return {
      template: null,
      doc: null,
      matter: null,
      user: null,
      making: false,
      exp_word: false,
      exp_pdf: false,
      newDocumentId: null,
      showResultsBox: false,
      showSendModal: false,
      formatter: new Intl.DateTimeFormat('en-AU', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        timeZone: 'Australia/Sydney'
      })
    };
  },

  created: function created() {
    this.getTemplate();
    this.getMatterAndUser();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3__components_bus_js__["a" /* bus */].$emit('in_editor', true);
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_3__components_bus_js__["a" /* bus */].$emit('in_editor', false);
  },

  methods: {
    getTemplate: function getTemplate() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/docs/template/' + this.type_id).then(function (res) {
        if (res.data) {
          _this.template = res.data;
          _this.loadTemplate(_this.template);
          _this.$root.$data.pageTitle = _this.template.name;
        }
      });
    },
    getMatterAndUser: function getMatterAndUser() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/matters/matterAndUser/' + this.matter_id).then(function (res) {
        if (res.data) {
          _this2.matter = res.data.matter;
          _this2.user = res.data.user;
        }
      });
    },
    loadTemplate: function loadTemplate(t) {
      var _this3 = this;

      this.doc = {
        templateId: t.fileId,
        name: t.name,
        sections: t.sections.map(function (s) {
          return _this3.convertSection(s);
        })
      };
    },
    convertSection: function convertSection(section) {
      return {
        name: section.name,
        pretty_name: section.pretty_name,
        display: section.display,
        fields: section.fields.map(function (f) {
          return {
            name: f.name,
            tag: f.tag,
            text: ''
          };
        })
      };
    },
    openDocLink: function openDocLink() {
      window.open('https://docs.google.com/document/d/' + this.newDocumentId + '/edit', '_blank');
    },
    openTemplateLink: function openTemplateLink() {
      window.open('https://docs.google.com/document/d/' + this.template.fileId + '/edit', '_blank');
    },
    getAffix: function getAffix() {
      var date = new Date();
      var parts = this.formatter.formatToParts(date);
      return ' - ' + parts[4].value + parts[0].value + parts[2].value;
    },
    exportDoc: function exportDoc(format) {
      var _this4 = this;

      var flagFn = function flagFn(str, bool) {
        if (str === 'word') _this4.exp_word = bool;
        if (str === 'pdf') _this4.exp_pdf = bool;
      };
      flagFn(format, true);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/docs/download', {
        name: this.doc.name + this.getAffix(),
        fileId: this.newDocumentId,
        folderId: this.matter.folders['working_docs'],
        format: format
      }).then(function (res) {
        if (res.status === 200) {
          flagFn(format, false);
        }
      });
    },
    make: function make() {
      var _this5 = this;

      if (!this.doc || !this.user || !this.matter) return;
      if (!this.user.drive_root) return;

      var removeSections = [];
      var tags = [];
      var subs = [];

      for (var i = 0; i < this.doc.sections.length; i++) {
        var s = this.doc.sections[i];
        if (!s.display) {
          removeSections.push(s.name);
          continue;
        }
        for (var j = 0; j < s.fields.length; j++) {
          var f = s.fields[j];
          if (!f.text) {
            continue;
          }
          tags.push('{{' + f.tag + '}}');
          subs.push(f.text);
        }
      }

      var date = new Date();
      tags.push('{{date_today}}');
      subs.push(this.formatter.format(date));

      this.making = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/docs/makenewdoc', {
        document_name: this.doc.name + this.getAffix(),
        fileId: this.doc.templateId,

        folderId: this.matter.folders['working_docs'],
        tags: tags,
        substitutions: subs,
        removeSections: removeSections
      }).then(function (res) {
        if (res.status === 200) {
          _this5.making = false;
          _this5.newDocumentId = res.data.documentId;
          _this5.showResultsBox = true;
        }
      }).catch(function (e) {
        _this5.making = false;
        console.log(e.response.data);
      });
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_docs_templateSection__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_docs_templateSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_docs_templateSection__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'templateSection',
  props: {
    section: Object
  },
  components: {
    templateSection: __WEBPACK_IMPORTED_MODULE_0__components_docs_templateSection___default.a
  },
  data: function data() {
    return {
      hidden: true
    };
  },

  methods: {
    removeField: function removeField(i) {
      this.section.fields.splice(i, 1);
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_documents_matterDocs__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_documents_matterDocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_documents_matterDocs__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'clientDocs',
  components: { matterdocs: __WEBPACK_IMPORTED_MODULE_0__components_documents_matterDocs___default.a },
  data: function data() {
    return {
      tab: 0
    };
  },
  created: function created() {
    this.$root.$data.pageTitle = 'Documents';
  },

  computed: {
    matters: function matters() {
      var matters = this.$root.$data.client.matters;
      if (!matters.length) return null;
      return matters;
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fileItem',
  props: ['file', 'matter'],
  data: function data() {
    return {
      error: '',
      saving: false
    };
  },

  methods: {
    del: function del() {
      var _this = this;

      this.saving = true;
      this.error = '';
      var form = new FormData();
      form.append('matter_id', this.matter._id);
      form.append('file_id', this.file.id);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/drive/delete', form).then(function (res) {
        if (res.status === 200) {
          _this.saving = false;
          _this.$emit('deleted');
        }
      }).catch(function (e) {
        _this.saving = false;
        _this.error = e.response.data;
      });
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_documents_fileItem__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_documents_fileItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_documents_fileItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_documents_upload__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_documents_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_documents_upload__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'matterDocs',
  components: {
    'upload': __WEBPACK_IMPORTED_MODULE_2__components_documents_upload___default.a,
    'file-item': __WEBPACK_IMPORTED_MODULE_1__components_documents_fileItem___default.a
  },
  props: ['matterdata'],
  data: function data() {
    return {
      files: {},
      matter: null,
      doctypes: null,
      saving: false,
      error: ''
    };
  },
  created: function created() {
    var _this = this;

    this.matter = this.matterdata.matter;

    var ans;
    var answers = this.$root.$data.client.answers;
    this.doctypes = this.matterdata.visatype.doctypes.filter(function (dt) {
      if (!dt.dependent) return true;
      if (!dt.depends.ref) return false;
      if (!answers[dt.depends.ref]) return false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(answers[dt.depends.ref]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          ans = _step.value;

          if (ans.ref === dt.depends.ref && ans.atxt === dt.depends.atxt) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    });

    this.doctypes.forEach(function (t) {
      _this.files[t.ref] = [];
    });

    this.matter.files.forEach(function (f) {
      if (_this.files.hasOwnProperty(f.docref)) {
        _this.files[f.docref].push(f);
      }
    });
  },

  methods: {
    addFile: function addFile(file) {
      if (!this.files[file.docref]) {
        this.files[file.docref] = [file];
      } else {
        this.files[file.docref].splice(this.files[file.docref].length, 0, file);
      }
      this.$forceUpdate();
    },
    delFile: function delFile(ref, index) {
      this.files[ref].splice(index, 1);
      this.$forceUpdate();
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'upload',
  props: ['matter', 'doctype'],
  data: function data() {
    return {
      error: '',
      saving: false
    };
  },

  methods: {
    upload: function upload(e) {
      var _this = this;

      if (!e.target.files.length) return;
      var file = e.target.files[0];

      this.saving = true;
      this.error = '';
      var form = new FormData();
      form.append('file', file, file.name);
      form.append('name', file.name);
      form.append('matter_id', this.matter._id);
      form.append('docref', this.doctype.ref);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/drive/upload', form).then(function (res) {
        if (res.status === 200) {
          var newFile = {
            id: res.data.id,
            name: res.data.name,
            docref: _this.doctype.ref,
            accepted: false
          };
          _this.saving = false;
          _this.$emit('new', newFile);
        }
      }).catch(function (e) {
        _this.saving = false;
        _this.error = e.response.data;
      });
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_users_avatar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_users_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_users_avatar__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  components: { avatar: __WEBPACK_IMPORTED_MODULE_1__components_users_avatar___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_utils___default.a],
  computed: {
    title: function title() {
      return this.$root.$data.pageTitle;
    },
    user: function user() {
      return this.$root.$data.user;
    }
  },
  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_0__components_utils___default.a.methods.logout(this);
    },
    toggleSidebar: function toggleSidebar() {
      this.$root.$data.showSidebar = !this.$root.$data.showSidebar;
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_questions_text__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_questions_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_questions_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_questions_bool__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_questions_bool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_questions_bool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_questions_select__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_questions_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_questions_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_questions_date__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_questions_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_questions_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_questions_number__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_questions_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_questions_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_questions_textarea__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_questions_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_questions_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_questions_country__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_questions_country___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_questions_country__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_questions_language__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_questions_language___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_questions_language__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_debounce__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_quill_editor__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_quill_dist_quill_core_css__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_quill_dist_quill_snow_css__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_quill_dist_quill_snow_css__);



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'matter',
  components: {
    textQ: __WEBPACK_IMPORTED_MODULE_3__components_questions_text___default.a,
    boolQ: __WEBPACK_IMPORTED_MODULE_4__components_questions_bool___default.a,
    selectQ: __WEBPACK_IMPORTED_MODULE_5__components_questions_select___default.a,
    dateQ: __WEBPACK_IMPORTED_MODULE_6__components_questions_date___default.a,
    numberQ: __WEBPACK_IMPORTED_MODULE_7__components_questions_number___default.a,
    textareaQ: __WEBPACK_IMPORTED_MODULE_8__components_questions_textarea___default.a,
    countryQ: __WEBPACK_IMPORTED_MODULE_9__components_questions_country___default.a,
    languageQ: __WEBPACK_IMPORTED_MODULE_10__components_questions_language___default.a,
    quillEditor: __WEBPACK_IMPORTED_MODULE_12_vue_quill_editor__["quillEditor"]
  },
  data: function data() {
    return {
      matterId: this.$route.params.matter_id,
      visatype: false,
      matter: null,
      answers: {},
      secKey: 'notes',
      subcounts: {},
      files: {},
      notes: '',
      editorOptions: {
        placeholder: '',
        theme: 'snow',
        modules: {
          toolbar: [['bold', 'italic', 'underline'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'color': [] }, { 'background': [] }], [{ 'font': [] }], [{ 'align': [] }], ['link', 'image'], ['clean']]
        }
      }
    };
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/matters/matterdata/' + this.matterId).then(function (res) {
      if (res.status === 200) {
        _this.matterData = res.data;
        _this.matter = res.data.matter;
        _this.notes = _this.matter.notes;
        _this.visatype = res.data.visatype;
        _this.matter.subcounts = _this.matter.subcounts || {};

        if (res.data.answers && res.data.answers.length) {
          res.data.answers.forEach(function (ans) {
            if (_this.answers[ans.ref]) {
              _this.answers[ans.ref].push(ans);
            } else {
              _this.answers[ans.ref] = [ans];
            }
          });
        }

        _this.visatype.sections.forEach(function (sec) {
          sec.subsections.forEach(function (sub) {
            _this.subcounts[sub.ref] = _this.matter.subcounts[sub.ref] || 1;
          });
        });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this.matter.files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var f = _step.value;

            if (_this.files.hasOwnProperty(f.docref)) {
              _this.files[f.docref].push(f);
            } else {
              _this.files[f.docref] = [f];
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }).catch(function (e) {
      console.log(e.response.data);
    });
  },
  computed: {
    section: function section() {
      if (typeof this.secKey === 'number') {
        return this.visatype.sections[this.secKey];
      } else {
        return false;
      }
    }
  },
  watch: {
    notes: __WEBPACK_IMPORTED_MODULE_11_lodash_debounce___default()(function () {
      this.saveNotes();
    }, 500)
  },
  methods: {
    visible: function visible(sub) {
      if (!sub.depends || !sub.depends.ref) return true;
      if (!this.answers[sub.depends.ref]) return false;
      var ans = this.answers[sub.depends.ref][0];
      if (!ans) return false;
      return ans.atxt === sub.depends.atxt;
    },

    addAns: function addAns(ans) {
      var array = this.answers[ans.ref];
      if (array) {
        array.splice(array.length, 0, ans);
      } else {
        this.answers[ans.ref] = [ans];
        this.answers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.answers);
      }
    },
    editAns: function editAns(ans) {
      this.answers[ans.ref][ans.num - 1] = ans;
      this.answers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.answers);
    },
    addSub: function addSub(sub) {
      this.subcounts[sub.ref] += 1;
      this.subcounts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.subcounts);
      this.matter.subcounts[sub.ref] = this.subcounts[sub.ref];
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/matters/update', this.matter).catch(function (e) {
        console.log(e.response.data);
      });
    },
    showSub: function showSub(sub) {
      if (!sub.depends || !sub.depends.ref) return true;
      if (!this.answers[sub.depends.ref]) return false;
      var ans = this.answers[sub.depends.ref][0];
      return ans && ans.atxt === sub.depends.atxt;
    },
    dateStr: function dateStr(d) {
      return new Date(d).toDateString();
    },
    saveMatter: function saveMatter() {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/matters/update', this.matter).catch(function (e) {
        console.log(e.response.data);
      });
    },
    saveNotes: function saveNotes() {
      if (this.notes === this.matter.notes) return;
      this.matter.notes = this.notes;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/matters/updateNotes/' + this.matter._id, { notes: this.notes }).catch(function (e) {
        console.log(e.response.data);
      });
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_table__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_searchClients__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_searchClients___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_users_searchClients__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'matters',
  components: {
    'matter-table': __WEBPACK_IMPORTED_MODULE_1__components_table___default.a,
    'searchClients': __WEBPACK_IMPORTED_MODULE_2__components_users_searchClients___default.a
  },
  data: function data() {
    return {
      matters: [],
      visatypes: [],
      selectedUser: null,
      selectedVisatype: '',
      filter: '',
      newMatterErr: '',
      showArchived: false,
      showModal: false,
      loading: false
    };
  },

  created: function created() {
    this.$root.$data.pageTitle = 'Matters';
    this.getMatters();
    this.getTypes();
  },
  watch: {
    showArchived: function showArchived() {
      this.$root.$data.pageTitle = this.showArchived ? 'Archived Matters' : 'Matters';
    }
  },
  methods: {
    selectClient: function selectClient(user) {
      this.selectedUser = user;
    },
    getMatters: function getMatters() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/matters/all').then(function (res) {
        if (res.status === 200) {
          _this.matters = res.data.map(function (m) {
            return [m._id, m.username, m.mattername, m.stage, new Date(m.due), m.owner, m.nextstep, new Date(m.deadline), m.deadlinenote, m.sponsor, m.dependents, m.archived, m.user_archived, m.visatype];
          });
        }
      });
    },
    getTypes: function getTypes() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/allvisatypes').then(function (res) {
        if (res.status === 200) {
          _this2.visatypes = res.data;
        }
      });
    },
    makeNewMatter: function makeNewMatter() {
      var _this3 = this;

      this.loading = true;
      this.newMatterErr = '';

      var week = 1000 * 60 * 60 * 24 * 7;
      var due = new Date();
      due.setTime(due.getTime() + week);

      var p = this.selectedUser.profile;
      var username = p.corporate ? p.business : p.firstname + ' ' + p.lastname;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/matters/new', {
        visatype: this.selectedVisatype._id,
        user: this.selectedUser._id,
        username: username,
        mattername: this.selectedVisatype.name,
        due: due
      }).then(function (res) {
        if (res.status === 200) {
          _this3.loading = false;
          _this3.getMatters();
          _this3.toggleModal();
        }
      }).catch(function (e) {
        _this3.loading = false;
        console.log(e);
        if (e.response) {
          _this3.newMatterErr = e.response.data;
        } else {
          _this3.toggleModal();
        }
      });
    },
    delMatter: function delMatter(key) {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/matters/delete/' + this.matters[key]._id).then(function (res) {
        vm.getMatters();
      }).catch(function (error) {
        console.log(error);
      });
    },
    toggleModal: function toggleModal() {
      this.showModal = !this.showModal;
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'clientMatters',
  props: ['user'],
  data: function data() {
    return {
      matters: []
    };
  },
  created: function created() {
    this.getMatters();
  },

  methods: {
    getMatters: function getMatters() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/matters/clientmatterlist/' + this.user._id).then(function (res) {
        if (res.status === 200) {
          _this.matters = res.data;
        }
      }).catch(function (e) {
        console.log(e.response.data);
      });
    },
    del: function del(matter) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/matters/delete/' + matter._id).then(function (res) {
        if (res.status === 200) {
          _this2.getMatters();
        }
      }).catch(function (e) {
        console.log(e.response.data);
      });
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'baseQ',
  props: ['matter', 'question', 'answers', 'num'],
  data: function data() {
    return {
      answer: {
        _id: null,
        matter: this.matter._id,
        ref: this.question.ref,
        num: this.num,
        atxt: ''
      },
      prevtxt: ''
    };
  },

  created: function created() {
    var arr = this.answers[this.question.ref];
    if (arr && arr.length >= this.num) {
      this.answer = arr[this.num - 1];
      this.prevtxt = this.answer.atxt;
    }
  },
  methods: {
    save: function save() {
      var vm = this;
      if (vm.prevtxt === vm.answer.atxt) return;
      if (!vm.answer._id) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/answers/new', vm.answer).then(function (res) {
          vm.answer = res.data;
          vm.prevtxt = res.data.atxt;
          vm.$emit('saved', res.data);
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/answers/update', vm.answer).then(function (res) {
          vm.prevtxt = res.data.atxt;
          vm.$emit('edited', res.data);
        }).catch(function (err) {
          console.log(err);
        });
      }
    },

    quickSave: function quickSave(val) {
      this.answer.atxt = val;
      this.save();
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_questions_base__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'boolQ',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default.a
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_questions_base__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'countryQ',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default.a,
  data: function data() {
    return {
      countries: {
        'Afghanistan': 'AFGH',
        'Albania': 'ALBA',
        'Algeria': 'ALGE',
        'American Samoa': 'ASAM',
        'Andorra': 'ANDO',
        'Angola': 'ANGA',
        'Anguilla': 'ANGU',
        'Antigua and Barbuda': 'ANBA',
        'Argentina': 'ARGE',
        'Armenia': 'ARME',
        'Aruba': 'ARUB',
        'Austria': 'AUST',
        'Australia': 'AUSTRALIA',
        'Azerbaijan': 'AZER',
        'Bahamas': 'BHMS',
        'Bahrain': 'BAHR',
        'Bangladesh': 'BDES',
        'Barbados': 'BARS',
        'Belarus': 'BYEL',
        'Belgium': 'BELM',
        'Belize': 'BELZ',
        'Benin': 'BENI',
        'Bermuda': 'BERM',
        'Bhutan': 'BHUT',
        'Bolivia': 'BOLI',
        'Bonaire, Saint Eustatius and Saba': 'BSES',
        'Bosnia & Herzegovina': 'BOHE',
        'Botswana': 'BOTS',
        'Bouvet Island': 'BVTI',
        'Brazil': 'BRAZ',
        'Brit Indian Ocn Terr': 'BIOT',
        'British Overseas Territories Citizen': 'BOTC',
        'Brunei Darussalam': 'BRUI',
        'Bulgaria': 'BULG',
        'Burkina Faso': 'UVOL',
        'Burundi': 'BURU',
        'Cabo Verde': 'CABV',
        'Cambodia': 'CAMB',
        'Cameroon': 'CREP',
        'Canada': 'CANA',
        'Cape Verde': 'CVER',
        'Cayman Islands': 'CAIS',
        'Central African Rep': 'CARE',
        'Chad': 'CHAD',
        'Chile': 'CHIL',
        'China': 'PRCH',
        'Christmas Island': 'CSIS',
        'Cocos (Keeling) Isl': 'COCO',
        'Colombia': 'COLA',
        'Comoros': 'COMO',
        'Congo': 'CONG',
        'Cook Islands': 'COOI',
        'Costa Rica': 'CRIC',
        'Cote D\'ivoire': 'ICOA',
        'Croatia': 'CROA',
        'Cuba': 'CUBA',
        'Curacao': 'CURA',
        'Cyprus': 'CYPR',
        'Czech Republic': 'CZER',
        'Denmark': 'DENM',
        'Djibouti': 'JIBU',
        'Dominica': 'DOMI',
        'Dominican Republic': 'DREP',
        'Ecuador': 'ECUA',
        'Egypt': 'EGYP',
        'El Salvador': 'ESAL',
        'England': 'ENGL',
        'Equatorial Guinea': 'EQGN',
        'Eritrea': 'ERIT',
        'Estonia': 'ESTO',
        'Ethiopia': 'ETHI',
        'Falkland Islands': 'FALI',
        'Faroe Islands': 'FAIS',
        'Fiji': 'FIJI',
        'Finland': 'FINL',
        'France': 'FRAE',
        'French Guiana': 'GUYE',
        'French Polynesia': 'FPOL',
        'Fyr Macedonia': 'MKDA',
        'Gabon': 'GABO',
        'Gambia': 'GAMB',
        'Gaza Strip': 'GAZA',
        'Georgia': 'GEOG',
        'Georgia/sandwich Isl': 'SGSI',
        'Germany': 'GERM',
        'Ghana': 'GHAN',
        'Gibraltar': 'GIBR',
        'Greece': 'GREE',
        'Greenland': 'GRED',
        'Grenada': 'GREN',
        'Guadeloupe': 'GUAE',
        'Guam': 'GUAM',
        'Guatemala': 'GUAT',
        'Guernsey': 'GUER',
        'Guinea': 'GUIN',
        'Guinea-bissau': 'GUBS',
        'Guyana': 'GUYN',
        'Haiti': 'HAIT',
        'Heard & Mcdonald Isl': 'HMDI',
        'Honduras': 'HOND',
        'Hong Kong Sar': 'HKON',
        'Hungary': 'HUNG',
        'Iceland': 'ICEL',
        'India': 'INDI',
        'Indonesia': 'INDO',
        'Iran': 'IRAN',
        'Iraq': 'IRAQ',
        'Ireland, Republic of': 'IREP',
        'Isle of Man': 'IMAN',
        'Israel': 'ISRA',
        'Italy': 'ITAL',
        'Jamaica': 'JAMA',
        'Japan': 'JAPA',
        'Jersey': 'JERS',
        'Jordan': 'JORD',
        'Kazakhstan': 'KAZA',
        'Kenya': 'KENY',
        'Kiribati': 'GIIS',
        'Korea, North': 'NKOR',
        'Korea, South': 'SKOR',
        'Kosovo': 'KOSO',
        'Kuwait': 'KUWA',
        'Kyrgyzstan': 'KIRG',
        'Lao Peoples Dem Rep': 'LAOS',
        'Latvia': 'LATV',
        'Lebanon': 'LEBA',
        'Lesotho': 'LESO',
        'Liberia': 'LIBE',
        'Libya': 'LIBA',
        'Liechtenstein': 'LIEC',
        'Lithuania': 'LITH',
        'Luxembourg': 'LUXE',
        'Macau Spcl Admin Rgn': 'MACS',
        'Madagascar': 'MADA',
        'Malawi': 'MALW',
        'Malaysia': 'MALS',
        'Maldives': 'MIS',
        'Mali': 'M',
        'Malta': 'MALT',
        'Marshall Islands': 'MAIS',
        'Martinique': 'MART',
        'Mauritania': 'MAUA',
        'Mauritius': 'MAUS',
        'Mayotte': 'MAYO',
        'Mexico': 'MEXI',
        'Micronesia': 'MICS',
        'Moldova': 'MOLD',
        'Monaco': 'MONA',
        'Mongolia': 'MONG',
        'Montenegro': 'MNTE',
        'Montserrat': 'MONT',
        'Morocco': 'MORO',
        'Mozambique': 'MOZA',
        'Myanmar': 'MYAN',
        'Namibia': 'NAMI',
        'Nauru': 'NAUR',
        'Nepal': 'NEPA',
        'Netherlands': 'NETH',
        'New Caledonia': 'NCAL',
        'New Guinea': 'NEWG',
        'New Hebrides': 'NHEB',
        'New Zealand': 'NZEA',
        'Nicaragua': 'NICA',
        'Niger': 'NIGR',
        'Nigeria': 'NGRA',
        'Niue': 'NIUE',
        'Norfolk Island': 'NOIS',
        'Northern Ireland': 'NOIR',
        'Northern Mariana Isl': 'NMAI',
        'Norway': 'NORW',
        'Oman': 'OMAN',
        'Pakistan': 'PKSN',
        'Palau': 'PALA',
        'Palestinian Authorty': 'PALE',
        'Panama': 'PANA',
        'Papua New Guinea': 'NGUI',
        'Paraguay': 'PARA',
        'Peru': 'PERU',
        'Philippines': 'PHIL',
        'Pitcairn': 'PIIS',
        'Poland': 'POLA',
        'Portugal': 'PORL',
        'Puerto Rico': 'PRIC',
        'Qatar': 'QATA',
        'Reunion': 'REIS',
        'Romania': 'ROUM',
        'Russian Federation': 'RFED',
        'Rwanda': 'RWAN',
        'Saint Barthelemy': 'STBA',
        'Saint Helena, Ascension and Tristan Da Cunha': 'SHTC',
        'Saint Lucia': 'STLU',
        'Saint Martin': 'STMA',
        'Samoa': 'SAMO',
        'San Marino': 'SMAR',
        'Sao Tome & Principe': 'STPR',
        'Saudi Arabia': 'SAAR',
        'Scotland': 'SCOT',
        'Senegal': 'SENE',
        'Serbia': 'SERB',
        'Seychelles': 'SEYC',
        'Sierra Leone': 'SLEO',
        'Singapore': 'SING',
        'Sint Maarten (Dutch Part)': 'SXMN',
        'Slovak Republic': 'SVKA',
        'Slovenia': 'SLOV',
        'Solomon Islands': 'SOLI',
        'Somalia': 'SOMA',
        'South Africa': 'SAFR',
        'South Sudan': 'SSDN',
        'Spain': 'SPAI',
        'Sri Lanka': 'SRIL',
        'St Helena': 'SHEL',
        'St Kitts and Nevis': 'SCKN',
        'St Pierre & Miquelon': 'STPM',
        'St Vincent/grenadine': 'STVG',
        'Sudan': 'SUDA',
        'Suriname': 'SURI',
        'Svalbard & Jan Mayen': 'SAJM',
        'Swaziland': 'SWAZ',
        'Sweden': 'SWED',
        'Switzerland': 'SWIT',
        'Syria': 'SYRI',
        'Taiwan': 'TAIW',
        'Tajikistan': 'TADZ',
        'Tanzania': 'TANZ',
        'Thailand': 'THAI',
        'Timor, East': 'ETIM',
        'Timor-leste': 'TILE',
        'Togo': 'TOGO',
        'Tokelau': 'TOKE',
        'Tonga': 'TONG',
        'Trinidad and Tobago': 'TRIN',
        'Tunisia': 'TUNI',
        'Turkey': 'TURY',
        'Turkmenistan': 'TURM',
        'Turks and Caicos Isl': 'TCIS',
        'Tuvalu': 'TUVU',
        'U.S. Minor Islands': 'USOI',
        'Uganda': 'UGAN',
        'Ukraine': 'UKRA',
        'United Arab Emirates': 'UAEM',
        'United Kingdom': 'UK',
        'United States': 'USA',
        'Uruguay': 'URUG',
        'Uzbekistan': 'UZBE',
        'Vanuatu': 'VANU',
        'Vatican City State': 'VCIT',
        'Venezuela': 'VENE',
        'Vietnam': 'VIET',
        'Virgin Islands (U.S)': 'VIIS',
        'Virgin Islnds (Brit)': 'VIUK',
        'Wales': 'WALE',
        'Wallis & Futuna Isl': 'WAFU',
        'West Bank': 'WBAN',
        'Yemen': 'YEME',
        'Yugoslavia': 'FRY',
        'Zaire': 'ZAIR',
        'Zambia': 'ZAMB',
        'Zimbabwe': 'ZIMB'
      }
    };
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_questions_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dateQ',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default.a,
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a
  },
  data: function data() {
    return {
      date: null,
      show: false
    };
  },

  created: function created() {
    if (this.answer.atxt) {
      this.date = new Date(this.answer.atxt);
    }
  },
  methods: {
    selected: function selected(date) {
      this.answer.atxt = date.toDateString();
      this.show = false;
      this.save();
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_questions_base__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'languageQ',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default.a
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_questions_base__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'numberQ',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default.a
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_questions_base__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'selectQ',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default.a
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_questions_base__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'textQ',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default.a
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_questions_base__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'textareaQ',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_questions_base___default.a
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bus_js__ = __webpack_require__(16);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_utils___default.a],
  data: function data() {
    return {
      inEditor: false };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__components_bus_js__["a" /* bus */].$on('in_editor', function (bool) {
      _this.inEditor = bool;
    });
  },

  computed: {
    active: function active() {
      return this.$root.$data.showSidebar;
    },
    isAdmin: function isAdmin() {
      return this.$root.$data.admin;
    },
    matters: function matters() {
      return this.$root.$data.client.matters.map(function (m) {
        return m.matter;
      });
    },
    agreement: function agreement() {
      return this.$root.$data.user.agreement;
    },
    brand: function brand() {
      return this.$root.$data.user.profile.brand || 'pl';
    }
  },
  methods: {
    setMatter: function setMatter(m) {
      this.$root.$data.client.matter = m;
    },
    viewAgreement: function viewAgreement() {
      var a = this.agreement;
      if (!a) return;
      if (a.pdf) {
        window.open('/api/pdf/get/' + a.pdf, '_blank');
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/pdf/make/agreements/' + a._id).then(function (res) {
          if (res.status === 200 && res.data) {
            a.pdf = res.data;
            window.open('/api/pdf/get/' + a.pdf, '_blank');
          }
        }).catch(function (e) {
          console.log(e.response.data);
        });
      }
    },
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_0__components_utils___default.a.methods.logout(this);
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_focus__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'matterTable',
  props: ['rows', 'filter', 'showArchived'],
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue_focus__["mixin"]],
  data: function data() {
    return {
      columns: ['_id', 'username', 'mattername', 'stage', 'due', 'owner', 'nextstep', 'deadline', 'deadlinenote', 'sponsor', 'dependents', 'archived', 'user_archived'],
      stages: ['Document Collection', 'Drafting Application', 'Client Application Review', 'Lodged', 'RFI', 'RFI Complete', 'Granted', 'Early', 'Finalised', 'Natural Justice', 'Paused', 'Refused', 'Withdrawn'],
      filterStr: '',
      colState: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      colClasses: ['hide', 'caret-down', 'caret-up'],
      s_cell: [0, 0],
      chosenDate: null,
      chosenRow: [],
      chosenRowIndex: 0,
      showDateModal: false,
      now: new Date().getTime()
    };
  },

  computed: {
    filtered: function filtered() {
      var _this = this;

      if (this.filterStr.trim().length === 0) {
        return this.rows.filter(function (row) {
          return (row[11] || row[12]) === _this.showArchived;
        });
      }
      var query = this.filterStr.toLowerCase();
      return this.rows.filter(function (row) {
        return (row[11] || row[12]) === _this.showArchived && row[1].toLowerCase().search(query) > -1 || row[2].toLowerCase().search(query) > -1 || row[5].toLowerCase().search(query) > -1;
      });
    }
  },
  watch: {
    filter: __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function (f) {
      this.filterStr = f;
    }, 300)
  },
  methods: {
    dateStr: function dateStr(d) {
      return d > 0 ? d.toLocaleDateString('en-AU') : null;
    },

    isSelected: function isSelected(row, col) {
      return this.s_cell[0] === row && this.s_cell[1] === col;
    },

    rowClass: function rowClass(row) {
      if (row[11] || row[12]) return null;
      if (row[7] > 0) {
        var delta = row[7].getTime() - this.now;
        if (delta < 1209600000) {
          if (delta < 0) {
            return 'blue';
          }
          return 'red';
        }
      }
      if (row[4] > 0) {
        var _delta = row[4].getTime() - this.now;
        if (_delta < 172800000) {
          if (_delta < 0) {
            return 'red';
          }
          return 'yellow';
        }
      }
    },
    toggleCol: function toggleCol(n) {
      var nextState = this.colState[n] === 2 ? 1 : this.colState[n] + 1;
      this.colState = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      this.colState.splice(n, 1, nextState);
      this.sortByCol(n);
    },
    sortByCol: function sortByCol(col) {
      switch (col) {
        case 1:
        case 2:
        case 5:
          this.rows.sort(function (a, b) {
            return b[col].localeCompare(a[col]);
          });
          break;
        default:
          this.rows.sort(function (a, b) {
            return b[col] - a[col];
          });
      }

      if (this.colState[col] === 2) {
        this.rows.reverse();
      }
    },
    openDate: function openDate(row, col) {
      this.s_cell = [row, col];
      this.chosenDate = this.filtered[row][col];
      this.showDateModal = true;
    },
    setDate: function setDate(d) {
      var _s_cell = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(this.s_cell, 2),
          row = _s_cell[0],
          col = _s_cell[1];

      this.filtered[row][col] = d;
      this.showDateModal = false;
      this.saveRow(this.filtered[row], false);
    },
    archive: function archive(row) {
      var idx = this.columns.indexOf('archived');
      row[idx] = !row[idx];
      this.filterStr += ' ';
      this.filterStr.trim();
      this.saveRow(row, false);
    },
    saveRow: function saveRow(row, setStage) {
      var _this2 = this;

      var update = {};
      this.columns.forEach(function (colname, i) {
        update[colname] = row[i];
      });
      if (setStage) update.stage_changed_at = new Date();
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/matters/updateTable', update).then(function (res) {
        if (res.status === 200) {
          _this2.s_cell = [0, 0];
        }
      }).catch(function (e) {
        console.log(e.response.data);
      });
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bus_js__ = __webpack_require__(16);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'avatar',
  props: ['user'],
  data: function data() {
    return {
      avatar: null,
      inits: '?'
    };
  },
  created: function created() {
    var _this = this;

    var p = this.user.profile;

    if (p.avatar) {
      this.load();
    }

    if (p.corporate) {
      var bname = p.business.toUpperCase().split(' ');
      if (bname.length > 1) {
        this.inits = bname[0][0] + bname[1][0];
      } else {
        this.inits = bname[0][0] + (bname[0][1] || '');
      }
    } else if (p.firstname && p.lastname) {
      this.inits = p.firstname[0] + p.lastname[0];
    }

    __WEBPACK_IMPORTED_MODULE_1__components_bus_js__["a" /* bus */].$on('new_avatar', function (userId, data) {
      if (_this.user._id === userId) {
        _this.avatar = data;
      }
    });
    __WEBPACK_IMPORTED_MODULE_1__components_bus_js__["a" /* bus */].$on('del_avatar', function (userId) {
      if (_this.user._id === userId) {
        _this.avatar = null;
      }
    });
  },

  methods: {
    load: function load() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/users/avatars/get/' + this.user.profile.avatar).then(function (res) {
        if (res.status === 200) {
          _this2.avatar = res.data.data;
        }
      }).catch(function (e) {
        console.log(e.response.data);
      });
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_questions_text__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_questions_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_questions_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_questions_bool__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_questions_bool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_questions_bool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_questions_select__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_questions_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_questions_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_questions_date__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_questions_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_questions_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_questions_number__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_questions_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_questions_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_questions_textarea__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_questions_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_questions_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_questions_country__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_questions_country___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_questions_country__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_questions_language__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_questions_language___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_questions_language__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'client-matter',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_utils___default.a],
  components: {
    textQ: __WEBPACK_IMPORTED_MODULE_3__components_questions_text___default.a,
    boolQ: __WEBPACK_IMPORTED_MODULE_4__components_questions_bool___default.a,
    selectQ: __WEBPACK_IMPORTED_MODULE_5__components_questions_select___default.a,
    dateQ: __WEBPACK_IMPORTED_MODULE_6__components_questions_date___default.a,
    numberQ: __WEBPACK_IMPORTED_MODULE_7__components_questions_number___default.a,
    textareaQ: __WEBPACK_IMPORTED_MODULE_8__components_questions_textarea___default.a,
    countryQ: __WEBPACK_IMPORTED_MODULE_9__components_questions_country___default.a,
    languageQ: __WEBPACK_IMPORTED_MODULE_10__components_questions_language___default.a
  },
  data: function data() {
    return {
      matter: null,
      visatype: null,
      answers: this.$root.$data.client.answers,
      secKey: 0,
      subcounts: null
    };
  },
  created: function created() {
    this.setup();
  },

  computed: {
    sections: function sections() {
      if (!this.visatype) return null;
      return this.visatype.sections.filter(function (sec) {
        return sec.subsections.some(function (sub) {
          return sub.for_client;
        });
      });
    },
    section: function section() {
      if (typeof this.secKey === 'number') {
        return this.sections[this.secKey];
      } else {
        return null;
      }
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.setup();
    }
  },
  methods: {
    setup: function setup() {
      var _this = this;

      this.matter = null;
      this.visatype = null;
      this.subcounts = {};
      this.secKey = 0;

      var index = this.$route.params.index || 0;
      var md = this.$root.$data.client.matters[index];
      this.matter = md.matter;
      this.visatype = md.visatype;

      this.$root.$data.pageTitle = md.matter.mattername;

      this.matter.subcounts = this.matter.subcounts || {};
      this.visatype.sections.forEach(function (sec) {
        sec.subsections.forEach(function (sub) {
          _this.subcounts[sub.ref] = _this.matter.subcounts[sub.ref] || 1;
        });
      });
    },

    showSub: function showSub(sub) {
      if (!sub.for_client) return false;
      if (!sub.depends || !sub.depends.ref) return true;
      if (!this.answers[sub.depends.ref]) return false;
      var ans = this.answers[sub.depends.ref][0];
      if (!ans) return false;
      return ans.atxt === sub.depends.atxt;
    },
    showQ: function showQ(q) {
      if (!q.depends || !q.depends.ref) return true;
      if (!this.answers[q.depends.ref]) return false;
      var ans = this.answers[q.depends.ref][0];
      if (!ans) return false;
      return ans.atxt === q.depends.atxt;
    },

    addAns: function addAns(ans) {
      var array = this.answers[ans.ref];
      if (array) {
        array.splice(array.length, 0, ans);
      } else {
        this.answers[ans.ref] = [ans];
        this.answers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.answers);
        __WEBPACK_IMPORTED_MODULE_2__components_utils___default.a.methods.checkMatter(this.visatype, this.matter, this.answers);
      }
    },
    editAns: function editAns(ans) {
      if (!this.answers[ans.ref]) {
        this.answers[ans.ref] = [ans];
      } else {
        this.answers[ans.ref][ans.num - 1] = ans;
      }
      this.answers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.answers);
    },
    addSub: function addSub(sub) {
      this.subcounts[sub.ref] += 1;
      this.subcounts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.subcounts);
      this.matter.subcounts[sub.ref] = this.subcounts[sub.ref];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/matters/update', this.matter);
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'clientvevo',
  props: ['user'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_utils___default.a],
  data: function data() {
    return {
      countries: __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.countries(),
      resultFields: __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.vevoFields(),
      okDOB: false,
      okPassport: false,
      okCountry: false,
      loading: false,
      results: null,
      message: null,
      errormsg: null,
      docType: '01',
      showCalMsg: false
    };
  },
  created: function created() {
    if (this.user.vevo) {
      this.results = this.user.vevo;
    }

    var p = this.user.profile;
    this.okDOB = /^\d{2}-\d{2}-\d{4}$/.test(p.dob);
    this.okPassport = p.passport.trim().length > 0;
    this.okCountry = this.countries.hasOwnProperty(p.country);
  },

  computed: {
    validProfile: function validProfile() {
      return this.okDOB && this.okPassport && this.okCountry;
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      if (this.loading) return;
      this.loading = true;
      this.showCalMsg = false;

      var p = this.user.profile;
      var params = new URLSearchParams();

      params.append('dyb_password', "C74zTIetr778B0rIAc5n");
      params.append('familyName', p.lastname);
      params.append('givenName', p.firstname);
      params.append('dob', p.dob);
      params.append('docType', this.docType);
      params.append('docNumber', p.passport);
      params.append('docCountry', this.countries[p.country]);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.dybURL() + params.toString()).then(function (res) {
        if (res.status === 200) {
          _this.loading = false;
          if (res.data.success) {
            res.data.date = new Date();
            res.data.expiry = new Date(res.data.visaExpDate);
            _this.results = res.data;
            _this.saveResults();
            _this.addToCalendar();
          } else if (res.data.message) {
            _this.message = res.data.message;
          }
        }
      }).catch(function (e) {
        _this.loading = false;
        _this.errormsg = e.response.data;
      });
    },
    saveResults: function saveResults() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/savevevo/' + this.user._id, this.results).catch(function (e) {
        console.log(e.response.data);
      });
    },
    addToCalendar: function addToCalendar() {
      var _this2 = this;

      if (!this.results.visaExpDate) return;
      var p = this.user.profile;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/events/new', {
        user: this.$root.$data.user._id,
        start: this.results.expiry,
        title: 'Visa expiry - ' + p.firstname + ' ' + p.lastname,
        details: this.results.visaType + ' ' + this.results.visaClass,
        allDay: true,
        hasOwner: false
      }).then(function (res) {
        if (res.status === 200) {
          _this2.showCalMsg = true;
        }
      }).catch(function (e) {
        console.log(e.response.data);
      });
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      verified: false,
      loading: false,
      forgot: false,
      email: '',
      password: '',
      error: '',
      msg: ''
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      this.msg = '';
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/login', {
        email: this.email,
        password: this.password
      }).then(function (res) {
        if (res.status === 200) {
          _this.loading = false;
          _this.error = '';
          _this.$root.$data.user = res.data;
          _this.$root.$data.validated = true;
          _this.$root.$data.admin = parseInt(res.data.level) < 5;

          if (!_this.$root.$data.admin) {
            _this.$root.getClientMatters();
          }
        }
      }).catch(function (e) {
        _this.error = e.response.data;
        _this.$root.$data.validated = false;
        _this.loading = false;
      });
    },
    reset: function reset() {
      var _this2 = this;

      var email = this.email.trim();
      if (!email) return;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/sendreset/' + email).then(function (res) {
        if (res.status === 200) {
          _this2.loading = false;
          _this2.forgot = false;
          _this2.error = '';
          _this2.msg = 'A password reset link has been sent to your email';
        }
      }).catch(function (e) {
        _this2.error = e.response.data;
        _this2.loading = false;
        _this2.msg = '';
      });
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newUser',
  props: ['usertype'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_utils___default.a],
  data: function data() {
    return {
      countries: __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.countries(),
      sources: __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.sources(),
      brands: __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.brands(),
      error: '',
      dob_d: '',
      dob_m: '',
      dob_y: '',
      success: false,
      newUser: {
        email: '',
        level: 6,
        profile: {
          corporate: false,
          brand: 'pl',
          firstname: '',
          lastname: '',
          dob: '',
          business: '',
          address1: '',
          address2: '',
          suburb: '',
          postcode: '',
          state: '',
          country: '',
          passport: '',
          phone: '',
          source: '',
          details: ''
        }
      }
    };
  },
  created: function created() {
    this.$root.$data.pageTitle = 'New ' + this.usertype;
    if (this.usertype === 'admin') {
      this.newUser.level = 4;
    }
  },

  computed: {
    newClient: function newClient() {
      return this.usertype === 'client';
    }
  },
  methods: {
    make: function make() {
      var _this = this;

      this.newUser.profile.dob = [this.dob_d, this.dob_m, this.dob_y].join('-');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/new', this.newUser).then(function (res) {
        if (res.status === 200) {
          _this.success = true;
          _this.error = '';
        }
      }).catch(function (e) {
        _this.success = false;
        _this.error = e.response.data;
      });
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_users_userProfile__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_users_userProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_users_userProfile__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'profileWrapper',
  components: { userprofile: __WEBPACK_IMPORTED_MODULE_0__components_users_userProfile___default.a },
  data: function data() {
    return {
      user: this.$root.$data.user
    };
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_autosuggest__ = __webpack_require__(431);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'searchClients',
  components: { 'suggest': __WEBPACK_IMPORTED_MODULE_1_vue_autosuggest__["a" /* VueAutosuggest */] },
  data: function data() {
    return {
      inputProps: {
        id: 'autosuggest__input',
        onInputChange: this.fetchResults,
        placeholder: 'Search for a contact'
      },
      suggestions: [],
      selected: null,
      timeout: null,
      debounceMilliseconds: 200
    };
  },

  methods: {
    fetchResults: function fetchResults(str) {
      var _this = this;

      clearTimeout(this.timeout);
      if (!str || str.trim().length === 0) {
        return;
      }
      this.timeout = setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/users/search/' + str).then(function (res) {
          if (res.status === 200) {
            _this.suggestions = [{ data: res.data }];
          }
        }).catch(function (e) {
          console.log(e.response.data);
        });
      }, this.debounceMilliseconds);
    },
    selectHandler: function selectHandler(s) {
      this.selected = s;
      this.$emit('selected', s.item);
    },
    renderSuggestion: function renderSuggestion(s) {
      var p = s.item.profile;
      if (p.corporate) {
        return p.business;
      } else {
        return p.firstname + ' ' + p.lastname;
      }
    },
    getSuggestionValue: function getSuggestionValue(s) {
      var p = s.item.profile;
      if (p.corporate) {
        return p.business;
      }
      return p.firstname + ' ' + p.lastname;
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'setPassword',
  data: function data() {
    return {
      code: '',
      verified: false,
      user: null,
      password_a: '',
      password_b: '',
      loading: false,
      success: false,
      error: ''
    };
  },

  created: function created() {
    var _this = this;

    this.code = window.location.toString().split('/').pop();
    console.log(this.code);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/verify/' + this.code).then(function (res) {
      if (res.status === 200) {
        _this.verified = true;
        _this.user = res.data;
      }
    });
  },
  methods: {
    setPassword: function setPassword() {
      var _this2 = this;

      this.error = '';
      this.success = false;
      if (this.password_a !== this.password_b) {
        this.error = 'Passwords do not match';
        return;
      }
      if (!this.password_a.length) {
        this.error = 'Empty password';
        return;
      }
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/setpassword', {
        code: this.code,
        password: this.password_a
      }).then(function (res) {
        if (res.status === 200) {
          _this2.loading = false;
          _this2.success = true;
        }
      }).catch(function (e) {
        _this2.loading = false;
        _this2.error = e.response.data;
      });
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_userProfile__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_userProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_users_userProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_matters_clientMatters__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_matters_clientMatters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_matters_clientMatters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_users_clientvevo__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_users_clientvevo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_users_clientvevo__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user',
  props: ['id'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_utils___default.a],
  components: {
    userProfile: __WEBPACK_IMPORTED_MODULE_2__components_users_userProfile___default.a,
    clientMatters: __WEBPACK_IMPORTED_MODULE_3__components_matters_clientMatters___default.a,
    clientVevo: __WEBPACK_IMPORTED_MODULE_4__components_users_clientvevo___default.a
  },
  data: function data() {
    return {
      user: null,
      tab: 0
    };
  },

  created: function created() {
    this.getUser();
  },
  computed: {
    isClient: function isClient() {
      if (!this.user) return false;
      return this.user.level > 4;
    }
  },
  methods: {
    getUser: function getUser() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/get/users/' + this.id).then(function (res) {
        if (res.data) {
          _this.user = res.data;
          var p = _this.user.profile;
          _this.$root.$data.pageTitle = p.firstname + ' ' + p.lastname;
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_avatar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_users_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bus_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_image_upload_resize__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_image_upload_resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_image_upload_resize__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'userProfile',
  props: ['user'],
  components: {
    avatar: __WEBPACK_IMPORTED_MODULE_2__components_users_avatar___default.a,
    ImageUploader: __WEBPACK_IMPORTED_MODULE_4_vue_image_upload_resize__["ImageUploader"]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_utils___default.a],
  data: function data() {
    return {
      countries: __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.countries(),
      sources: __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.sources(),
      brands: __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.brands(),
      agreements: [],
      newAgreement: '',
      editing: false,
      newPic: null,
      successMsg: '',
      error: '',
      savingPic: false,
      showDelModal: false,
      showButtons: true,
      wait1: false,
      wait2: false,
      dob_y: '',
      dob_m: '',
      dob_d: ''
    };
  },
  created: function created() {
    var title = '';
    var p = this.user.profile;
    if (p.corporate) {
      title = p.business;
    } else {
      title = p.firstname + ' ' + p.lastname;
    }
    this.$root.$data.pageTitle = title;

    if (p.dob && /^\d{2}-\d{2}-\d{4}$/.test(p.dob)) {
      var dmy = p.dob.split('-');
      this.dob_d = dmy[0];
      this.dob_m = dmy[1];
      this.dob_y = dmy[2];
    }
  },

  computed: {
    isEdAdmin: function isEdAdmin() {
      return this.$root.$data.admin;
    },
    isUserClient: function isUserClient() {
      return this.user.level > 4;
    }
  },
  methods: {
    editMode: function editMode() {
      if (this.isEdAdmin && this.isUserClient) {
        this.getAgreements();
      }
      this.editing = true;
    },
    save: function save() {
      var _this = this;

      if (this.newAgreement) {
        this.user.agreement = this.newAgreement;
        this.linkAgreement();
      }
      this.wait1 = true;

      this.user.profile.dob = [this.dob_d, this.dob_m, this.dob_y].join('-');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/update', this.user).then(function (res) {
        if (res.status === 200) {
          _this.error = '';
          if (_this.newPic) {
            _this.savePic();
          }
          _this.editing = false;
          _this.wait1 = false;
          _this.successMsg = 'Saved';
          _this.newAgreement = '';
        }
      }).catch(function (e) {
        _this.editing = false;
        _this.wait1 = false;
        _this.error = e.response.data;
        __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.methods.delay(3000, function () {
          _this.error = '';
        });
      });
    },
    delUser: function delUser() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/delete/' + this.user._id).then(function (res) {
        if (res.status === 200) {
          _this2.error = '';
          _this2.successMsg = 'Deleted';
          _this2.showButtons = false;
          _this2.showDelModal = false;
          __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.methods.delay(3000, function () {
            _this2.$router.go(-1);
          });
        }
      }).catch(function (e) {
        _this2.error = e.response.data;
        _this2.showDelModal = false;
        __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.methods.delay(3000, function () {
          _this2.error = '';
        });
      });
    },
    invite: function invite() {
      var _this3 = this;

      this.error = '';
      this.wait2 = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/invite/' + this.user._id).then(function (res) {
        if (res.status === 200) {
          _this3.wait2 = false;
          _this3.successMsg = 'Invitation sent';
        }
      }).catch(function (e) {
        _this3.error = e.response.data;
        _this3.wait2 = false;
      });
    },
    setPic: function setPic(file) {
      this.newPic = file;
    },
    savePic: function savePic() {
      var _this4 = this;

      if (this.user.profile.avatar) {
        this.updateAvatar();
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/avatars/set', {
        user: this.user._id,
        data: this.newPic
      }).then(function (res) {
        if (res.status === 200) {
          if (res.data) {
            _this4.user.profile.avatar = res.data;
          }
          _this4.savingPic = false;
          __WEBPACK_IMPORTED_MODULE_3__components_bus_js__["a" /* bus */].$emit('new_avatar', _this4.user._id, _this4.newPic);
        }
      }).catch(function (e) {
        _this4.savingPic = false;
        console.log(e.response.data);
      });
    },
    updateAvatar: function updateAvatar() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/avatars/update', {
        _id: this.user.profile.avatar,
        user: this.user._id,
        data: this.newPic
      }).then(function (res) {
        if (res.status === 200) {
          _this5.savingPic = false;
          __WEBPACK_IMPORTED_MODULE_3__components_bus_js__["a" /* bus */].$emit('new_avatar', _this5.user._id, _this5.newPic);
        }
      }).catch(function (e) {
        _this5.savingPic = false;
        console.log(e);
      });
    },
    getAgreements: function getAgreements() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/agreements/unlinked').then(function (res) {
        if (res.status === 200) _this6.agreements = res.data;
      }).catch(function (e) {
        console.log(e.response.data);
      });
    },
    linkAgreement: function linkAgreement() {
      var _this7 = this;

      if (!this.newAgreement) return;
      var form = new FormData();
      form.append('user', this.user._id);
      form.append('agreement', this.newAgreement);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/agreements/link', form).catch(function (e) {
        _this7.error = e.respone.data;
      });
    },
    unlinkAgreement: function unlinkAgreement() {
      var _this8 = this;

      var form = new FormData();
      form.append('user', this.user._id);
      form.append('agreement', this.user.agreement);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/agreements/unlink', form).then(function (res) {
        if (res.status === 200) {
          _this8.user.agreement = null;
          _this8.getAgreements();
        }
      }).catch(function (e) {
        _this8.error = e.response.data;
      });
    },
    delAvatar: function delAvatar() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/avatars/delete/' + this.user._id).then(function (res) {
        if (res.status === 200) {
          _this9.user.profile.avatar = '';
          __WEBPACK_IMPORTED_MODULE_3__components_bus_js__["a" /* bus */].$emit('del_avatar', _this9.user._id);
        }
      }).catch(function (e) {
        console.log(e.response.data);
      });
    },
    toLevel: function toLevel(n) {
      this.user.level = n;
      this.save();
    },
    archiveUser: function archiveUser() {
      var _this10 = this;

      this.wait1 = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users/archive/' + this.user._id).then(function (res) {
        if (res.status === 200) {
          _this10.wait1 = false;
          _this10.successMsg = 'Saved';
          _this10.user.archived = !_this10.user.archived;
        }
      }).catch(function (e) {
        _this10.wait1 = false;
        _this10.error = e.response.data;
        __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.methods.delay(3000, function () {
          _this10.error = '';
        });
      });
    },
    getBrand: function getBrand() {
      if (!this.user.profile.brand) {
        return this.brands['pl'];
      }
      return this.brands[this.user.profile.brand];
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_users_avatar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_users_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_users_avatar__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'users',
  components: { avatar: __WEBPACK_IMPORTED_MODULE_1__components_users_avatar___default.a },
  props: ['usertype'], data: function data() {
    return {
      users: [],
      tab: 0
    };
  },
  created: function created() {
    this.setup();
  },

  watch: {
    '$route': function $route(to, from) {
      this.setup();
    }
  },
  computed: {
    userlist: function userlist() {
      if (this.usertype === 'admin') {
        return this.users;
      }
      if (this.tab === 0) {
        return this.users.filter(function (u) {
          return !u.archived && u.level === 5;
        });
      }
      if (this.tab === 1) {
        return this.users.filter(function (u) {
          return !u.archived && u.level === 6;
        });
      }
      if (this.tab === 2) {
        return this.users.filter(function (u) {
          return u.archived && u.level >= 5;
        });
      }
    }
  },
  methods: {
    setup: function setup() {
      if (this.usertype === 'client') {
        this.$root.$data.pageTitle = 'Clients';
      } else {
        this.$root.$data.pageTitle = 'Team';
      }
      this.getUsers();
    },

    getUsers: function getUsers() {
      var _this = this;

      var path = null;
      if (this.usertype === 'client') {
        path = '/api/users/clientbriefs';
      } else {
        path = '/api/users/adminbriefs';
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(path).then(function (res) {
        if (res.data) {
          _this.users = res.data.sort(function (a, b) {
            var aName = a.profile.corporate ? a.profile.business : a.profile.firstname;
            var bName = b.profile.corporate ? b.profile.business : b.profile.firstname;
            return aName.localeCompare(bName);
          });
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    delUser: function delUser(user) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/delete/users/' + user._id).then(function (res) {
        if (res.status === 200) {
          _this2.getUsers();
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'utils',
  methods: {
    logout: function logout(that) {
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/api/users/logout').then(function (res) {
        if (res.status === 200) {
          that.$root.$data.validated = false;
          that.$root.$data.user = null;
          that.$root.$data.pageTitle = '';
          that.$router.push('/');
        }
      });
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    delay: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(ms, fn) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.sleep(ms);

              case 2:
                fn();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function delay(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return delay;
    }(),
    getData: function getData(path, fn) {
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(path).then(function (res) {
        fn(res.data);
      }).catch(function (err) {
        console.log(err);
      });
    },

    allFields: function allFields(obj, ignore) {
      ignore = ignore || [];
      for (var key in obj) {
        if (typeof obj[key] === 'string' && ignore.indexOf(key) < 0) {
          obj[key] = obj[key].trim();
          if (!obj[key]) return false;
        }
      }
      return true;
    },
    importType: function importType(string) {
      var lines = string.split(';;');
      var secKey = 0;
      var subKey = 0;
      var vtype = {
        name: lines[0].split('visatype')[1].trim(),
        sections: []
      };

      var newSec = function newSec(line) {
        vtype.sections.push({
          name: line.split('# ')[1].trim(),
          ref: Math.round(Math.random() * 100000),
          subsections: []
        });
        secKey = vtype.sections.length - 1;
      };

      var newSub = function newSub(line) {
        line = line.slice(3).split('||').map(function (f) {
          return f.trim();
        });
        vtype.sections[secKey].subsections.push({
          name: line[0],
          ref: Math.round(Math.random() * 100000),
          repeatable: line.length >= 2 && line[1] === 'repeatable',
          questions: []
        });
        subKey = vtype.sections[secKey].subsections.length - 1;
      };

      var newQ = function newQ(line) {
        var fields = line.split('||').map(function (f) {
          return f.trim();
        });
        if (fields.length < 4) return;
        vtype.sections[secKey].subsections[subKey].questions.push({
          ref: Math.round(Math.random() * 100000),
          type: fields[0],
          text: fields[1],
          helptext: fields[2] === '_' ? '' : fields[2],

          selectVals: [],
          dependent: false,
          depends: {
            ref: '',
            atxt: ''
          }
        });
      };

      lines.slice(1).forEach(function (line) {
        line = line.trim();
        if (line.startsWith('# ')) newSec(line);else if (line.startsWith('## ')) newSub(line);else if (line.trim() === '') return;else newQ(line);
      });

      return vtype;
    },

    payments: function payments(inv) {
      if (!inv.plan) return null;
      var payments = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(inv.payments), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var p = _step.value;

          payments.push({
            date: new Date(p.time).toLocaleDateString('en-GB'),
            amount: p.amount,
            paid: true
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!inv.paid) {
        var outstanding = inv.outstanding;
        var period = 1000 * 60 * 60 * 24 * 28;
        var firstUpcoming = true;
        var time, amount;
        var lastpayment = new Date(inv.last_payment).getTime();

        if (lastpayment > 0) {
          time = lastpayment;
        } else {
          time = new Date(inv.date).getTime();
          amount = inv.initial;
          payments.push({
            date: new Date(time).toLocaleDateString('en-GB'),
            amount: amount,
            paid: false,
            firstUpcoming: firstUpcoming
          });
          outstanding -= amount;
          time += period;
          firstUpcoming = false;
        }

        while (outstanding > 0) {
          amount = Math.min(outstanding, inv.monthly);
          outstanding -= amount;
          time += period;

          payments.push({
            date: new Date(time).toLocaleDateString('en-GB'),
            amount: amount,
            paid: false,
            firstUpcoming: firstUpcoming
          });
          firstUpcoming = false;
        }
      }

      return payments;
    },

    checkMatter: function checkMatter(visatype, matter, answers) {
      var isNeededSub = function isNeededSub(sub) {
        if (!sub.for_client) {
          return false;
        }
        if (!sub.depends || !sub.depends.ref) {
          console.log(sub.name);
          return true;
        } else {
          var ref = sub.depends.ref;
          var atxt = sub.depends.atxt;
          if (answers[ref] && answers[ref].length > 0) {
            for (var i in answers[ref]) {
              if (answers[ref][i].atxt === atxt) {
                return true;
              }
            }
          } else {
            return false;
          }
        }
      };

      var isAnswered = function isAnswered(q) {
        var arr = answers[q.ref];
        if (arr && arr.length > 0) {
          return true;
        } else {
          return false;
        }
      };

      for (var i in visatype.sections) {
        var sec = visatype.sections[i];
        for (var j in sec.subsections) {
          var sub = sec.subsections[j];
          if (isNeededSub(sub)) {
            console.log(sub.name);
            for (var k in sub.questions) {
              var q = sub.questions[k];
              if (!isAnswered(q)) {
                return;
              }
            }
          }
        }
      }

      console.log('All required questions answered');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/api/matters/markallcqanswered/' + matter._id);
    }
  },
  countries: function countries() {
    return {
      'Select': '',
      'AFGHANISTAN': 'AFG',
      'ALBANIA': 'ALB',
      'ALGERIA': 'DZA',
      'AMERICAN SAMOA': 'ASM',
      'ANDORRA': 'AND',
      'ANGOLA': 'AGO',
      'ANGUILLA': 'AIA',
      'ANTARCTICA': 'ATA',
      'ANTIGUA AND BARBUDA': 'ATG',
      'ARGENTINA': 'ARG',
      'ARMENIA': 'ARM',
      'ARUBA': 'ABW',
      'AUSTRALIA': 'AUS',
      'AUSTRIA': 'AUT',
      'AZERBAIJAN': 'AZE',
      'BAHAMAS': 'BHS',
      'BAHRAIN': 'BHR',
      'BANGLADESH': 'BGD',
      'BARBADOS': 'BRB',
      'BELARUS': 'BLR',
      'BELGIUM': 'BEL',
      'BELIZE': 'BLZ',
      'BENIN': 'BEN',
      'BERMUDA': 'BMU',
      'BHUTAN': 'BTN',
      'BOLIVIA': 'BOL',
      'BONAIRE, SINT EUSTATIUS AND SABA': 'BES',
      'BOSNIA AND HERZEGOVINA': 'BIH',
      'BOTSWANA': 'BWA',
      'BOUVET ISLAND': 'BVT',
      'BRAZIL': 'BRA',
      'BRIT INDIAN OCN TERR': 'IOT',
      'BRUNEI DARUSSALAM': 'BRN',
      'BULGARIA': 'BGR',
      'BURKINA FASO': 'BFA',
      'BURMA (MYANMAR)': 'MMR',
      'BURUNDI': 'BDI',
      'CABO VERDE': 'CPV',
      'CAMBODIA': 'KHM',
      'CAMEROON': 'CMR',
      'CANADA': 'CAN',
      'CAYMAN ISLANDS': 'CYM',
      'CENTRAL AFRICAN REPUBLIC': 'CAF',
      'CHAD': 'TCD',
      'CHILE': 'CHL',
      'CHINA': 'CHN',
      'COCOS (KEELING) ISL.': 'CCK',
      'COLOMBIA': 'COL',
      'COMOROS': 'COM',
      'CONGO': 'COG',
      'CONGO, DEMOCRATIC REPUBLIC OF THE': 'COD',
      'COOK ISLANDS': 'COK',
      'COSTA RICA': 'CRI',
      'COTE D\'IVOIRE': 'CIV',
      'CROATIA': 'HRV',
      'CUBA': 'CUB',
      'CURACAO': 'CUW',
      'CYPRUS': 'CYP',
      'CZECHIA (CZECH REP)': 'CZE',
      'CZECHOSLOVAKIA': 'CSK',
      'DENMARK': 'DNK',
      'DJIBOUTI': 'DJI',
      'DOMINICA': 'DMA',
      'DOMINICAN REPUBLIC': 'DOM',
      'EAST TIMOR': 'TMP',
      'ECUADOR': 'ECU',
      'EGYPT': 'EGY',
      'EL SALVADOR': 'SLV',
      'EQUATORIAL GUINEA': 'GNQ',
      'ERITREA': 'ERI',
      'ESTONIA': 'EST',
      'ETHIOPIA': 'ETH',
      'FALKLAND ISLANDS (MALVINAS)': 'FLK',
      'FAROE ISLANDS': 'FRO',
      'FIJI': 'FJI',
      'FINLAND': 'FIN',
      'FRANCE': 'FRA',
      'FRANCE, METROPOLITAN': 'FXX',
      'FRENCH GUIANA': 'GUF',
      'FRENCH POLYNESIA': 'PYF',
      'FRENCH SOUTHERN TERR': 'ATF',
      'GABON': 'GAB',
      'GAMBIA': 'GMB',
      'GEORGIA': 'GEO',
      'GEORGIA/SANDWICH ISL': 'SGS',
      'GERMANY': 'D',
      'GHANA': 'GHA',
      'GIBRALTAR': 'GIB',
      'GREECE': 'GRC',
      'GREENLAND': 'GRL',
      'GRENADA': 'GRD',
      'GUADELOUPE': 'GLP',
      'GUAM': 'GUM',
      'GUATEMALA': 'GTM',
      'GUINEA': 'GIN',
      'GUINEA-BISSAU': 'GNB',
      'GUYANA': 'GUY',
      'HAITI': 'HTI',
      'HEARD ISLAND AND MCDONALD ISLANDS': 'HMD',
      'HONDURAS': 'HND',
      'HONG KONG SAR': 'HKG',
      'HUNGARY': 'HUN',
      'ICELAND': 'ISL',
      'INDIA': 'IND',
      'INDONESIA': 'IDN',
      'IRAN, ISLAMIC REPUBLIC OF': 'IRN',
      'IRAQ': 'IRQ',
      'IRELAND': 'IRL',
      'ISRAEL': 'ISR',
      'ITALY': 'ITA',
      'JAMAICA': 'JAM',
      'JAPAN': 'JPN',
      'JORDAN': 'JOR',
      'KAZAKHSTAN': 'KAZ',
      'KENYA': 'KEN',
      'KIRIBATI': 'KIR',
      'KOREA, DEMOCRATIC PEOPLES REPUBLIC OF (NORTH)': 'PRK',
      'KOREA, REPUBLIC OF (SOUTH)': 'KOR',
      'KOSOVO': 'RKS',
      'KUWAIT': 'KWT',
      'KYRGYZSTAN': 'KGZ',
      'LAO PEOPLE\'S DEMOCRATIC REPUBLIC': 'LAO',
      'LATVIA': 'LVA',
      'LEBANON': 'LBN',
      'LESOTHO': 'LSO',
      'LIBERIA': 'LBR',
      'LIBYA': 'LBY',
      'LIECHTENSTEIN': 'LIE',
      'LITHUANIA': 'LTU',
      'LUXEMBOURG': 'LUX',
      'MACAU SAR': 'MAC',
      'MACEDONIA, FORMER YUGOSLAV REPUBLIC OF': 'MKD',
      'MADAGASCAR': 'MDG',
      'MALAWI': 'MWI',
      'MALAYSIA': 'MYS',
      'MALDIVES': 'MDV',
      'MALI': 'MLI',
      'MALTA': 'MLT',
      'MARSHALL ISLANDS': 'MHL',
      'MARTINIQUE': 'MTQ',
      'MAURITANIA': 'MRT',
      'MAURITIUS': 'MUS',
      'MAYOTTE': 'MYT',
      'MEXICO': 'MEX',
      'MICRONESIA, FEDERATED STATES OF': 'FSM',
      'MOLDOVA, REPUBLIC OF': 'MDA',
      'MONACO': 'MCO',
      'MONGOLIA': 'MNG',
      'MONTENEGRO': 'MNE',
      'MONTSERRAT': 'MSR',
      'MOROCCO': 'MAR',
      'MOZAMBIQUE': 'MOZ',
      'NAMIBIA': 'NAM',
      'NAURU': 'NRU',
      'NEPAL': 'NPL',
      'NETHERLANDS': 'NLD',
      'NETHERLANDS ANTILLES': 'ANT',
      'NEUTRAL ZONE': 'NTZ',
      'NEW CALEDONIA': 'NCL',
      'NEW ZEALAND': 'NZL',
      'NICARAGUA': 'NIC',
      'NIGER': 'NER',
      'NIGERIA': 'NGA',
      'NIUE': 'NIU',
      'NORTHERN MARIANA ISL': 'MNP',
      'NORWAY': 'NOR',
      'OMAN': 'OMN',
      'PAKISTAN': 'PAK',
      'PALAU': 'PLW',
      'PALESTINIAN AUTHORITY': 'PSE',
      'PANAMA': 'PAN',
      'PAPUA NEW GUINEA': 'PNG',
      'PARAGUAY': 'PRY',
      'PERU': 'PER',
      'PHILIPPINES': 'PHL',
      'PITCAIRN': 'PCN',
      'POLAND': 'POL',
      'PORTUGAL': 'PRT',
      'PUERTO RICO': 'PRI',
      'QATAR': 'QAT',
      'REFUGEE AS PER ART 1': 'XXB',
      'REFUGEE OTHER': 'XXC',
      'REUNION': 'REU',
      'ROMANIA': 'ROU',
      'ROMANIA PRE 1/2/2002': 'ROM',
      'RUSSIAN FEDERATION': 'RUS',
      'RWANDA': 'RWA',
      'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA': 'SHN',
      'SAINT KITTS AND NEVIS': 'KNA',
      'SAINT LUCIA': 'LCA',
      'SAINT VINCENT AND THE GRENADINES': 'VCT',
      'SAMOA': 'WSM',
      'SAN MARINO': 'SMR',
      'SAO TOME AND PRINCIPE': 'STP',
      'SAUDI ARABIA': 'SAU',
      'SENEGAL': 'SEN',
      'SERBIA': 'SRB',
      'SERBIA AND MONTENEGRO': 'SCG',
      'SEYCHELLES': 'SYC',
      'SIERRA LEONE': 'SLE',
      'SINGAPORE': 'SGP',
      'SINT MAARTEN (DUTCH PART)': 'SXM',
      'SLOVAK REPUBLIC': 'SVK',
      'SLOVENIA': 'SVN',
      'SOLOMON ISLANDS': 'SLB',
      'SOMALIA': 'SOM',
      'SOUTH AFRICA': 'ZAF',
      'SOUTH SUDAN': 'SSD',
      'SPAIN': 'ESP',
      'SRI LANKA': 'LKA',
      'ST PIERRE & MIQUELON': 'SPM',
      'STATELESS PERSON': 'XXA',
      'SUDAN': 'SDN',
      'SURINAME': 'SUR',
      'SVALBARD & JAN MAYEN': 'SJM',
      'SWAZILAND': 'SWZ',
      'SWEDEN': 'SWE',
      'SWITZERLAND': 'CHE',
      'SYRIAN ARAB REPUBLIC': 'SYR',
      'TAIWAN': 'TWN',
      'TAJIKISTAN': 'TJK',
      'TANZANIA, UNITED REPUBLIC OF': 'TZA',
      'THAILAND': 'THA',
      'TIMOR-LESTE': 'TLS',
      'TOGO': 'TGO',
      'TOKELAU': 'TKL',
      'TONGA': 'TON',
      'TRINIDAD AND TOBAGO': 'TTO',
      'TUNISIA': 'TUN',
      'TURKEY': 'TUR',
      'TURKMENISTAN': 'TKM',
      'TURKS AND CAICOS ISLANDS': 'TCA',
      'TUVALU': 'TUV',
      'U.S MINOR ISLANDS': 'UMI',
      'UGANDA': 'UGA',
      'UKRAINE': 'UKR',
      'UNITED ARAB EMIRATES': 'ARE',
      'UNITED KINGDOM - BRITISH CITIZEN': 'GBR',
      'UNITED KINGDOM - BRITISH NATIONAL (OVERSEAS)': 'GBN',
      'UNITED KINGDOM - BRITISH OVERSEAS CITIZEN': 'GBO',
      'UNITED KINGDOM - BRITISH OVERSEAS TERRITORIES CITIZEN': 'GBD',
      'UNITED KINGDOM - BRITISH PROTECTED PERSON': 'GBP',
      'UNITED KINGDOM - BRITISH SUBJECT': 'GBS',
      'UNITED NATIONS AGNCY': 'UNA',
      'UNITED NATIONS ORGANISATION': 'UNO',
      'UNITED STATES': 'USA',
      'UNMIK TRAVEL DOC': 'UNK',
      'UNSPCFED NATIONALITY': 'XXX',
      'URUGUAY': 'URY',
      'UZBEKISTAN': 'UZB',
      'VANUATU': 'VUT',
      'VATICAN CITY STATE (HOLY SEE)': 'VAT',
      'VENEZUELA': 'VEN',
      'VIET NAM': 'VNM',
      'VIRGIN ISLANDS (BRITISH)': 'VGB',
      'VIRGIN ISLANDS (U.S.)': 'VIR',
      'WALLIS & FUTUNA ISL': 'WLF',
      'WESTERN SAHARA': 'ESH',
      'YEMEN': 'YEM',
      'YUGOSLAVIA': 'YUG',
      'ZAIRE': 'ZAR',
      'ZAMBIA': 'ZMB',
      'ZIMBABWE': 'ZWE'
    };
  },
  vevoFields: function vevoFields() {
    return {
      visaDesc: 'Visa description',
      visaClass: 'Visa class',
      visaType: 'Visa type',
      visaStatus: 'Visa status',
      visaApplicant: 'Visa applicant',
      visaGrantDate: 'Visa grant date',
      visaExpDate: 'Visa expiry date',
      location: 'Location',
      grantNumber: 'Grant number',
      entriesAllowed: 'Entries allowed',
      notArriveAfter: 'Must not arrive after',
      stayPeriod: 'Period of stay'
    };
  },
  sources: function sources() {
    return ['Google Organic', 'Google SEM', 'Facebook', 'LinkedIn', 'Referral', 'Other'];
  },
  dybURL: function dybURL() {
    if (false) {
      return 'http://localhost:8082/vevo?';
    } else {
      return 'https://staging.pocketlegal.com.au:8082/vevo?';
    }
  },
  brands: function brands() {
    return {
      'pl': 'PocketLegal',
      'ie': 'Immigration Experts'
    };
  },
  invoiceItems: function invoiceItems() {
    return ['Initial work on application', 'Standard Business Sponsorship', 'Primary', 'Nomination', 'Balance of account', 'Other'];
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vevo',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_utils___default.a],
  data: function data() {
    return {
      countries: __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.countries(),
      resultFields: __WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.vevoFields(),
      showDateModal: false,
      loading: false,
      results: null,
      errormsg: null,
      familyName: '',
      givenName: '',
      dob_y: '',
      dob_m: '',
      dob_d: '',
      docType: '01',
      docNumber: '',
      docCountry: ''
    };
  },

  created: function created() {
    this.$root.$data.pageTitle = 'VEVO';
  },
  methods: {
    submit: function submit() {
      var _this = this;

      if (this.loading) return;
      this.loading = true;
      this.errormsg = null;
      var params = new URLSearchParams();

      params.append('dyb_password', "C74zTIetr778B0rIAc5n");
      params.append('familyName', this.familyName);
      params.append('givenName', this.givenName);
      params.append('dob', [this.dob_y, this.dob_m, this.dob_d].join('-'));
      params.append('docType', this.docType);
      params.append('docNumber', this.docNumber);
      params.append('docCountry', this.docCountry);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__components_utils___default.a.dybURL() + params.toString()).then(function (res) {
        if (res.status === 200) {
          _this.loading = false;
          _this.results = res.data;
        }
      }).catch(function (e) {
        _this.loading = false;
        _this.errormsg = e.response.data;
      });
    },
    testFunc: function testFunc() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/agreements/test').catch(function (e) {
        console.log(e.response.data);
      });
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_utils__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'visatypes',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_utils___default.a],
  data: function data() {
    return {
      typeIndex: -1,
      visatypes: [],
      newTypeField: '',
      error: false
    };
  },

  created: function created() {
    this.$root.$data.pageTitle = 'Visa Types';
    this.getTypes();
  },
  methods: {
    getTypes: function getTypes() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/allvisatypes').then(function (res) {
        if (res.data) {
          _this.visatypes = res.data;
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    addType: function addType() {
      var _this2 = this;

      var name = this.newTypeField.trim();
      if (name === '') {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/new/visatypes', {
        name: name,
        sections: [],
        doctypes: []
      }).then(function (res) {
        if (res.status === 200) {
          _this2.visatypes.push(res.data);
          _this2.newTypeField = '';
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    delType: function delType(index) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/delete/visatypes/' + this.visatypes[index]._id).then(function (res) {
        if (res.status === 200) {
          _this3.visatypes.splice(index, 1);
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    editType: function editType(t) {
      this.$router.push('/visatype/' + t._id);
    },
    importType: function importType() {
      var vtype = null;
      if (this.newTypeField.startsWith('visatype ')) {
        vtype = __WEBPACK_IMPORTED_MODULE_2__components_utils___default.a.methods.importType(this.newTypeField);
      } else {
        vtype = JSON.parse(this.newTypeField);
      }
      if (vtype && vtype.name && vtype.sections) {
        delete vtype['_id'];
        var vm = this;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/new/visatypes', vtype).then(function (res) {
          if (res.status === 200) {
            vm.visatypes.push(res.data);
            vm.newTypeField = '';
          }
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    exportType: function exportType(t) {
      var vtype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(t, null, 2);
      var w = window.open();
      w.document.open();
      w.document.write('<html><body><pre>' + vtype + '</pre></body></html>');
      w.document.close();
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'visatype',
  props: ['id'],
  data: function data() {
    return {
      visatype: null,
      secKey: 0,
      subKey: -1,
      qKey: -1,
      newSectionName: '',
      newSubName: '',
      selectInput: '',
      showDocModal: false,
      showQModal: false,
      showDepsModal: false,
      editingQ: false,
      editingDoc: false,
      tempQ: null,
      tempDoc: null,
      depRef: null,
      depVal: '',
      saving: false,
      error: false
    };
  },
  created: function created() {
    var _this = this;

    this.$root.$data.pageTitle = '';
    this.resetQ();
    this.resetDoc();
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/visatype/' + this.id).then(function (res) {
      if (res.status === 200) {
        _this.visatype = res.data;
        _this.$root.$data.pageTitle = res.data.name;
      }
    }).catch(function (e) {
      console.log(e.response.data);
    });
  },

  computed: {
    allowNewSub: function allowNewSub() {
      return this.visatype.sections.length > 0;
    },

    selectedQ: {
      get: function get() {
        if (!this.visatype.sections[this.secKey] || this.subKey < 0 || this.qKey < 0) return null;
        return this.visatype.sections[this.secKey].subsections[this.subKey].questions[this.qKey];
      },
      set: function set(editedQ) {
        this.visatype.sections[this.secKey].subsections[this.subKey].questions.splice(this.qKey, 1, editedQ);
      }
    },
    boolQuestions: function boolQuestions() {
      var qs = [];
      this.visatype.sections.forEach(function (sec) {
        sec.subsections.forEach(function (sub) {
          sub.questions.forEach(function (q) {
            if (q.type === 'yn') {
              qs.push(q);
            }
          });
        });
      });
      return qs;
    }
  },
  methods: {
    addSection: function addSection() {
      var name = this.newSectionName.trim();
      if (name === '') return;
      this.visatype.sections.push({
        ref: Math.round(Math.random() * 100000),
        name: name,
        subsections: []
      });
      this.newSectionName = '';
    },
    addSubsection: function addSubsection() {
      var name = this.newSubName.trim();
      if (name === '') {
        return;
      }
      this.visatype.sections[this.secKey].subsections.push({
        ref: Math.round(Math.random() * 100000),
        name: name,
        repeatable: false,
        for_client: false,
        questions: []
      });
      this.newSubName = '';
    },
    delSection: function delSection() {
      var delKey = this.secKey;
      if (delKey > 0 && delKey === this.visatype.sections.length - 1) {
        this.secKey -= 1;
      }
      this.visatype.sections.splice(delKey, 1);
    },
    delSubsection: function delSubsection(key) {
      this.visatype.sections[this.secKey].subsections.splice(key, 1);
    },
    saveType: function saveType() {
      var _this2 = this;

      this.saving = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/update/visatypes/' + this.visatype._id, this.visatype).then(function (res) {
        if (res.status === 200) {
          _this2.saving = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    delQ: function delQ(subKey, qKey) {
      this.visatype.sections[this.secKey].subsections[subKey].questions.splice(qKey, 1);
    },
    delDoc: function delDoc(i) {
      this.visatype.doctypes.splice(i, 1);
    },
    editQ: function editQ() {
      if (!this.validQ()) return;
      this.closeQ();
    },
    addQ: function addQ() {
      if (!this.validQ()) return;

      this.tempQ.ref = Math.round(Math.random() * 100000);
      this.visatype.sections[this.secKey].subsections[this.subKey].questions.splice(this.qKey + 1, 0, this.tempQ);
      this.closeQ();
    },
    addDoc: function addDoc() {
      var d = this.tempDoc;
      d.name = d.name.trim();
      d.helptext = d.helptext.trim();
      if (d.name === '') return;

      d.ref = Math.round(Math.random() * 100000);
      if (!this.visatype.doctypes) {
        this.visatype.doctypes = [d];
      } else {
        this.visatype.doctypes.push(d);
      }
      this.closeQ();
    },
    validQ: function validQ() {
      var _this3 = this;

      if (this.tempQ.type === 'select') {
        this.tempQ.selectVals = [];
        var pairs = this.selectInput.split('\n');
        if (pairs.length < 2) return false;
        var validPairs = pairs.every(function (pair) {
          var _pair$split$map = pair.split(',').map(function (s) {
            return s.trim();
          }),
              _pair$split$map2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_pair$split$map, 2),
              k = _pair$split$map2[0],
              v = _pair$split$map2[1];

          if (k && v && k.length && v.length) {
            _this3.tempQ.selectVals.push([k, v]);
            return true;
          }
          return false;
        });
        if (!validPairs) {
          console.log('invalid pairs');
          return false;
        }
        this.selectInput = '';
      }
      return this.tempQ.type !== '' && this.tempQ.text.trim().length > 0;
    },
    openNewQ: function openNewQ(subKey, qKey) {
      this.showQModal = true;
      this.subKey = subKey;
      this.qKey = qKey;
    },
    openEditQ: function openEditQ(subKey, qKey) {
      this.editingQ = true;
      this.subKey = subKey;
      this.qKey = qKey;
      this.tempQ = this.selectedQ;
      this.showQModal = true;

      if (this.tempQ.type === 'select') {
        this.selectInput = this.tempQ.selectVals.map(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              k = _ref2[0],
              v = _ref2[1];

          return k + ', ' + v;
        }).join('\n');
      }
    },
    openEditDoc: function openEditDoc(doc, index) {
      this.editingDoc = true;
      this.tempDoc = doc;
      this.showDocModal = true;
    },

    closeQ: function closeQ() {
      this.showQModal = false;
      this.showDocModal = false;
      this.editingQ = false;
      this.editingDoc = false;
      this.resetQ();
      this.resetDoc();
    },
    resetQ: function resetQ() {
      this.tempQ = {
        type: 'text',
        text: '',
        helptext: '',

        selectVals: [],
        dependent: false,
        depends: {
          ref: '',
          atxt: ''
        }
      };
      this.selectInput = '';
    },
    resetDoc: function resetDoc() {
      this.tempDoc = {
        name: '',
        helptext: '',
        dependent: false,
        depends: {
          ref: '',
          atxt: ''
        }
      };
    },
    openDeps: function openDeps(sub, subKey) {
      this.subKey = subKey;
      this.showDepsModal = true;
      this.depRef = '';
      this.depVal = '';
      if (sub.depends && sub.depends.ref) {
        this.depRef = sub.depends.ref;
      }
      if (sub.depends && sub.depends.ans) {
        this.depVal = sub.depends.atxt;
      }
    },
    addDep: function addDep() {
      if (!this.depRef && !this.depVal) {
        delete this.visatype.sections[this.secKey].subsections[this.subKey].depends;
      } else if (!this.depRef || !this.depVal) {
        return;
      } else {
        this.visatype.sections[this.secKey].subsections[this.subKey].depends = {
          ref: this.depRef,
          atxt: this.depVal
        };
      }
      this.showDepsModal = false;
      this.depRef = '';
      this.depVal = '';
    },
    resetDep: function resetDep() {
      this.depRef = '';
      this.depVal = '';
    },

    movePosition: function movePosition(arr, key, dir) {
      if (dir === -1 && key === 0) return;
      if (dir === 1 && key >= arr.length - 1) return;
      var s = arr[key];
      var temp = arr[key + dir];
      if (dir === -1) {
        arr.splice(key - 1, 2, s, temp);
      } else {
        arr.splice(key, 2, temp, s);
      }
    },
    moveSub: function moveSub(subKey, dir) {
      var subs = this.visatype.sections[this.secKey].subsections;
      this.movePosition(subs, subKey, dir);
    },
    moveQ: function moveQ(subKey, qKey, dir) {
      var questions = this.visatype.sections[this.secKey].subsections[subKey].questions;
      this.movePosition(questions, qKey, dir);
    },
    moveDoc: function moveDoc(i, dir) {
      this.movePosition(this.visatype.doctypes, i, dir);
    }
  }
});

/***/ }),
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */,
/* 423 */,
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 87,
	"./af.js": 87,
	"./ar": 94,
	"./ar-dz": 88,
	"./ar-dz.js": 88,
	"./ar-kw": 89,
	"./ar-kw.js": 89,
	"./ar-ly": 90,
	"./ar-ly.js": 90,
	"./ar-ma": 91,
	"./ar-ma.js": 91,
	"./ar-sa": 92,
	"./ar-sa.js": 92,
	"./ar-tn": 93,
	"./ar-tn.js": 93,
	"./ar.js": 94,
	"./az": 95,
	"./az.js": 95,
	"./be": 96,
	"./be.js": 96,
	"./bg": 97,
	"./bg.js": 97,
	"./bm": 98,
	"./bm.js": 98,
	"./bn": 99,
	"./bn.js": 99,
	"./bo": 100,
	"./bo.js": 100,
	"./br": 101,
	"./br.js": 101,
	"./bs": 102,
	"./bs.js": 102,
	"./ca": 103,
	"./ca.js": 103,
	"./cs": 104,
	"./cs.js": 104,
	"./cv": 105,
	"./cv.js": 105,
	"./cy": 106,
	"./cy.js": 106,
	"./da": 107,
	"./da.js": 107,
	"./de": 110,
	"./de-at": 108,
	"./de-at.js": 108,
	"./de-ch": 109,
	"./de-ch.js": 109,
	"./de.js": 110,
	"./dv": 111,
	"./dv.js": 111,
	"./el": 112,
	"./el.js": 112,
	"./en-SG": 113,
	"./en-SG.js": 113,
	"./en-au": 114,
	"./en-au.js": 114,
	"./en-ca": 115,
	"./en-ca.js": 115,
	"./en-gb": 116,
	"./en-gb.js": 116,
	"./en-ie": 117,
	"./en-ie.js": 117,
	"./en-il": 118,
	"./en-il.js": 118,
	"./en-nz": 119,
	"./en-nz.js": 119,
	"./eo": 120,
	"./eo.js": 120,
	"./es": 123,
	"./es-do": 121,
	"./es-do.js": 121,
	"./es-us": 122,
	"./es-us.js": 122,
	"./es.js": 123,
	"./et": 124,
	"./et.js": 124,
	"./eu": 125,
	"./eu.js": 125,
	"./fa": 126,
	"./fa.js": 126,
	"./fi": 127,
	"./fi.js": 127,
	"./fo": 128,
	"./fo.js": 128,
	"./fr": 131,
	"./fr-ca": 129,
	"./fr-ca.js": 129,
	"./fr-ch": 130,
	"./fr-ch.js": 130,
	"./fr.js": 131,
	"./fy": 132,
	"./fy.js": 132,
	"./ga": 133,
	"./ga.js": 133,
	"./gd": 134,
	"./gd.js": 134,
	"./gl": 135,
	"./gl.js": 135,
	"./gom-latn": 136,
	"./gom-latn.js": 136,
	"./gu": 137,
	"./gu.js": 137,
	"./he": 138,
	"./he.js": 138,
	"./hi": 139,
	"./hi.js": 139,
	"./hr": 140,
	"./hr.js": 140,
	"./hu": 141,
	"./hu.js": 141,
	"./hy-am": 142,
	"./hy-am.js": 142,
	"./id": 143,
	"./id.js": 143,
	"./is": 144,
	"./is.js": 144,
	"./it": 146,
	"./it-ch": 145,
	"./it-ch.js": 145,
	"./it.js": 146,
	"./ja": 147,
	"./ja.js": 147,
	"./jv": 148,
	"./jv.js": 148,
	"./ka": 149,
	"./ka.js": 149,
	"./kk": 150,
	"./kk.js": 150,
	"./km": 151,
	"./km.js": 151,
	"./kn": 152,
	"./kn.js": 152,
	"./ko": 153,
	"./ko.js": 153,
	"./ku": 154,
	"./ku.js": 154,
	"./ky": 155,
	"./ky.js": 155,
	"./lb": 156,
	"./lb.js": 156,
	"./lo": 157,
	"./lo.js": 157,
	"./lt": 158,
	"./lt.js": 158,
	"./lv": 159,
	"./lv.js": 159,
	"./me": 160,
	"./me.js": 160,
	"./mi": 161,
	"./mi.js": 161,
	"./mk": 162,
	"./mk.js": 162,
	"./ml": 163,
	"./ml.js": 163,
	"./mn": 164,
	"./mn.js": 164,
	"./mr": 165,
	"./mr.js": 165,
	"./ms": 167,
	"./ms-my": 166,
	"./ms-my.js": 166,
	"./ms.js": 167,
	"./mt": 168,
	"./mt.js": 168,
	"./my": 169,
	"./my.js": 169,
	"./nb": 170,
	"./nb.js": 170,
	"./ne": 171,
	"./ne.js": 171,
	"./nl": 173,
	"./nl-be": 172,
	"./nl-be.js": 172,
	"./nl.js": 173,
	"./nn": 174,
	"./nn.js": 174,
	"./pa-in": 175,
	"./pa-in.js": 175,
	"./pl": 176,
	"./pl.js": 176,
	"./pt": 178,
	"./pt-br": 177,
	"./pt-br.js": 177,
	"./pt.js": 178,
	"./ro": 179,
	"./ro.js": 179,
	"./ru": 180,
	"./ru.js": 180,
	"./sd": 181,
	"./sd.js": 181,
	"./se": 182,
	"./se.js": 182,
	"./si": 183,
	"./si.js": 183,
	"./sk": 184,
	"./sk.js": 184,
	"./sl": 185,
	"./sl.js": 185,
	"./sq": 186,
	"./sq.js": 186,
	"./sr": 188,
	"./sr-cyrl": 187,
	"./sr-cyrl.js": 187,
	"./sr.js": 188,
	"./ss": 189,
	"./ss.js": 189,
	"./sv": 190,
	"./sv.js": 190,
	"./sw": 191,
	"./sw.js": 191,
	"./ta": 192,
	"./ta.js": 192,
	"./te": 193,
	"./te.js": 193,
	"./tet": 194,
	"./tet.js": 194,
	"./tg": 195,
	"./tg.js": 195,
	"./th": 196,
	"./th.js": 196,
	"./tl-ph": 197,
	"./tl-ph.js": 197,
	"./tlh": 198,
	"./tlh.js": 198,
	"./tr": 199,
	"./tr.js": 199,
	"./tzl": 200,
	"./tzl.js": 200,
	"./tzm": 202,
	"./tzm-latn": 201,
	"./tzm-latn.js": 201,
	"./tzm.js": 202,
	"./ug-cn": 203,
	"./ug-cn.js": 203,
	"./uk": 204,
	"./uk.js": 204,
	"./ur": 205,
	"./ur.js": 205,
	"./uz": 207,
	"./uz-latn": 206,
	"./uz-latn.js": 206,
	"./uz.js": 207,
	"./vi": 208,
	"./vi.js": 208,
	"./x-pseudo": 209,
	"./x-pseudo.js": 209,
	"./yo": 210,
	"./yo.js": 210,
	"./zh-cn": 211,
	"./zh-cn.js": 211,
	"./zh-hk": 212,
	"./zh-hk.js": 212,
	"./zh-tw": 213,
	"./zh-tw.js": 213
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 424;

/***/ }),
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/consumer_guide.2211e54.gif";

/***/ }),
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(473),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(480),
  /* scopeId */
  "data-v-1f9a823a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(415)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(520),
  /* scopeId */
  "data-v-c81d459a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(396)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(494),
  /* scopeId */
  "data-v-44f19d26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(482),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(407)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(511),
  /* scopeId */
  "data-v-7bc9cb56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(400)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(500),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(404)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(507),
  /* scopeId */
  "data-v-6cab34db",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(486),
  /* scopeId */
  "data-v-2c6707a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(413)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(518),
  /* scopeId */
  "data-v-b7dca5e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(419)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(525),
  /* scopeId */
  "data-v-ef26debe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(523),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(489),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(527),
  /* scopeId */
  "data-v-fd4aad14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(476),
  /* scopeId */
  "data-v-10512432",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(390)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(487),
  /* scopeId */
  "data-v-35a2804d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(514),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(418)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(524),
  /* scopeId */
  "data-v-e51a86c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(416)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(521),
  /* scopeId */
  "data-v-c9e472ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(472),
  /* scopeId */
  "data-v-04d46f22",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(414)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(519),
  /* scopeId */
  "data-v-bbe273f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(479),
  /* scopeId */
  "data-v-1a864838",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(490),
  /* scopeId */
  "data-v-39ee5feb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(510),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(493),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(409)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(513),
  /* scopeId */
  "data-v-873b9fb2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(399)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(497),
  /* scopeId */
  "data-v-4c1ff5ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(491),
  /* scopeId */
  "data-v-3a42bc91",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(397)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(495),
  /* scopeId */
  "data-v-47a49b8a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(410)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(515),
  /* scopeId */
  "data-v-99b45646",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(485),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(394)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(492),
  /* scopeId */
  "data-v-3c8654e9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(401)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(501),
  /* scopeId */
  "data-v-57efe95a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(398)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(496),
  /* scopeId */
  "data-v-47b35142",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(412)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(517),
  /* scopeId */
  "data-v-b0a2989e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(411)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(516),
  /* scopeId */
  "data-v-9b64466e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": _vm.save
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-md-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.question.text))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer.atxt),
      expression: "answer.atxt"
    }],
    staticClass: "form-select",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "blur": _vm.save,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.answer, "atxt", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Choose an option")]), _vm._v(" "), _vm._l((_vm.question.selectVals), function(opt) {
    return _c('option', {
      domProps: {
        "value": opt[1]
      }
    }, [_vm._v(_vm._s(opt[0]))])
  })], 2)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile-action"
  })])])
},staticRenderFns: []}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form",
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('label', {
    staticClass: "myLabel c-hand"
  }, [_c('input', {
    staticClass: "form-input",
    attrs: {
      "type": "file",
      "disabled": _vm.saving
    },
    on: {
      "change": _vm.upload
    }
  }), _vm._v(" "), _c('span', {
    class: {
      loading: _vm.saving
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Upload")])]), _vm._v(" "), (_vm.error) ? _c('label', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 1
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("New Invoice")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 2
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 2
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Invoices")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 3
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 3
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Overdue")])])]), _vm._v(" "), (_vm.tab === 1) ? _c('makeinvoice', {
    attrs: {
      "invoices": _vm.invoices_all
    },
    on: {
      "new": _vm.getInvoices
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 2) ? _c('invoiceList', {
    attrs: {
      "invoices": _vm.invoices_all,
      "showOverdue": false
    },
    on: {
      "del": _vm.getInvoices
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 3) ? _c('invoiceList', {
    attrs: {
      "invoices": _vm.invoices_overdue,
      "showOverdue": true
    },
    on: {
      "del": _vm.getInvoices
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('figure', {
    staticClass: "avatar avatar-sm",
    attrs: {
      "data-initial": _vm.inits
    }
  }, [(_vm.avatar) ? _c('img', {
    attrs: {
      "src": _vm.avatar
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": _vm.save
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-md-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.question.text))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer.atxt),
      expression: "answer.atxt"
    }],
    staticClass: "form-select",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "blur": _vm.save,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.answer, "atxt", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Choose a country")]), _vm._v(" "), _vm._l((_vm.countries), function(val, key) {
    return _c('option', {
      domProps: {
        "value": val
      }
    }, [_vm._v(_vm._s(key))])
  })], 2)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile-action"
  })])])
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-10"
  }, [(_vm.errMsg) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.errMsg))]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.name),
      expression: "template.name"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.template.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.fileId),
      expression: "template.fileId"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.template.fileId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "fileId", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._l((_vm.template.sections), function(s, i) {
    return _c('templateSection', {
      key: i,
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "section": s
      },
      on: {
        "delete": function($event) {
          return _vm.removeSec(i)
        },
        "moveUp": function($event) {
          return _vm.moveSec(i, -1)
        },
        "moveDown": function($event) {
          return _vm.moveSec(i, 1)
        }
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "column col-2"
  }, [_c('div', {
    staticClass: "bg-secondary docs-block"
  }, [(_vm.template.fileId) ? _c('button', {
    staticClass: "btn btn-block btn-side",
    on: {
      "click": _vm.viewTemplate
    }
  }, [_vm._v("View Template")]) : _vm._e(), _vm._v(" "), (_vm.template._id) ? _c('button', {
    staticClass: "btn btn-block btn-side",
    on: {
      "click": _vm.del
    }
  }, [_vm._v("Delete Template")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-side",
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("Add Section")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-side",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("File id")])])
}]}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.invoice) ? _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.show
    }
  }, [_c('a', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('a', {
    staticClass: "btn btn-clear float-right",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title h5"
  }, [_vm._v("Send invoice")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "input-example-3"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('quillEditor', {
    attrs: {
      "id": "editor",
      "options": _vm.editorOptions
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      loading: _vm.sending
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send($event)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), (_vm.sendError) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v("Something went wrong")]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": _vm.save
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-md-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.question.text))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-md-12"
  }, [(!_vm.show) ? _c('button', {
    staticClass: "btn btn-link dateBtn",
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.answer.atxt ? _vm.answer.atxt : 'Select a date') + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('datepicker', {
    attrs: {
      "inline": true
    },
    on: {
      "selected": _vm.selected
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }) : _vm._e()], 1)])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "matterHeader"
  }, [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-back"
  }), _c('span', [_vm._v("Back")])]), _vm._v(" "), (_vm.visatype) ? _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.matter.username) + " (" + _vm._s(_vm.matter.mattername) + ")")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-nav",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.secKey === 'notes'
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.secKey = 'notes'
      }
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.secKey === 'docs'
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.secKey = 'docs'
      }
    }
  }, [_vm._v("Documents")])]), _vm._v(" "), _vm._l((_vm.visatype.sections), function(section, key) {
    return _c('li', {
      staticClass: "tab-item",
      class: {
        active: _vm.secKey === key
      }
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.secKey = key
        }
      }
    }, [_vm._v(_vm._s(section.name))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "matterHolder"
  }, [_c('div', [(_vm.secKey === 'notes') ? _c('div', [_c('quillEditor', {
    attrs: {
      "options": _vm.editorOptions
    },
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.visatype && _vm.matter && _vm.section) ? _c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.section.subsections), function(sub) {
    return _c('div', [(_vm.visible(sub)) ? _c('div', _vm._l((_vm.subcounts[sub.ref]), function(n) {
      return _c('div', {
        staticClass: "panel",
        staticStyle: {
          "margin-top": "10px"
        }
      }, [_c('div', {
        staticClass: "panel-header"
      }, [_c('div', {
        staticClass: "panel-title"
      }, [_c('h3', [_vm._v(_vm._s(sub.name) + " "), (n > 1) ? _c('span', [_vm._v("(" + _vm._s(n) + ")")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
        staticClass: "panel-body"
      }, _vm._l((sub.questions), function(q) {
        return _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (q.dependent ? _vm.visible(q) : true),
            expression: "q.dependent ? visible(q) : true"
          }],
          key: q.ref
        }, [(q.type === 'text') ? _c('textQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'yn') ? _c('boolQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'select') ? _c('selectQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'date') ? _c('dateQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'number') ? _c('numberQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'textarea') ? _c('textareaQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'country') ? _c('countryQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'language') ? _c('languageQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : _vm._e()], 1)
      }), 0), _vm._v(" "), (sub.repeatable && n === _vm.subcounts[sub.ref]) ? _c('button', {
        staticClass: "btn btn-sm btn-primary float-right",
        staticStyle: {
          "width": "155px"
        },
        on: {
          "click": function($event) {
            return _vm.addSub(sub)
          }
        }
      }, [_c('i', {
        staticClass: "icon icon-plus"
      }), _vm._v("Add another\n              ")]) : _vm._e()])
    }), 0) : _vm._e()])
  }), 0) : (_vm.secKey === 'docs') ? _c('div', _vm._l((_vm.visatype.doctypes), function(doctype) {
    return _c('div', {
      staticClass: "panel panel-docs"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('div', {
      staticClass: "panel-title"
    }, [_vm._v("\n              " + _vm._s(doctype.name) + "\n              "), (!_vm.files[doctype.ref] || !_vm.files[doctype.ref].length) ? _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("\n                no uploads\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, _vm._l((_vm.files[doctype.ref]), function(file) {
      return _c('div', {
        staticClass: "tile tile-centered"
      }, [_c('div', {
        staticClass: "tile-icon"
      }, [_c('button', {
        staticClass: "btn btn-primary"
      }, [_c('i', {
        staticClass: "icon",
        class: [file.accepted ? 'icon-check' : 'icon-cross']
      })])]), _vm._v(" "), _c('div', {
        staticClass: "tile-content"
      }, [_c('div', {
        staticClass: "tile-title"
      }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('div', {
        staticClass: "tile-subtitle text-gray"
      }, [_vm._v(_vm._s(_vm.dateStr(file.date)))])]), _vm._v(" "), _c('div', {
        staticClass: "tile-action"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "form-switch"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (file.accepted),
          expression: "file.accepted"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(file.accepted) ? _vm._i(file.accepted, null) > -1 : (file.accepted)
        },
        on: {
          "change": [function($event) {
            var $$a = file.accepted,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(file, "accepted", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(file, "accepted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(file, "accepted", $$c)
            }
          }, _vm.saveMatter]
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "form-icon"
      }), _vm._v(" Accept\n                  ")])])])])
    }), 0)])
  }), 0) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._l((_vm.groups), function(g, i) {
    return _c('div', {
      staticClass: "panel"
    }, [_c('div', {
      staticClass: "panel-header",
      on: {
        "click": function($event) {
          return _vm.setGrp(i)
        }
      }
    }, [_c('div', {
      staticClass: "panel-title"
    }, [_vm._v(_vm._s(_vm.getTitle(g[0])))])]), _vm._v(" "), (_vm.sel_grp === i) ? _c('div', {
      staticClass: "panel-body"
    }, _vm._l((g), function(inv, j) {
      return _c('div', {
        staticClass: "tile",
        class: {
          'deleted': _vm.deleted_inv === inv._id
        }
      }, [_c('div', {
        staticClass: "tile-content"
      }, [_c('p', {
        staticClass: "tile-title"
      }), _c('div', {
        staticClass: "container c-hand"
      }, [_c('div', {
        staticClass: "columns"
      }, [_c('div', {
        staticClass: "column col-1 col-md-4",
        on: {
          "click": function($event) {
            return _vm.setInv(j)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(inv.ref) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "column col-1 col-md-4",
        on: {
          "click": function($event) {
            return _vm.setInv(j)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.date(inv.date)) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "column col-2 col-md-4",
        on: {
          "click": function($event) {
            return _vm.setInv(j)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(inv.matter_desc) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "column col-3 col-md-4"
      }, [(inv.paid) ? _c('span', {
        staticClass: "label label-success"
      }, [_vm._v("Paid"), (_vm.hasPayment(inv)) ? _c('span', [_vm._v(": " + _vm._s(_vm.date(inv.last_payment)))]) : _vm._e()]) : _c('span', {
        staticClass: "label label-warning"
      }, [_vm._v("Unpaid")])]), _vm._v(" "), _c('div', {
        staticClass: "column col-3 col-md-4"
      }, [(inv.sendError) ? _c('span', {
        staticClass: "label label-error"
      }, [_vm._v("Something went wrong")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
        staticClass: "container"
      }, [_c('div', {
        staticClass: "columns"
      }, [_c('div', {
        staticClass: "column col-12 col-md-12",
        staticStyle: {
          "padding": "1.6em 0"
        }
      }, [_c('div', {
        staticClass: "column col-12"
      }, [_c('button', {
        staticClass: "btn btn-sm",
        attrs: {
          "title": "Mark as paid/unpaid"
        },
        on: {
          "click": function($event) {
            return _vm.togglePaid(inv)
          }
        }
      }, [_vm._v("\n                      Mark as paid\n                    ")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.sendInvoice(inv)
          }
        }
      }, [_vm._v("\n                      Send invoice  "), (inv.sent) ? _c('span', {
        staticClass: "label label-success"
      }, [_c('i', {
        staticClass: "fa fa-check",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e()]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.viewPdf(inv, 'inline')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-eye",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" View Invoice\n                    ")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.viewPdf(inv, 'attachment')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Download\n                    ")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.copyLink(inv)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-clone",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Copy Link\n                    ")]), _vm._v(" "), (inv.paid) ? _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.viewReceipt(inv)
          }
        }
      }, [_vm._v("\n                      View receipt\n                    ")]) : _vm._e(), _vm._v(" "), (inv.paid) ? _c('button', {
        staticClass: "btn btn-sm",
        class: {
          loading: _vm.sending === inv
        },
        on: {
          "click": function($event) {
            return _vm.sendReceipt(inv)
          }
        }
      }, [_vm._v("\n                      Send receipt \n                    ")]) : _vm._e(), _vm._v(" "), (!inv.paid) ? _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.openPaymentModal(inv)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-credit-card",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Pay\n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.del(inv)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Delete\n                    ")])])])])]), _vm._v(" "), _c('p'), _vm._v(" "), (_vm.sel_inv === j) ? _c('div', [_c('table', {
        staticClass: "table"
      }, [_vm._m(0, true), _vm._v(" "), _c('tbody', [_vm._l((inv.items), function(item) {
        return _c('tr', [_c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(item.cost)))])])
      }), _vm._v(" "), (inv.gst) ? _c('tr', [_c('td', [_vm._v("GST (10%)")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(inv.gst)))])]) : _vm._e(), _vm._v(" "), (inv.surcharge) ? _c('tr', [_c('td', [_vm._v("Surcharge (1.4%)")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(inv.surcharge)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(inv.total)))])])], 2)]), _vm._v(" "), (inv.plan) ? _c('table', {
        staticClass: "table"
      }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Payment Plan: $" + _vm._s(_vm.c2d(inv.monthly)) + " per month")]), _vm._v(" "), _c('th', [_vm._v("Remaining: $" + _vm._s(_vm.c2d(inv.outstanding)))]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('tbody', _vm._l((_vm.payments(inv)), function(payment) {
        return _c('tr', [(inv.last_payment) ? _c('td', [_vm._v(_vm._s(payment.date))]) : _c('td', [_vm._v("Upcoming")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(payment.amount)))]), _vm._v(" "), _c('td', [(payment.paid) ? _c('span', {
          staticClass: "label label-rounded label-success"
        }, [_vm._v("Paid")]) : _c('span', {
          staticClass: "label label-rounded label-warning"
        }, [_vm._v("Scheduled")])])])
      }), 0)]) : _vm._e()]) : _vm._e()])])
    }), 0) : _vm._e()])
  }), _vm._v(" "), _c('sendModal', {
    attrs: {
      "show": _vm.showSendModal,
      "invoice": _vm.invoiceToSend
    },
    on: {
      "close": function($event) {
        _vm.showSendModal = false
      },
      "done": function($event) {
        _vm.showSendModal = false
      }
    }
  }), _vm._v(" "), _c('payModal', {
    attrs: {
      "invoice": _vm.invoiceToPay,
      "active": _vm.showPayModal
    },
    on: {
      "hide": _vm.closePaymentModal
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Item description")]), _vm._v(" "), _c('th', [_vm._v("Cost")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Status")])])
}]}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": _vm.save
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-5 col-md-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.question.text))])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 col-md-12"
  }, [_c('label', {
    staticClass: "form-radio",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quickSave('y')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer.atxt),
      expression: "answer.atxt"
    }],
    attrs: {
      "type": "radio",
      "name": _vm.question.ref,
      "value": "y"
    },
    domProps: {
      "checked": _vm._q(_vm.answer.atxt, "y")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.answer, "atxt", "y")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" Yes\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "form-radio",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quickSave('n')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer.atxt),
      expression: "answer.atxt"
    }],
    attrs: {
      "type": "radio",
      "name": _vm.question.ref,
      "value": "n"
    },
    domProps: {
      "checked": _vm._q(_vm.answer.atxt, "n")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.answer, "atxt", "n")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" No\n              ")])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-8 col-md-12"
  }, [_c('calendar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-md-12"
  }, [_c('notifications')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal",
    class: {
      active: _vm.active
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "btn btn-clear float-right",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hide
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title h5 text-center"
  }, [_vm._v("Payment Details")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns",
    staticStyle: {
      "margin": "0.8em 0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v("\n            $" + _vm._s(_vm.c2d(_vm.amount)) + "\n          ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v("\n            $" + _vm._s(_vm.c2d(_vm.stripeFee(_vm.amount))) + "\n          ")])]), _vm._v(" "), (_vm.showform) ? _c('div', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "columns",
    staticStyle: {
      "margin-top": "0.8em",
      "margin-bottom": "0.8em"
    }
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.loading
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "paybtn"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v("Submit Payment")])])])]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.cardError) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.cardError))]) : _vm._e(), _vm._v(" "), (_vm.paymentError) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.paymentError))]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Thank you for your payment")]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-12 text-center cardTypes"
  }, [_vm._v("\n            We accept\n            "), _c('i', {
    staticClass: "fa fa-cc-visa",
    attrs: {
      "apaymentError-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-cc-mastercard",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-cc-diners-club",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-cc-amex",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-5"
  }, [_c('strong', [_vm._v("Invoice amount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-5"
  }, [_c('strong', [_vm._v("Payment processing fee")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-input card-input",
    attrs: {
      "id": "card-element"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('small', [_vm._v("Your credit card information is encrypted "), _c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
}]}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-8 col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "Jane Doe"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Card")]), _vm._v(" "), _c('div', {
    staticClass: "form-input card-input",
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.amount),
      expression: "amount",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "placeholder": "100"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v("Pay Now")]), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v("😤 " + _vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("😀 Success")]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-secondary text-center"
  }, [_c('p', [_vm._v("Every transaction is encrypted and secured. "), _c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('userprofile', {
    attrs: {
      "user": _vm.user
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 0
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("New")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 1
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Agreements")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 2
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 2
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Archived")])])]), _vm._v(" "), (_vm.tab === 0) ? _c('makeagreement', {
    on: {
      "new": _vm.addAgreement
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab > 0) ? _c('div', {
    staticClass: "dataTable"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns dataTableHeader"
  }, [_c('div', {
    staticClass: "col-3 col-md-6"
  }, [_vm._v("\n          Name\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-md-5"
  }, [_vm._v("\n          Type\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 hide-md text-center"
  }, [_vm._v("\n          Sent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 hide-md text-center"
  }, [_vm._v("\n          Accepted\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 hide-xs text-center"
  }, [_vm._v("\n          Send\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 hide-xs text-center"
  }, [_vm._v("\n          PDF\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 hide-xs text-center"
  }, [_vm._v("\n          Download\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 hide-md text-center"
  }, [_vm._v("\n          " + _vm._s(_vm.tab === 1 ? 'Archive' : 'Unarchive') + "\n        ")]), _vm._v(" "), (_vm.tab === 2) ? _c('div', {
    staticClass: "col-1 hide-md text-center"
  }, [_vm._v("\n          Delete\n        ")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.filtered), function(a, n) {
    return _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "col-3 col-md-6"
    }, [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.viewPdf(a, 'inline')
        }
      }
    }, [_vm._v(_vm._s(a.corporate ? a.business : a.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-3 col-md-5"
    }, [_c('span', [_vm._v(_vm._s(a.visatype))])]), _vm._v(" "), _c('div', {
      staticClass: "col-1 hide-md text-center"
    }, [_c('i', {
      staticClass: "icon",
      class: a.sent ? 'icon-check' : 'icon-cross'
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-1 hide-md text-center"
    }, [_c('i', {
      staticClass: "icon",
      class: a.accepted ? 'icon-check' : 'icon-cross'
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-1 hide-xs text-center"
    }, [_c('button', {
      staticClass: "btn",
      class: {
        loading: _vm.sending === a._id
      },
      on: {
        "click": function($event) {
          return _vm.openSendModal(a)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-send-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-1 hide-xs text-center"
    }, [(a.pdf) ? _c('button', {
      staticClass: "btn btn-sm",
      class: {
        loading: _vm.makingPdf === a._id
      },
      on: {
        "click": function($event) {
          return _vm.makePdf(a)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-repeat",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-1 hide-xs text-center"
    }, [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.viewPdf(a, 'attachment')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-1 hide-md text-center"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.archive(a)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-archive-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), (_vm.tab === 2) ? _c('div', {
      staticClass: "col-1 hide-md text-center"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.del(a)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('sendModal', {
    attrs: {
      "show": _vm.showSendModal,
      "agreement": _vm.toSend,
      "invoice": null
    },
    on: {
      "close": _vm.closeSendModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-9"
  }, [(_vm.doc) ? _c('div', _vm._l((_vm.doc.sections), function(s, i) {
    return _c('docMakerSection', {
      key: i,
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "section": s
      }
    })
  }), 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column col-2"
  }, [_c('div', {
    staticClass: "docs-block"
  }, [_c('button', {
    staticClass: "btn btn-block btn-side",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openTemplateLink($event)
      }
    }
  }, [_vm._v("View Template")]), _vm._v(" "), (!_vm.making && _vm.newDocumentId) ? _c('button', {
    staticClass: "btn btn-block btn-side",
    class: {
      loading: _vm.exp_word
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportDoc('word')
      }
    }
  }, [_vm._v("Export Word")]) : _vm._e(), _vm._v(" "), (!_vm.making && _vm.newDocumentId) ? _c('button', {
    staticClass: "btn btn-block btn-side",
    class: {
      loading: _vm.exp_pdf
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportDoc('pdf')
      }
    }
  }, [_vm._v("Export PDF")]) : _vm._e(), _vm._v(" "), (!_vm.making && _vm.newDocumentId) ? _c('button', {
    staticClass: "btn btn-block btn-side",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSendModal = true
      }
    }
  }, [_vm._v("Dispatch")]) : _vm._e(), _vm._v(" "), (!_vm.making && _vm.newDocumentId) ? _c('button', {
    staticClass: "btn btn-block btn-side docComplete",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openDocLink($event)
      }
    }
  }, [_vm._v("View")]) : _vm._e(), _vm._v(" "), (_vm.doc) ? _c('button', {
    staticClass: "btn btn-block btn-side btn-primary",
    class: {
      'loading': _vm.making
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.make($event)
      }
    }
  }, [_vm._v("Make")]) : _vm._e()])])]), _vm._v(" "), _c('dispatchModal', {
    attrs: {
      "show": _vm.showSendModal,
      "doc": _vm.doc,
      "fileId": _vm.newDocumentId,
      "user": _vm.user
    },
    on: {
      "close": function($event) {
        _vm.showSendModal = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(this.section) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.pretty_name),
      expression: "section.pretty_name"
    }],
    staticClass: "form-input input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.section.pretty_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.section, "pretty_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm input-group-btn",
    on: {
      "click": function($event) {
        _vm.hidden = !_vm.hidden
      }
    }
  }, [_c('i', {
    staticClass: "icon",
    class: {
      'icon-arrow-down': _vm.hidden, 'icon-arrow-up': !_vm.hidden
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm input-group-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('delete')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-delete"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm input-group-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('moveUp')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-upward"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm input-group-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('moveDown')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-downward"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidden),
      expression: "!hidden"
    }],
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-9 col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.name),
      expression: "section.name"
    }],
    staticClass: "form-input input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.section.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.section, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-9 col-sm-12"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.display),
      expression: "section.display"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.section.display) ? _vm._i(_vm.section.display, null) > -1 : (_vm.section.display)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.section.display,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.section, "display", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.section, "display", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.section, "display", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-9 col-sm-12 innerInput"
  }, [_vm._l((_vm.section.fields), function(field, i) {
    return _c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.name),
        expression: "field.name"
      }],
      staticClass: "form-input input-sm",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (field.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(field, "name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.tag),
        expression: "field.tag"
      }],
      staticClass: "form-input input-sm",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (field.tag)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(field, "tag", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm input-group-btn",
      on: {
        "click": function($event) {
          return _vm.removeField(i)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-minus"
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-special",
    on: {
      "click": function($event) {
        return _vm.section.fields.push({
          name: 'name',
          tag: '{{tag}}'
        })
      }
    }
  }, [_vm._v("\n                Add "), _c('i', {
    staticClass: "icon icon-plus"
  })])], 2)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Name in template")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Display by default")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n              Fields\n              \n            ")])])
}]}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.to_editor === 'true') ? _c('ul', {
    staticClass: "docCreation"
  }, _vm._l((_vm.types), function(t) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/docs/edit/false/' + t._id
      }
    }, [_vm._v(_vm._s(t.name))])], 1)
  }), 0) : _c('ul', {
    staticClass: "docCreation"
  }, _vm._l((_vm.types), function(t) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/docs/make/' + t._id + '/' + _vm.matter_id
      }
    }, [_vm._v(_vm._s(t.name))])], 1)
  }), 0), _vm._v(" "), (_vm.to_editor === 'true') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "left",
      "clear": "both"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/docs/edit/true/' + _vm.matter_type
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  }), _vm._v(" New")])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-2 col-xs-12 col-sm-12 col-md-4 col-lg-2 col-xl-2"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  }), _vm._v("Create new matter")])]), _vm._v(" "), _c('div', {
    staticClass: "column col-6 col-xs-12 col-sm-12 col-md-4 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Filter")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column col-4 col-xs-12 col-sm-12 col-md-4 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showArchived),
      expression: "showArchived"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showArchived) ? _vm._i(_vm.showArchived, null) > -1 : (_vm.showArchived)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showArchived,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showArchived = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showArchived = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showArchived = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" Show Archived\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('matter-table', {
    attrs: {
      "rows": _vm.matters,
      "filter": _vm.filter,
      "showArchived": _vm.showArchived
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showModal
    },
    attrs: {
      "id": "editMatter"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "btn btn-clear float-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleModal($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title h4"
  }, [_vm._v("Create a new matter")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow": "visible"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('searchClients', {
    on: {
      "selected": _vm.selectClient
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedVisatype),
      expression: "selectedVisatype"
    }],
    staticClass: "form-select",
    attrs: {
      "id": "editqtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedVisatype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.visatypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type
      }
    }, [_vm._v(_vm._s(type.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.makeNewMatter($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.newMatterErr) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.newMatterErr))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Client")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "editqtype"
    }
  }, [_vm._v("Type")])])
}]}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(!_vm.results) ? _c('div', {
    staticClass: "empty"
  }, [_c('p', {
    staticClass: "empty-title h5"
  }, [_vm._v("There are no VEVO results for this client")]), _vm._v(" "), (!_vm.validProfile) ? _c('div', [_c('dl', [(!_vm.okDOB) ? _c('dt', [_vm._v("Invalid date of birth")]) : _vm._e(), _vm._v(" "), (!_vm.okCountry) ? _c('dt', [_vm._v("No country")]) : _vm._e(), _vm._v(" "), (!_vm.okPassport) ? _c('dt', [_vm._v("No passport number")]) : _vm._e()])]) : _c('div', {
    staticClass: "empty-action"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Perform search")])])]) : _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_vm._v("Date of search")]), _vm._v(" "), _c('div', {
    staticClass: "col-9 col-sm-12"
  }, [_vm._v(_vm._s(new Date(_vm.results.date).toLocaleDateString('en-gb')))])]), _vm._v(" "), _vm._l((_vm.resultFields), function(desc, field) {
    return _c('div', {
      staticClass: "columns"
    }, [(_vm.results[field]) ? _c('div', {
      staticClass: "col-3 col-sm-12"
    }, [_vm._v(_vm._s(desc))]) : _vm._e(), _vm._v(" "), (_vm.results[field]) ? _c('div', {
      staticClass: "col-9 col-sm-12"
    }, [_vm._v(_vm._s(_vm.results[field]))]) : _vm._e()])
  }), _vm._v(" "), (_vm.results.conditions) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_vm._v("Visa conditions")]), _vm._v(" "), _c('div', {
    staticClass: "col-9 col-sm-12"
  }, _vm._l((_vm.results.conditions), function(c) {
    return _c('div', {
      domProps: {
        "innerHTML": _vm._s(c)
      }
    })
  }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Update results")]), _vm._v(" "), (_vm.showCalMsg) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Expiry date in calendar")]) : _vm._e()], 2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.message) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), (_vm.errormsg) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.errormsg))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.user) ? _c('div', [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-back"
  }), _c('span', [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.user) ? _c('div', [_c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    staticClass: "tab-item"
  }, [_c('a', {
    class: {
      active: _vm.tab === 0
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 0
      }
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), (_vm.isClient) ? _c('li', {
    staticClass: "tab-item"
  }, [_c('a', {
    class: {
      active: _vm.tab === 1
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 1
      }
    }
  }, [_vm._v("Matters")])]) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('li', {
    staticClass: "tab-item"
  }, [_c('a', {
    class: {
      active: _vm.tab === 2
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 2
      }
    }
  }, [_vm._v("VEVO")])]) : _vm._e()]), _vm._v(" "), (_vm.tab === 0) ? _c('userProfile', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('clientMatters', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 2) ? _c('clientVevo', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    class: {
      visible: _vm.active
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.brand === 'pl') ? _c('img', {
    attrs: {
      "src": __webpack_require__(215),
      "alt": "PocketLegal"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('img', {
    attrs: {
      "src": __webpack_require__(35),
      "alt": "Immigration Experts"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('ul', {
    staticClass: "menu"
  }, [_c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/#"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/userlist/admin/"
    }
  }, [_vm._v("Team")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/userlist/client/"
    }
  }, [_vm._v("Clients")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/visatypes/"
    }
  }, [_vm._v("Matter Types")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item",
    class: {
      activated: _vm.inEditor
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/docs/choosecategory/true/none"
    }
  }, [_vm._v("Document Editor")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/matters/"
    }
  }, [_vm._v("Matters")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/accounts/"
    }
  }, [_vm._v("Accounts")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/agreements/"
    }
  }, [_vm._v("Cost Agreements")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/pay/"
    }
  }, [_vm._v("Payment")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/vevo/"
    }
  }, [_vm._v("VEVO")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item mobileOnly",
    on: {
      "click": _vm.logout
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Logout")])])]) : _c('ul', {
    staticClass: "menu"
  }, [_c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/clienthome"
    }
  }, [_vm._v("\n          Home\n        ")])], 1), _vm._v(" "), _vm._l((_vm.matters), function(m, i) {
    return _c('li', {
      staticClass: "menu-item"
    }, [_c('router-link', {
      attrs: {
        "to": '/client-matter/' + i
      }
    }, [_vm._v("\n          Questions")])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/documents"
    }
  }, [_vm._v("\n          Documents\n        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/invoices"
    }
  }, [_vm._v("\n          Invoices\n        ")])], 1), _vm._v(" "), (_vm.agreement) ? _c('li', {
    staticClass: "menu-item"
  }, [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.viewAgreement
    }
  }, [_vm._v("Costs Agreement")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "menu-item mobileOnly",
    on: {
      "click": _vm.logout
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n        Logout")])])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "column col-6 col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-8"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('searchClients', {
    on: {
      "selected": _vm.selectClient
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoice.matter_desc),
      expression: "invoice.matter_desc"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.invoice, "matter_desc", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.visatypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type.name
      }
    }, [_vm._v(_vm._s(type.name))])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.user && _vm.user.stripe_id) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column col-7 col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8"
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instant_payment),
      expression: "instant_payment"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.instant_payment) ? _vm._i(_vm.instant_payment, null) > -1 : (_vm.instant_payment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.instant_payment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.instant_payment = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.instant_payment = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.instant_payment = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "column col-8 col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.no_gst),
      expression: "no_gst"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.no_gst) ? _vm._i(_vm.no_gst, null) > -1 : (_vm.no_gst)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.no_gst,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.no_gst = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.no_gst = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.no_gst = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.description),
      expression: "newItem.description"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newItem, "description", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.selItem]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.descriptions), function(d) {
    return _c('option', {
      domProps: {
        "value": d
      }
    }, [_vm._v(_vm._s(d))])
  })], 2)]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newItem.cost),
      expression: "newItem.cost",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.newItem.cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "cost", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItem($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  })])])]), _vm._v(" "), _vm._l((_vm.invoice.items), function(item, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(item.cost)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.delItem(i)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-minus"
    })])])])
  }), _vm._v(" "), (_vm.totals[0]) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("GST")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.totals[0])))])]) : _vm._e(), _vm._v(" "), (_vm.totals[1]) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Surcharge")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.totals[1])))])]) : _vm._e(), _vm._v(" "), (_vm.totals[2]) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.totals[2])))])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "column col-8 col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8"
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan),
      expression: "plan"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.plan) ? _vm._i(_vm.plan, null) > -1 : (_vm.plan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plan = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "column col-6 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
  }, [(_vm.plan) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Initial payment $")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.plan_initial),
      expression: "plan_initial",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.plan_initial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan_initial = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column col-6 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
  }, [(_vm.plan) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Monthly payment $")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.plan_monthly),
      expression: "plan_monthly",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.plan_monthly)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan_monthly = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(!_vm.success) ? _c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.isLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.make($event)
      }
    }
  }, [_vm._v("Make")]) : _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Success")]), _vm._v(" "), (_vm.errormsg) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.errormsg))]) : _vm._e(), _vm._v(" "), (_vm.newInvoice) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSendModal = true
      }
    }
  }, [_vm._v("Send")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Clear")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.othermodal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Item description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDesc),
      expression: "newDesc"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.newDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.surcharge),
      expression: "newItem.surcharge"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newItem.surcharge) ? _vm._i(_vm.newItem.surcharge, null) > -1 : (_vm.newItem.surcharge)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newItem.surcharge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newItem, "surcharge", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newItem, "surcharge", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newItem, "surcharge", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" Surcharge\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addDesc($event)
      }
    }
  }, [_vm._v("Done")])])])]), _vm._v(" "), _c('sendModal', {
    attrs: {
      "show": _vm.showSendModal,
      "invoice": _vm.newInvoice
    },
    on: {
      "close": function($event) {
        _vm.showSendModal = false
      },
      "done": _vm.reset
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Client")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Matter description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-3 col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Instant payment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-4 col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("No GST")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Cost")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-4 col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Payment plan")])])
}]}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "panel1"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel2"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Welcome!")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.forgot) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.forgot) ? _c('button', {
    staticClass: "btn btn-primary btn-block",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Sign In")]) : _c('button', {
    staticClass: "btn btn-primary btn-block",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("\n        Reset password\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btn-block",
    on: {
      "click": function($event) {
        _vm.forgot = !_vm.forgot;
        _vm.error = ''
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.forgot ? 'Back' : 'Forgot password?') + "\n      ")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "toast toast-error",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.msg) ? _c('div', {
    staticClass: "toast toast-success",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.msg))])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-8 col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Family name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.familyName),
      expression: "familyName"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.familyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.familyName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Given name(s)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.givenName),
      expression: "givenName"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.givenName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.givenName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Date of birth")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-2 col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_d),
      expression: "dob_d"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "placeholder": "DD"
    },
    domProps: {
      "value": (_vm.dob_d)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_d = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column col-2 col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_m),
      expression: "dob_m"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "placeholder": "MM"
    },
    domProps: {
      "value": (_vm.dob_m)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_m = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column col-3 col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_y),
      expression: "dob_y"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "placeholder": "YYYY"
    },
    domProps: {
      "value": (_vm.dob_y)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_y = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Passport Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.docNumber),
      expression: "docNumber"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.docNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.docNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label text-bold"
  }, [_vm._v("Document country")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.docCountry),
      expression: "docCountry"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.docCountry = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countries), function(v, k) {
    return _c('option', {
      domProps: {
        "value": v
      }
    }, [_vm._v(_vm._s(k))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "column col-8 col-md-12"
  }, [(_vm.results && _vm.results.success) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "card-title h5"
  }, [_vm._v("Results")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._l((_vm.resultFields), function(desc, field) {
    return _c('div', {
      staticClass: "columns"
    }, [(_vm.results[field]) ? _c('div', {
      staticClass: "col-3 col-sm-12"
    }, [_vm._v(_vm._s(desc))]) : _vm._e(), _vm._v(" "), (_vm.results[field]) ? _c('div', {
      staticClass: "col-9 col-sm-12"
    }, [_vm._v(_vm._s(_vm.results[field]))]) : _vm._e()])
  }), _vm._v(" "), (_vm.results.conditions) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_vm._v("Visa conditions")]), _vm._v(" "), _c('div', {
    staticClass: "col-9 col-sm-12"
  }, _vm._l((_vm.results.conditions), function(c) {
    return _c('div', {
      domProps: {
        "innerHTML": _vm._s(c)
      }
    })
  }), 0)]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.results && _vm.results.message) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.results.message))]) : _vm._e(), _vm._v(" "), (_vm.errormsg) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.errormsg))]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-secondary text-center"
  }, [_c('p', [_vm._v("Visa Entitlement Verification Online - check visa details and conditions.")])])
}]}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.visatype) ? _c('div', {
    staticClass: "panel-nav",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.sections), function(section, key) {
    return _c('li', {
      staticClass: "tab-item",
      class: {
        active: _vm.secKey === key
      }
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.secKey = key
        }
      }
    }, [_vm._v(_vm._s(section.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "matterHolder"
  }, [(_vm.visatype && _vm.matter && _vm.section) ? _c('div', _vm._l((_vm.section.subsections), function(sub) {
    return _c('div', [(_vm.showSub(sub)) ? _c('div', _vm._l((_vm.subcounts[sub.ref]), function(n) {
      return _c('div', {
        staticClass: "panel",
        staticStyle: {
          "margin-top": "10px"
        }
      }, [_c('div', {
        staticClass: "panel-header"
      }, [_c('div', {
        staticClass: "panel-title"
      }, [_c('h3', [_vm._v(_vm._s(sub.name) + " "), (n > 1) ? _c('span', [_vm._v("(" + _vm._s(n) + ")")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
        staticClass: "panel-body"
      }, _vm._l((sub.questions), function(q) {
        return _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showQ(q)),
            expression: "showQ(q)"
          }],
          key: q.ref
        }, [(q.type === 'text') ? _c('textQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'yn') ? _c('boolQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'select') ? _c('selectQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'date') ? _c('dateQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'number') ? _c('numberQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'textarea') ? _c('textareaQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'country') ? _c('countryQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'language') ? _c('languageQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : _vm._e()], 1)
      }), 0), _vm._v(" "), (sub.repeatable && n === _vm.subcounts[sub.ref]) ? _c('button', {
        staticClass: "btn btn-sm btn-primary float-right",
        staticStyle: {
          "width": "155px"
        },
        on: {
          "click": function($event) {
            return _vm.addSub(sub)
          }
        }
      }, [_c('i', {
        staticClass: "icon icon-plus"
      }), _vm._v("Add another\n            ")]) : _vm._e()])
    }), 0) : _vm._e()])
  }), 0) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": _vm.save
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-md-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.question.text))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer.atxt),
      expression: "answer.atxt"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "textarea"
    },
    domProps: {
      "value": (_vm.answer.atxt)
    },
    on: {
      "blur": _vm.save,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.answer, "atxt", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile-action"
  })])])
},staticRenderFns: []}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": _vm.save
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-md-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.question.text))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer.atxt),
      expression: "answer.atxt"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.answer.atxt)
    },
    on: {
      "blur": _vm.save,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.answer, "atxt", $event.target.value)
      }
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "notifiCate"
  }, [_vm._v("Notifications")]), _vm._v(" "), _vm._l((_vm.notifications), function(n) {
    return _c('div', {
      staticClass: "tile tile-notification",
      class: {
        hidden: n.hidden
      }
    }, [_c('div', {
      staticClass: "tile-icon"
    }, [_c('router-link', {
      attrs: {
        "to": '/users/' + n.aboutUser._id
      }
    }, [_c('avatar', {
      key: n.aboutUser._id,
      attrs: {
        "user": n.aboutUser
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "tile-content"
    }, [_c('div', {
      staticClass: "tile-title"
    }, [_vm._v("\n        " + _vm._s(n.aboutUser.profile.corporate ?
      n.aboutUser.profile.business :
      n.aboutUser.profile.firstname + ' ' + n.aboutUser.profile.lastname) + "\n        "), _c('span', {
      staticStyle: {
        "font-size": "0.8em",
        "float": "right"
      }
    }, [_vm._v(_vm._s(new Date(n.date).toLocaleDateString('en-GB')))])]), _vm._v(" "), _c('div', {
      staticClass: "tile-subtitle text-gray"
    }, [_vm._v(_vm._s(n.content))])]), _vm._v(" "), _c('div', {
      staticClass: "tile-action"
    }, [_c('button', {
      staticClass: "btn btn-clear float-right",
      on: {
        "click": function($event) {
          return _vm.del(n)
        }
      }
    })])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-link",
    attrs: {
      "to": '/newUser/' + _vm.usertype
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  }), _vm._v("Create new " + _vm._s(_vm.usertype) + "\n  ")]), _vm._v(" "), (_vm.usertype === 'admin') ? _c('div', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.usertype === 'client') ? _c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 0
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Clients")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 1
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Prospects")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 2
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 2
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Archived")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.userlist), function(user, key) {
    return _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column col-1 col-md-2"
    }, [_c('router-link', {
      attrs: {
        "to": '/users/' + user._id,
        "user": user
      }
    }, [_c('avatar', {
      key: user._id,
      attrs: {
        "user": user
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "column col-11 col-md-10"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column col-4 col-md-12"
    }, [_c('router-link', {
      attrs: {
        "to": '/users/' + user._id
      }
    }, [_vm._v("\n              " + _vm._s(user.profile.corporate ? user.profile.business : user.profile.firstname + ' ' + user.profile.lastname) + "\n            ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "column col-4 col-md-12"
    }, [_c('a', {
      attrs: {
        "href": ("mailto:" + (user.email))
      }
    }, [_vm._v(_vm._s(user.email))])]), _vm._v(" "), _c('div', {
      staticClass: "column col-4 col-md-12"
    }, [_c('a', {
      attrs: {
        "href": ("tel:" + (user.profile.phone))
      }
    }, [_vm._v(_vm._s(user.profile.phone))])])])])])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": _vm.save
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-md-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.question.text))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer.atxt),
      expression: "answer.atxt"
    }],
    staticClass: "form-select",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "blur": _vm.save,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.answer, "atxt", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a language")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6513A"
    }
  }, [_vm._v("Acehnese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7999E"
    }
  }, [_vm._v("Achang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9201A"
    }
  }, [_vm._v("Acholi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8601A"
    }
  }, [_vm._v("Adnymathanha (Yura Ngawarla)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AY"
    }
  }, [_vm._v("Afar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100B"
    }
  }, [_vm._v("Afghan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299A"
    }
  }, [_vm._v("African Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9200A"
    }
  }, [_vm._v("African Languages, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1403A"
    }
  }, [_vm._v("Afrikaans")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9203A"
    }
  }, [_vm._v("Akan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3901A"
    }
  }, [_vm._v("Albanian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8201A"
    }
  }, [_vm._v("Alyawarr (Alyawarra)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9101A"
    }
  }, [_vm._v("American Languages")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9214A"
    }
  }, [_vm._v("Amharic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8101A"
    }
  }, [_vm._v("Anindilyakwa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8202A"
    }
  }, [_vm._v("Anmatyerr (Anmatyirra)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AQ"
    }
  }, [_vm._v("Anuak")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8602A"
    }
  }, [_vm._v("Arabana (Arabuna)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4202A"
    }
  }, [_vm._v("Arabic (Including Lebanese)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AM"
    }
  }, [_vm._v("Arabic, Sudanese Creole")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999C"
    }
  }, [_vm._v("Arakanese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3902A"
    }
  }, [_vm._v("Armenian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3903A"
    }
  }, [_vm._v("Aromunian (Macedo-Romanian)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8203A"
    }
  }, [_vm._v("Arrente (Aranda)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9204A"
    }
  }, [_vm._v("Asante")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100C"
    }
  }, [_vm._v("Ashkun")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5213A"
    }
  }, [_vm._v("Assamese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4203A"
    }
  }, [_vm._v("Assyrian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4206A"
    }
  }, [_vm._v("Assyrian Neo-Aramaic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9701A"
    }
  }, [_vm._v("Auslan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8700A"
    }
  }, [_vm._v("Australian Creoles (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8000A"
    }
  }, [_vm._v("Australian Indigenous/Aboriginal (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4302A"
    }
  }, [_vm._v("Azeri")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6514A"
    }
  }, [_vm._v("Balinese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4104A"
    }
  }, [_vm._v("Balochi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3100A"
    }
  }, [_vm._v("Baltic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8204A"
    }
  }, [_vm._v("Bardi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299H"
    }
  }, [_vm._v("Bari")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2901A"
    }
  }, [_vm._v("Basque")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299I"
    }
  }, [_vm._v("Bassa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3401A"
    }
  }, [_vm._v("Belorussian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9215A"
    }
  }, [_vm._v("Bemba")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AD"
    }
  }, [_vm._v("Bembe")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5201A"
    }
  }, [_vm._v("Bengali")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6515A"
    }
  }, [_vm._v("Bikol")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6501A"
    }
  }, [_vm._v("Bisaya/Visaya")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9402A"
    }
  }, [_vm._v("Bislama")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3501A"
    }
  }, [_vm._v("Bosnian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3502A"
    }
  }, [_vm._v("Bulgarian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8205A"
    }
  }, [_vm._v("Bunuba (Bunaba)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8102A"
    }
  }, [_vm._v("Burarra")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6100A"
    }
  }, [_vm._v("Burmese and Related Languages")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7101A"
    }
  }, [_vm._v("Cantonese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8399A"
    }
  }, [_vm._v("Cape York Pen Aboriginal (NEC)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8300A"
    }
  }, [_vm._v("Cape York Pen Aboriginal (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2301A"
    }
  }, [_vm._v("Catalan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6502A"
    }
  }, [_vm._v("Cebuano")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1199A"
    }
  }, [_vm._v("Celtic, nec ( Breton, Cornish, Manz)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1100A"
    }
  }, [_vm._v("Celtic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8299A"
    }
  }, [_vm._v("Central Aboriginal (NEC)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8200A"
    }
  }, [_vm._v("Central Aboriginal (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4299B"
    }
  }, [_vm._v("Chaldaean")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4203B"
    }
  }, [_vm._v("Chaldean Neo-Aramaic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AV"
    }
  }, [_vm._v("Chiga")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7100B"
    }
  }, [_vm._v("Chin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69996"
    }
  }, [_vm._v("Chin Daai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999E"
    }
  }, [_vm._v("Chin Falam")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999D"
    }
  }, [_vm._v("Chin Haka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999F"
    }
  }, [_vm._v("Chin Khumi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999G"
    }
  }, [_vm._v("Chin Mara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999H"
    }
  }, [_vm._v("Chin Mro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999I"
    }
  }, [_vm._v("Chin Mun")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999J"
    }
  }, [_vm._v("Chin Ngawn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999K"
    }
  }, [_vm._v("Chin Senthang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999L"
    }
  }, [_vm._v("Chin Teddim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999M"
    }
  }, [_vm._v("Chin Thado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999N"
    }
  }, [_vm._v("Chin Zome")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999O"
    }
  }, [_vm._v("Chin Zotong")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7199A"
    }
  }, [_vm._v("Chinese, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7100A"
    }
  }, [_vm._v("Chinese, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9209A"
    }
  }, [_vm._v("Comorian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3503A"
    }
  }, [_vm._v("Croatian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3601A"
    }
  }, [_vm._v("Czech")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3604A"
    }
  }, [_vm._v("Czechoslovakian, so described")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299C"
    }
  }, [_vm._v("Dagbani")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AO"
    }
  }, [_vm._v("Daju, Dar Daju")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AP"
    }
  }, [_vm._v("Daju, Dar Sila")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1501A"
    }
  }, [_vm._v("Danish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4105A"
    }
  }, [_vm._v("Dari")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8103A"
    }
  }, [_vm._v("Dhaangu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8104A"
    }
  }, [_vm._v("Dhayyi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5214A"
    }
  }, [_vm._v("Dhivehi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8105A"
    }
  }, [_vm._v("Dhuwal-Dhuwala")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9216A"
    }
  }, [_vm._v("Dinka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8106A"
    }
  }, [_vm._v("Djinang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5199A"
    }
  }, [_vm._v("Dravidian, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5100A"
    }
  }, [_vm._v("Dravidian, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1401A"
    }
  }, [_vm._v("Dutch")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7999B"
    }
  }, [_vm._v("Dzonkha")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7000A"
    }
  }, [_vm._v("EASTERN ASIAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3000A"
    }
  }, [_vm._v("EASTERN EUROPEAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3400A"
    }
  }, [_vm._v("East Slavic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8699A"
    }
  }, [_vm._v("Eastern Aboriginal (NEC)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8600A"
    }
  }, [_vm._v("Eastern Aboriginal (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6199C"
    }
  }, [_vm._v("Eastern Kayah")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1201A"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1601A"
    }
  }, [_vm._v("Estonian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9217A"
    }
  }, [_vm._v("Ewe")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1599B"
    }
  }, [_vm._v("Faeroese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9301A"
    }
  }, [_vm._v("Fijian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5217A"
    }
  }, [_vm._v("Fijian Hindustani")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6512A"
    }
  }, [_vm._v("Filipino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3299A"
    }
  }, [_vm._v("Finnic, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3200A"
    }
  }, [_vm._v("Finnic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1602A"
    }
  }, [_vm._v("Finnish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1401C"
    }
  }, [_vm._v("Flemish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AB"
    }
  }, [_vm._v("Fon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2101A"
    }
  }, [_vm._v("French")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1402A"
    }
  }, [_vm._v("Frisian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9245A"
    }
  }, [_vm._v("Fulfulde")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AE"
    }
  }, [_vm._v("Fuliiru")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299F"
    }
  }, [_vm._v("Fullah")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AR"
    }
  }, [_vm._v("Fur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9218A"
    }
  }, [_vm._v("Ga")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1101A"
    }
  }, [_vm._v("Gaelic (Scotland)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4902A"
    }
  }, [_vm._v("Georgian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1301A"
    }
  }, [_vm._v("German")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9302A"
    }
  }, [_vm._v("Gilbertese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299K"
    }
  }, [_vm._v("Gio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299L"
    }
  }, [_vm._v("Grebo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2201A"
    }
  }, [_vm._v("Greek")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8301A"
    }
  }, [_vm._v("Gugu Yalanji")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5202A"
    }
  }, [_vm._v("Gujarati")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8302A"
    }
  }, [_vm._v("Guugu Yimidhirr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299G"
    }
  }, [_vm._v("Hadiyigna")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6102A"
    }
  }, [_vm._v("Haka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7102A"
    }
  }, [_vm._v("Hakka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9221A"
    }
  }, [_vm._v("Harari")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9222A"
    }
  }, [_vm._v("Hausa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9404A"
    }
  }, [_vm._v("Hawaiian English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100G"
    }
  }, [_vm._v("Hazaragi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4204A"
    }
  }, [_vm._v("Hebrew")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92993"
    }
  }, [_vm._v("Hemba")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5203A",
      "selected": "selected"
    }
  }, [_vm._v("Hindi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6201A"
    }
  }, [_vm._v("Hmong")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6299A"
    }
  }, [_vm._v("Hmong-Mien, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6200A"
    }
  }, [_vm._v("Hmong-Mien, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7103A"
    }
  }, [_vm._v("Hokkien")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999P"
    }
  }, [_vm._v("Hpon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3301A"
    }
  }, [_vm._v("Hungarian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6516A"
    }
  }, [_vm._v("Iban")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2399A"
    }
  }, [_vm._v("Iberian Romance, nec (includes Crioulo, Galaician, Ladino)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2300A"
    }
  }, [_vm._v("Iberian Romance, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1502A"
    }
  }, [_vm._v("Icelandic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9223A"
    }
  }, [_vm._v("Igbo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6503A"
    }
  }, [_vm._v("Iiokano")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6517A"
    }
  }, [_vm._v("Ilonggo (Hiligaynon)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0000A"
    }
  }, [_vm._v("Inadequately Described")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5000B"
    }
  }, [_vm._v("Indian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5299A"
    }
  }, [_vm._v("Indo-Aryan, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5200A"
    }
  }, [_vm._v("Indo-Aryan, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6504A"
    }
  }, [_vm._v("Indonesian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9601A"
    }
  }, [_vm._v("Invented Languages")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4199A"
    }
  }, [_vm._v("Iranic, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100A"
    }
  }, [_vm._v("Iranic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1102A"
    }
  }, [_vm._v("Irish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2401A"
    }
  }, [_vm._v("Italian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7201A"
    }
  }, [_vm._v("Japanese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8206A"
    }
  }, [_vm._v("Jaru (Djaru)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6518A"
    }
  }, [_vm._v("Javanese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AG"
    }
  }, [_vm._v("Joba")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6199B"
    }
  }, [_vm._v("Kachin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299M"
    }
  }, [_vm._v("Kakwa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8401A"
    }
  }, [_vm._v("Kalaw Lagaw Ya (Kalaw Kawa Ya)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5101A"
    }
  }, [_vm._v("Kannada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6103A"
    }
  }, [_vm._v("Karen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999Q"
    }
  }, [_vm._v("Karen Brek")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999R"
    }
  }, [_vm._v("Karen Bwe")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999S"
    }
  }, [_vm._v("Karen Gebe")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999T"
    }
  }, [_vm._v("Karen Geko")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999U"
    }
  }, [_vm._v("Karen Manumanaw")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999V"
    }
  }, [_vm._v("Karen Paku")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999W"
    }
  }, [_vm._v("Karen Pwo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999X"
    }
  }, [_vm._v("Karen S'gaw")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999Y"
    }
  }, [_vm._v("Karen Yinbaw")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999Z"
    }
  }, [_vm._v("Karen Yintale")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69991"
    }
  }, [_vm._v("Karen Zayein")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8107A"
    }
  }, [_vm._v("Karrwa (Garrwa, Garawa)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5215A"
    }
  }, [_vm._v("Kashmiri")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100D"
    }
  }, [_vm._v("Kati")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4399B"
    }
  }, [_vm._v("Kazakh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6301A"
    }
  }, [_vm._v("Khmer/Cambodian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8207A"
    }
  }, [_vm._v("Kija (Gidya)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9224A"
    }
  }, [_vm._v("Kikuyu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299N"
    }
  }, [_vm._v("Kinyarwanda / Rwanda")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299O"
    }
  }, [_vm._v("Kirundi / Nyarwandwa / Rundi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299P"
    }
  }, [_vm._v("Kissi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9502A"
    }
  }, [_vm._v("Kiwai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5204A"
    }
  }, [_vm._v("Konkani")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92990"
    }
  }, [_vm._v("Kono (Sierra Leone)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AF"
    }
  }, [_vm._v("Koongo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7301A"
    }
  }, [_vm._v("Korean")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299Q"
    }
  }, [_vm._v("Kpelle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299R"
    }
  }, [_vm._v("Krahn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9205B"
    }
  }, [_vm._v("Kreole / Creole (African)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8701B"
    }
  }, [_vm._v("Krieole")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9225A"
    }
  }, [_vm._v("Krio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8701A"
    }
  }, [_vm._v("Kriol")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299S"
    }
  }, [_vm._v("Kru")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8212A"
    }
  }, [_vm._v("Kukatha (Gugaja)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8211A"
    }
  }, [_vm._v("Kukatha (Kokatha, Gugada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299T"
    }
  }, [_vm._v("Kuku")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8108A"
    }
  }, [_vm._v("Kunwinjku (Gunwinggu)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92994"
    }
  }, [_vm._v("Kuranko")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4101A"
    }
  }, [_vm._v("Kurdish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8303A"
    }
  }, [_vm._v("Kuuku-Yau")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8208A"
    }
  }, [_vm._v("Kuurinji (Gurindji)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AT"
    }
  }, [_vm._v("Laka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AW"
    }
  }, [_vm._v("Lango")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6401A"
    }
  }, [_vm._v("Lao")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69992"
    }
  }, [_vm._v("Lashi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2902A"
    }
  }, [_vm._v("Latin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3101A"
    }
  }, [_vm._v("Latvian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1302A"
    }
  }, [_vm._v("Letzeburgish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AA"
    }
  }, [_vm._v("Liberian English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299U"
    }
  }, [_vm._v("Limba")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92992"
    }
  }, [_vm._v("Lingala")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7999F"
    }
  }, [_vm._v("Lisu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3102A"
    }
  }, [_vm._v("Lithuanian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92995"
    }
  }, [_vm._v("Loko")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92996"
    }
  }, [_vm._v("Lokoya")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299V"
    }
  }, [_vm._v("Loma / Lorma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AK"
    }
  }, [_vm._v("Luba-Kasai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9226A"
    }
  }, [_vm._v("Luganda / Ganda")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9254A"
    }
  }, [_vm._v("Lumun (Kuku Lumun)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9227A"
    }
  }, [_vm._v("Luo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92997"
    }
  }, [_vm._v("Luwo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3504A"
    }
  }, [_vm._v("Macedonian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299E"
    }
  }, [_vm._v("Madi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9702A"
    }
  }, [_vm._v("Makaton")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6505A"
    }
  }, [_vm._v("Malay")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5102A"
    }
  }, [_vm._v("Malayalam")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2501A"
    }
  }, [_vm._v("Maltese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4208A"
    }
  }, [_vm._v("Mandaean (Mandaic)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7104A"
    }
  }, [_vm._v("Mandarin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299W"
    }
  }, [_vm._v("Mandingo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299X"
    }
  }, [_vm._v("Mano")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9303A"
    }
  }, [_vm._v("Maori (Cook Island)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9304A"
    }
  }, [_vm._v("Maori (New Zealand)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5205A"
    }
  }, [_vm._v("Marathi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69993"
    }
  }, [_vm._v("Maru")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8111A"
    }
  }, [_vm._v("Maung")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9205A"
    }
  }, [_vm._v("Mauritian Creole")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299Y"
    }
  }, [_vm._v("Mende")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8402A"
    }
  }, [_vm._v("Meryam Mir")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4299A"
    }
  }, [_vm._v("Middle Eastern Semitic Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4200A"
    }
  }, [_vm._v("Middle Eastern Semitic Languages, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7107A"
    }
  }, [_vm._v("Min Nan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AC"
    }
  }, [_vm._v("Mina")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8213A"
    }
  }, [_vm._v("Miriwoong")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6303A"
    }
  }, [_vm._v("Mon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6399A"
    }
  }, [_vm._v("Mon-Khmer, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6300A"
    }
  }, [_vm._v("Mon-Khmer, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7902A"
    }
  }, [_vm._v("Mongolian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92998"
    }
  }, [_vm._v("Moro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9305A"
    }
  }, [_vm._v("Motu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8112A"
    }
  }, [_vm._v("Murrinh-Patha")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8214A"
    }
  }, [_vm._v("Mutpurra (Mudburra)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1000A"
    }
  }, [_vm._v("NORTHERN EUROPEAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9306A"
    }
  }, [_vm._v("Nauruan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9228A"
    }
  }, [_vm._v("Ndebele")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1401B"
    }
  }, [_vm._v("Nederlands")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5206A"
    }
  }, [_vm._v("Nepali")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8215A"
    }
  }, [_vm._v("Ngaatjatjara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8113A"
    }
  }, [_vm._v("Ngangkikurungurr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8501A"
    }
  }, [_vm._v("Ngarluma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9307A"
    }
  }, [_vm._v("Niue")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0001A"
    }
  }, [_vm._v("Non-Verbal So Described")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8199A"
    }
  }, [_vm._v("Northern Aboriginal (NEC)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8100A"
    }
  }, [_vm._v("Northern Aboriginal (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1503A"
    }
  }, [_vm._v("Norwegian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0002A"
    }
  }, [_vm._v("Not Stated")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AU"
    }
  }, [_vm._v("Nubi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9231A"
    }
  }, [_vm._v("Nuer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69994"
    }
  }, [_vm._v("Nung")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8114A"
    }
  }, [_vm._v("Nunggubuyu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8216A"
    }
  }, [_vm._v("Nyangumarta")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9232A"
    }
  }, [_vm._v("Nyanja (Chichewa)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8502A"
    }
  }, [_vm._v("Nyungar (Noongar)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9000A"
    }
  }, [_vm._v("OTHER LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9499A"
    }
  }, [_vm._v("Oceanian Pidgins And Creoles, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9400A"
    }
  }, [_vm._v("Oceanian Pidgins And Creoles, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5216A"
    }
  }, [_vm._v("Oriya")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9206A"
    }
  }, [_vm._v("Oromo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7999A"
    }
  }, [_vm._v("Other Eastern Asian Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3999A"
    }
  }, [_vm._v("Other Eastern European Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3900A"
    }
  }, [_vm._v("Other Eastern European Languages, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999A"
    }
  }, [_vm._v("Other Southeast Asian Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5999A"
    }
  }, [_vm._v("Other Southern Asian Languages, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2999A"
    }
  }, [_vm._v("Other Southern European Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2900A"
    }
  }, [_vm._v("Other Southern European Languages, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4999A"
    }
  }, [_vm._v("Other Southwest and Central Asian Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9399A"
    }
  }, [_vm._v("Pacific Austronesian Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9300A"
    }
  }, [_vm._v("Pacific Austronesian Languages, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0000B"
    }
  }, [_vm._v("Pakistani")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6521A"
    }
  }, [_vm._v("Pampangan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4103E"
    }
  }, [_vm._v("Panjsheri")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9599A"
    }
  }, [_vm._v("Papua New Guinea Papuan Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9501A"
    }
  }, [_vm._v("Papuan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100E"
    }
  }, [_vm._v("Parsun")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4102A"
    }
  }, [_vm._v("Pashto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4106A"
    }
  }, [_vm._v("Persian (excluding Dari)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4103A"
    }
  }, [_vm._v("Persian/Farsi/Dari")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8217A"
    }
  }, [_vm._v("Pintupi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9403A"
    }
  }, [_vm._v("Pitcairnese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8218A"
    }
  }, [_vm._v("Pitjantjatjara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3602A"
    }
  }, [_vm._v("Polish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2302A"
    }
  }, [_vm._v("Portuguese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299D"
    }
  }, [_vm._v("Pular / Fuuta Jalon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5207A"
    }
  }, [_vm._v("Punjabi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AH"
    }
  }, [_vm._v("Punu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8115A"
    }
  }, [_vm._v("Rembarrnga")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8116A"
    }
  }, [_vm._v("Ritharrngu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5201B"
    }
  }, [_vm._v("Rohingya")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3904A"
    }
  }, [_vm._v("Romanian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3905A"
    }
  }, [_vm._v("Romany")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9312A"
    }
  }, [_vm._v("Rotuman")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3402A"
    }
  }, [_vm._v("Russian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6000A"
    }
  }, [_vm._v("SOUTHEAST ASIAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5000A"
    }
  }, [_vm._v("SOUTHERN ASIAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2000A"
    }
  }, [_vm._v("SOUTHERN EUROPEAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4000A"
    }
  }, [_vm._v("SOUTHWEST AND CENTRAL ASIAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9308A"
    }
  }, [_vm._v("Samoan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AJ"
    }
  }, [_vm._v("Sango")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999B"
    }
  }, [_vm._v("Sasak")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1599A"
    }
  }, [_vm._v("Scandinavian, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1500A"
    }
  }, [_vm._v("Scandinavian, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3505A"
    }
  }, [_vm._v("Serbian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3507A"
    }
  }, [_vm._v("Serbo-Croatian/Yugoslavian, so described")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9238A"
    }
  }, [_vm._v("Seychelles Creole")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69995"
    }
  }, [_vm._v("Shan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9233A"
    }
  }, [_vm._v("Shilluk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9207A"
    }
  }, [_vm._v("Shona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9799A"
    }
  }, [_vm._v("Sign Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9700A"
    }
  }, [_vm._v("Sign Languages,nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5208A"
    }
  }, [_vm._v("Sindhi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5211A"
    }
  }, [_vm._v("Sinhalese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3603A"
    }
  }, [_vm._v("Slovak")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3506A"
    }
  }, [_vm._v("Slovene")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9405A"
    }
  }, [_vm._v("Solomon Islands Pijin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9208A"
    }
  }, [_vm._v("Somali")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AI"
    }
  }, [_vm._v("Songo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3500A"
    }
  }, [_vm._v("South Slavic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6500A"
    }
  }, [_vm._v("Southeast Asian Austronesian Languages")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6599A"
    }
  }, [_vm._v("Southeast Asian Austronesian Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2303A"
    }
  }, [_vm._v("Spanish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5000C"
    }
  }, [_vm._v("Sri Lankan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299Z"
    }
  }, [_vm._v("Susu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9211A"
    }
  }, [_vm._v("Swahili")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1504A"
    }
  }, [_vm._v("Swedish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7999C"
    }
  }, [_vm._v("Szi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6506A"
    }
  }, [_vm._v("Tagalog (Filipino)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6499A"
    }
  }, [_vm._v("Tai, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6400A"
    }
  }, [_vm._v("Tai, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5103A"
    }
  }, [_vm._v("Tamil")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4303A"
    }
  }, [_vm._v("Tatar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5104A"
    }
  }, [_vm._v("Telugu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299J"
    }
  }, [_vm._v("Temne / Themne")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7105A"
    }
  }, [_vm._v("Teochew")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6507A"
    }
  }, [_vm._v("Tetum")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6402A"
    }
  }, [_vm._v("Thai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7901A"
    }
  }, [_vm._v("Tibetan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9234A"
    }
  }, [_vm._v("Tigre")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9235A"
    }
  }, [_vm._v("Tigrinya")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6508A"
    }
  }, [_vm._v("Timorese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8117A"
    }
  }, [_vm._v("Tiwi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9401A"
    }
  }, [_vm._v("Tok Pisin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9313A"
    }
  }, [_vm._v("Tokelauan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9311A"
    }
  }, [_vm._v("Tongan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8400A"
    }
  }, [_vm._v("Torres Strait (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8702A"
    }
  }, [_vm._v("Torres Strait Creole (Broken)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9236A"
    }
  }, [_vm._v("Tswana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5105A"
    }
  }, [_vm._v("Tulu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4399A"
    }
  }, [_vm._v("Turkic, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4300A"
    }
  }, [_vm._v("Turkic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4301A"
    }
  }, [_vm._v("Turkish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4304A"
    }
  }, [_vm._v("Turkmen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9314A"
    }
  }, [_vm._v("Tuvaluan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9203B"
    }
  }, [_vm._v("Twi (Akan)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3403A"
    }
  }, [_vm._v("Ukrainian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3500B"
    }
  }, [_vm._v("Unspec.Fmr.Yugoslav Language")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5212A"
    }
  }, [_vm._v("Urdu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4305A"
    }
  }, [_vm._v("Uygur / Uyghur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4306A"
    }
  }, [_vm._v("Uzbek")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92991"
    }
  }, [_vm._v("Vai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6302A"
    }
  }, [_vm._v("Vietnamese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100F"
    }
  }, [_vm._v("Waigali")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8221A"
    }
  }, [_vm._v("Walmajarri (Walmadjari)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8223A"
    }
  }, [_vm._v("Warlpiri")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8222A"
    }
  }, [_vm._v("Warumungu (Warumunga)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1103A"
    }
  }, [_vm._v("Welsh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8599A"
    }
  }, [_vm._v("West Coast Aboriginal (NEC)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8500A"
    }
  }, [_vm._v("West Coast Aboriginal (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3600A"
    }
  }, [_vm._v("West Slavic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8304A"
    }
  }, [_vm._v("Wik-Mungkan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7106A"
    }
  }, [_vm._v("Wu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9237A"
    }
  }, [_vm._v("Xhosa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AL"
    }
  }, [_vm._v("Yakoma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8225A"
    }
  }, [_vm._v("Yankuntjatjara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8118A"
    }
  }, [_vm._v("Yanyuwa (Anula)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9315A"
    }
  }, [_vm._v("Yapese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1303A"
    }
  }, [_vm._v("Yiddish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8503A"
    }
  }, [_vm._v("Yindjibarndi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9212A"
    }
  }, [_vm._v("Yoruba")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8224A"
    }
  }, [_vm._v("Yulparija")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AS"
    }
  }, [_vm._v("Zaghawa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7999D"
    }
  }, [_vm._v("Zaiwa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AN"
    }
  }, [_vm._v("Zande")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69997"
    }
  }, [_vm._v("Zophei")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9213A"
    }
  }, [_vm._v("Zulu")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile-action"
  })])])
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.agreement) ? _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.show
    }
  }, [_c('a', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('a', {
    staticClass: "btn btn-clear float-right",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title h5"
  }, [_vm._v("Send cost agreement")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "input-example-3"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('quillEditor', {
    attrs: {
      "id": "editor",
      "options": _vm.editorOptions
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Add a Factsheet")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attachments),
      expression: "attachments"
    }],
    staticClass: "form-select",
    attrs: {
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.attachments = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.files), function(f, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(f.listname))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      loading: _vm.sending
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send($event)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), (_vm.sendError) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v("Something went wrong")]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.inv) ? _c('div', [_c('div', {
    staticClass: "columns border-bottom-lg"
  }, [_c('div', {
    staticClass: "column col-xs-12 col-md-6"
  }, [(_vm.brand === 'pl') ? _c('img', {
    staticClass: "invoiceLogo",
    attrs: {
      "src": __webpack_require__(54),
      "alt": "PocketLegal"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('img', {
    staticClass: "invoiceLogo",
    attrs: {
      "src": __webpack_require__(35),
      "alt": "Immigration Experts"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column col-xs-12 col-md-6 text-right"
  }, [_c('h1', [_vm._v("Tax Invoice")]), _vm._v(" "), _c('h4', [_vm._v("Reference: #" + _vm._s(_vm.inv.ref))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns border-bottom-lg"
  }, [_c('div', {
    staticClass: "column col-xs-12 col-md-6"
  }, [_vm._v("\n          Invoice date: " + _vm._s(_vm.date(_vm.inv.date))), _c('br'), _vm._v("\n          Due date: " + _vm._s(_vm.due)), _c('br'), _vm._v("\n          Invoice status: \n          "), (_vm.inv.paid) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Paid")]) : _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Unpaid")])]), _vm._v(" "), _c('div', {
    staticClass: "column col-xs-12 col-md-6"
  }, [_vm._v("       \n        " + _vm._s(_vm.inv.business ? _vm.inv.business : _vm.inv.firstname + ' ' + _vm.inv.lastname)), _c('br'), _vm._v(" "), (_vm.inv.business) ? _c('span', [_vm._v("Attn: " + _vm._s(_vm.inv.firstname) + " " + _vm._s(_vm.inv.lastname))]) : _vm._e(), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-lg"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_c('h2', [_vm._v("Description")]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.inv.matter_desc))])])]), _vm._v(" "), _vm._l((_vm.inv.items), function(item) {
    return _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column col-4"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('div', {
      staticClass: "column col-8"
    }, [_vm._v("$" + _vm._s(_vm.c2d(item.cost)))])])
  }), _vm._v(" "), (_vm.inv.gst) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-4"
  }, [_vm._v("GST (10%)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v("$" + _vm._s(_vm.c2d(_vm.inv.gst)))])]) : _vm._e(), _vm._v(" "), (_vm.inv.surcharge) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Surcharge (1.4%)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v("$" + _vm._s(_vm.c2d(_vm.inv.surcharge)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v("$" + _vm._s(_vm.c2d(_vm.inv.total)))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-lg"
  }, [_c('h2', [_vm._v("Payment Methods")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column col-9"
  }, [_c('a', {
    staticClass: "d-none showForPrint",
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v(_vm._s(_vm.url))]), _vm._v(" "), (_vm.showPayBtn) ? _c('button', {
    staticClass: "btn btn-primary hideForPrint",
    on: {
      "click": function($event) {
        _vm.showPay = true
      }
    }
  }, [_vm._v("\n            Pay now\n          ")]) : _vm._e(), _c('br'), _c('br')]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column col-9"
  }, [_vm._v("     \n          BSB: 032023"), _c('br'), _vm._v("   \n          Account Number: 386512"), _c('br'), _vm._v(" \n          Account Name: Operating Account"), _c('br'), _vm._v("    \n          Bank: Westpac"), _c('br'), _vm._v("           \n          Bank Address: 547 Crown Street, Surry Hills 2001"), _c('br'), _vm._v("   \n          SWIFT: WPACAU2S"), _c('br'), _vm._v("\n          Transaction Reference: " + _vm._s(_vm.inv.ref)), _c('br'), _c('br'), _vm._v("\n          Please email proof of payment once transferred. "), _c('br'), _c('br')]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column col-9"
  }, [_vm._v("\n          Call "), (_vm.brand === 'ie') ? _c('span', [_vm._v("1300 921 114")]) : _vm._e(), (_vm.brand === 'pl') ? _c('span', [_vm._v("1300 921 114")]) : _vm._e(), _vm._v(" and mention your Transaction Reference (" + _vm._s(_vm.inv.ref) + ").\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-12 text-center"
  }, [(_vm.brand === 'pl') ? _c('div', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('div', [_vm._m(4)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns border-bottom-sm hideForPrint"
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_c('button', {
    staticClass: "btn bg-gray",
    on: {
      "click": _vm.print
    }
  }, [_vm._v("Print this page")])])]), _vm._v(" "), (_vm.inv.plan) ? _c('div', {
    staticClass: "paymentPlanTable"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_vm._m(5), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Monthly payment amount: $" + _vm._s(_vm.c2d(_vm.inv.monthly)))]), _vm._v(" "), _c('th', [_vm._v("Remaining: $" + _vm._s(_vm.c2d(_vm.inv.outstanding)))]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('tbody', _vm._l((_vm.payments(_vm.inv)), function(payment) {
    return _c('tr', [(_vm.inv.last_payment) ? _c('td', [_vm._v(_vm._s(payment.date))]) : _c('td', [_vm._v("Upcoming")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(payment.amount)))]), _vm._v(" "), _c('td', [(payment.paid) ? _c('span', {
      staticClass: "label label-rounded label-success"
    }, [_vm._v("Paid")]) : _c('span', {
      staticClass: "label label-rounded label-warning"
    }, [_vm._v("Scheduled")])])])
  }), 0)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.inv) ? _c('payment', {
    attrs: {
      "invoice": _vm.inv,
      "active": _vm.showPay
    },
    on: {
      "hide": function($event) {
        _vm.showPay = false
      },
      "payment": _vm.getInvoice
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-3"
  }, [_c('strong', [_vm._v("Credit Card")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-3"
  }, [_c('strong', [_vm._v("Direct Deposit")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-3"
  }, [_c('strong', [_vm._v("Phone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("\n          PocketLegal Pty Ltd\n          162 Redfern Street\n          Redfern 2016, NSW\n          accounts@pocketlegal.com.au\n          ABN: 12 613 908 124\n          ACN: 613 908 124\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("\n          Immigration Experts\n          162 Redfern Street\n          Redfern 2016, NSW\n          info@immiexperts.com.au\n          ABN: 12 613 908 124\n          ACN: 613 908 124\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h4', [_vm._v("Your payment plan")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Monthly amount")]), _vm._v(" "), _c('th', [_vm._v("Status")])])
}]}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(this.section) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-title h4"
  }, [(_vm.section.display) ? _c('span', [_vm._v(_vm._s(_vm.section.pretty_name))]) : _c('span', {
    staticClass: "text-gray"
  }, [_vm._v(_vm._s(_vm.section.pretty_name))]), _vm._v(" "), _c('div', {
    staticClass: "columns float-right"
  }, [_c('div', {
    staticClass: "column col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-switch",
    staticStyle: {
      "bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.display),
      expression: "section.display"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.section.display) ? _vm._i(_vm.section.display, null) > -1 : (_vm.section.display)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.section.display,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.section, "display", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.section, "display", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.section, "display", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column col-6"
  }, [_c('button', {
    staticClass: "btn btn-sm float-right",
    on: {
      "click": function($event) {
        _vm.hidden = !_vm.hidden
      }
    }
  }, [_c('i', {
    staticClass: "icon",
    class: {
      'icon-arrow-down': _vm.hidden, 'icon-arrow-up': !_vm.hidden
    }
  })])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidden),
      expression: "!hidden"
    }],
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, _vm._l((_vm.section.fields), function(f, i) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-3 col-sm-12"
    }, [_c('label', {
      staticClass: "form-label"
    }, [_vm._v(_vm._s(f.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-9 col-sm-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (f.text),
        expression: "f.text"
      }],
      staticClass: "form-input input-sm",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (f.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(f, "text", $event.target.value)
        }
      }
    })])])
  }), 0)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": _vm.save
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-md-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.question.text))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer.atxt),
      expression: "answer.atxt"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.answer.atxt)
    },
    on: {
      "blur": _vm.save,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.answer, "atxt", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-7 col-md-10"
  }, [(_vm.question.helptext) ? _c('div', {
    staticClass: "tooltipz",
    domProps: {
      "innerHTML": _vm._s(_vm.question.helptext)
    }
  }) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.agreement) ? _c('div', [(_vm.forbidden) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "acceptedAgreement"
  }, [_vm._v("This link is no longer valid. Please contact us if you require access.")])]) : _c('div', {
    staticClass: "container costAgreement"
  }, [_c('div', {
    staticClass: "printHeading"
  }, [(_vm.brand === 'pl') ? _c('img', {
    attrs: {
      "src": __webpack_require__(215),
      "alt": "PocketLegal"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('img', {
    attrs: {
      "src": __webpack_require__(35),
      "alt": "Immigration Experts"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6 col-sm-12"
  }, [_c('strong', [_vm._v("Agent Details")]), _c('br'), _vm._v(" "), (_vm.brand === 'pl') ? _c('div', [_vm._v("\n            PocketLegal Pty Ltd"), _c('br'), _vm._v("\n            Benjamin Kramer"), _c('br'), _vm._v("\n            benji@pocketlegal.com.au"), _c('br'), _vm._v("\n            MARA Registration No: 1386609"), _c('br'), _vm._v("\n            PocketLegal"), _c('br'), _vm._v("\n            162 Redfern Street, Redfern 2016, NSW Australia"), _c('br'), _vm._v("\n            Phone: (02) 8385 1451"), _c('br'), _vm._v("\n            ABN: 12 613 908 124"), _c('br'), _vm._v("\n            ACN: 613 908 124\n          ")]) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('div', [_vm._v("\n            Immigration Experts Pty Ltd"), _c('br'), _vm._v("\n            Benjamin Kramer"), _c('br'), _vm._v("\n            benji@immiexperts.com.au"), _c('br'), _vm._v("\n            MARA Registration No: 1386609"), _c('br'), _vm._v("\n            Immigration Experts"), _c('br'), _vm._v("\n            162 Redfern Street, Redfern 2016, NSW Australia"), _c('br'), _vm._v("\n            Phone: (02) 9279 1289"), _c('br'), _vm._v("\n            ABN: 12 613 908 124"), _c('br'), _vm._v("\n            ACN: 613 908 124\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column col-6"
  }, [_c('strong', [_vm._v("Client")]), _c('br'), _vm._v(" "), (_vm.agreement.business) ? _c('span', [_vm._v(_vm._s(_vm.agreement.business)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.agreement.name) ? _c('span', [_vm._v(_vm._s(_vm.agreement.name)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.agreement.email) ? _c('span', [_vm._v(_vm._s(_vm.agreement.email)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.agreement.address) ? _c('span', [_vm._v(_vm._s(_vm.agreement.address)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.agreement.phone) ? _c('span', [_vm._v(_vm._s(_vm.agreement.phone)), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("Date of issue: " + _vm._s(new Date(_vm.agreement.date).toDateString()) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "columns bg-gray",
    staticStyle: {
      "border": "1px solid #ccc",
      "padding": "1em",
      "margin": "1em 0 2em 0"
    }
  }, [_c('div', {
    staticClass: "column col-12 text-center h6"
  }, [_vm._v("\n          SERVICE CATEGORY"), _c('br'), _vm._v("\n          " + _vm._s(_vm.agreement.visatype) + "\n        ")])]), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Important Information for Clients")]), _vm._v("\n      The terms and conditions of this agreement are set out below. By signing below you are confirming that you have read and understood all the conditions before entering into the agreement. If you wish to seek independent legal advice about this agreement, you should do so before signing this agreement.\n      "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n            I accept the quoted fees, have read and understood the terms and conditions below, and I agree to be bound by this agreement. " + _vm._s(_vm.brandname) + " will assume your agreement if you do not inform us to the contrary and continue to instruct us to act for you.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-12",
    staticStyle: {
      "padding-top": "2em"
    }
  }, [(!_vm.agreement.accepted) ? _c('button', {
    staticClass: "btn btn-primary",
    class: {
      'loading': _vm.loading
    },
    on: {
      "click": _vm.accept
    }
  }, [_vm._v("\n              Accept\n            ")]) : _vm._e(), _vm._v(" "), (_vm.agreement.accepted) ? _c('div', [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Accepted on")]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(new Date(_vm.agreement.accepted_at).toDateString()))])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "costAgreementTable"
  }, [_c('div', {
    staticClass: "columns bg-gray costagreementHeader"
  }, [_c('div', {
    staticClass: "column col-6"
  }, [_vm._v("\n              Items\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-2 text-center hide-md"
  }, [_vm._v("\n              Quantity\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-2 hide-md"
  }, [_vm._v("\n              Fixed Fee\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-2 hide-md"
  }, [_vm._v("\n              Total "), (!_vm.agreement.no_gst) ? _c('span', [_vm._v("(incl. 10% GST)")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.agreement.items), function(item) {
    return _c('div', [_c('div', {
      staticClass: "columns costagreementItems"
    }, [_c('div', {
      staticClass: "column col-6 col-sm-12 itemDescription"
    }, [_vm._v("\n                " + _vm._s(item.description) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "column col-2 col-sm-12 itemQuantity"
    }, [_vm._v("\n                " + _vm._s(item.quantity) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "column col-2 col-sm-12 itemCost"
    }, [_vm._v("\n                $" + _vm._s(_vm.c2d(item.cost)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "column col-2 col-sm-12 itemTotal"
    }, [_vm._v("\n                $" + _vm._s(_vm.itemtotal(item)) + "\n              ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-10 hide-md"
  }, [_vm._v("\n              Total "), (!_vm.agreement.no_gst) ? _c('span', [_vm._v("(including GST)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column col-2 col-sm-12 itemTotalGst"
  }, [_c('strong', [_vm._v("$" + _vm._s(_vm.total))])])])], 2)]), _vm._v(" "), _c('h2', [_vm._v("Third Party Costs")]), _vm._v(" "), _c('p', [_vm._v("Below is a non-exhaustive list of potential 3rd party fees. We are not responsible for these fees, which are payable when due and are subject to vary at any time; these services are disbursements in addition to the fees of " + _vm._s(_vm.brandname) + ".")]), _vm._v(" "), _c('p', [_vm._v("Please review them carefully to determine the full cost of your application.")]), _vm._v(" "), _c('div', {
    staticClass: "costAgreementTable"
  }, [_vm._m(1), _vm._v(" "), (_vm.agreement.visatype === '482 - Primary (Short-Term Stream)') ? _c('div', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Primary (Long-Term Stream)') ? _c('div', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Primary') ? _c('div', [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Nomination') ? _c('div', [_vm._m(5), _vm._v(" "), _vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Nomination') ? _c('div', [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Sponsor') ? _c('div', [_vm._m(10), _vm._v(" "), _vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Sponsor') ? _c('div', [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Standard Business Sponsorship') ? _c('div', [_vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Subsequent Entrant') ? _c('div', [_vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Sponsorship and Primary') ? _c('div', [_vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Sponsorship and Primary') ? _c('div', [_vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Primary') ? _c('div', [_vm._m(25)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Nomination') ? _c('div', [_vm._m(26)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Sponsor') ? _c('div', [_vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Subsequent Entrant') ? _c('div', [_vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '187 - Nomination') ? _c('div', [_vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '187 - Primary') ? _c('div', [_vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '186 - Primary') ? _c('div', [_vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '186 - Nomination') ? _c('div', [_vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '186 - Nomination and Primary') ? _c('div', [_vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Protection') ? _c('div', [_vm._m(63)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Waiver') ? _c('div', [_vm._m(64)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Partner Visa') ? _c('div', [_vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '820 - Partner Visa') ? _c('div', [_vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _vm._m(70)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '801 - Partner Visa') ? _c('div', [_vm._m(71), _vm._v(" "), _vm._m(72)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '300 - Prospective Marriage Visa') ? _c('div', [_vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _vm._m(75)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Skilled Independent Visa') ? _c('div', [_vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79), _vm._v(" "), _vm._m(80), _vm._v(" "), _vm._m(81)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Tourist Visa') ? _c('div', [_vm._m(82), _vm._v(" "), _vm._m(83), _vm._v(" "), _vm._m(84), _vm._v(" "), _vm._m(85), _vm._v(" "), _vm._m(86)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '600 - Visitor Visa') ? _c('div', [_vm._m(87), _vm._v(" "), _vm._m(88), _vm._v(" "), _vm._m(89), _vm._v(" "), _vm._m(90), _vm._v(" "), _vm._m(91)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Student Visa') ? _c('div', [_vm._m(92), _vm._v(" "), _vm._m(93), _vm._v(" "), _vm._m(94), _vm._v(" "), _vm._m(95)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Student - Subsequent Entrant') ? _c('div', [_vm._m(96), _vm._v(" "), _vm._m(97), _vm._v(" "), _vm._m(98), _vm._v(" "), _vm._m(99)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '189 - NZ Stream') ? _c('div', [_vm._m(100), _vm._v(" "), _vm._m(101), _vm._v(" "), _vm._m(102), _vm._v(" "), _vm._m(103)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Ministerial Intervention') ? _c('div', [_vm._m(104), _vm._v(" "), _vm._m(105)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'AAT Appeal') ? _c('div', [_vm._m(106)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '408') ? _c('div', [_vm._m(107), _vm._v(" "), _vm._m(108)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '407') ? _c('div', [_vm._m(109), _vm._v(" "), _vm._m(110), _vm._v(" "), _vm._m(111), _vm._v(" "), _vm._m(112), _vm._v(" "), _vm._m(113), _vm._v(" "), _vm._m(114), _vm._v(" "), _vm._m(115), _vm._v(" "), _vm._m(116), _vm._v(" "), _vm._m(117)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '407 - Sponsor') ? _c('div', [_vm._m(118), _vm._v(" "), _vm._m(119)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '485 - Graduate Visa') ? _c('div', [_vm._m(120), _vm._v(" "), _vm._m(121)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Citizenship') ? _c('div', [_vm._m(122)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Distinguished Talent Visa') ? _c('div', [_vm._m(123)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '802 - Child Visa') ? _c('div', [_vm._m(124), _vm._v(" "), _vm._m(125)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Contributory Parent Visa') ? _c('div', [_vm._m(126), _vm._v(" "), _vm._m(127), _vm._v(" "), _vm._m(128)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '461 - NZ Citizen Family Relationship') ? _c('div', [_vm._m(129), _vm._v(" "), _vm._m(130)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Resident Return Visa') ? _c('div', [_vm._m(131)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Medical Treatment Visa') ? _c('div', [_vm._m(132)]) : _vm._e()]), _vm._v(" "), _c('h2', [_vm._v("TERMS AND CONDITIONS OF SERVICE ")]), _vm._v(" "), _c('p', [_vm._v("As soon as possible after giving instructions to the Agent and receiving an estimate of fees, disbursements and the likely time to be taken in performing services, the Client will provide written acceptance of these estimates. ")]), _vm._v(" "), _c('h3', [_vm._v("1. Appointment of an agent")]), _vm._v(" "), _vm._m(133), _vm._v(" "), _c('h3', [_vm._v("2. Code of Conduct ('The Code')")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("The Code is intended to regulate the conduct of registered migration agents by introducing a proper standard for the conduct of business as a registered migration agent and establishes the minimum attributes and abilities that a person must demonstrate to perform as a registered migration agent. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent guarantees to provide a copy of the Code to the Client immediately upon request. The Client acknowledges that they are aware of and have read the Consumer Guide, which, along with the Code, is available at "), (_vm.brand === 'pl') ? _c('div', [_c('a', {
    attrs: {
      "href": "https://pocketlegal.com.au/resources/the-code",
      "target": "new"
    }
  }, [_vm._v("https://pocketlegal.com.au/resources/the-code")])]) : _vm._e(), (_vm.brand === 'ie') ? _c('div', [_c('a', {
    attrs: {
      "href": "http://www.immiexperts.com.au/wp-content/uploads/2018/11/Code_of_Conduct_April_2017.pdf"
    }
  }, [_vm._v("http://www.immiexperts.com.au/wp-content/uploads/2018/11/Code_of_Conduct_April_2017.pdf")])]) : _vm._e(), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("If the Code (which is prescribed in Schedule 2 of the Migration Agent Regulations 1998) is inconsistent with this agreement, the Agent and Client agree to vary this agreement to the extent that it complies with the new Code. ")])]), _vm._v(" "), _c('h3', [_vm._v("3. Services to be provided")]), _vm._v(" "), _vm._m(134), _vm._v(" "), _c('h3', [_vm._v("4. The agent guarantees that")]), _vm._v(" "), _vm._m(135), _vm._v(" "), _c('h3', [_vm._v("5. The parties agree")]), _vm._v(" "), _vm._m(136), _vm._v(" "), _c('h3', [_vm._v("6. Termination of agreement")]), _vm._v(" "), _vm._m(137), _vm._v(" "), _c('h3', [_vm._v("7. Retention of documents")]), _vm._v(" "), _vm._m(138), _vm._v(" "), _c('h3', [_vm._v("8. Confidentiality")]), _vm._v(" "), _vm._m(139), _vm._v(" "), _c('h3', [_vm._v("9. Conflicts of Interest")]), _vm._v(" "), _vm._m(140), _vm._v(" "), _c('h3', [_vm._v("10. Electronic communications")]), _vm._v(" "), _vm._m(141), _vm._v(" "), _c('h3', [_vm._v("11. Relevant law and jurisdiction")]), _vm._v(" "), _vm._m(142), _vm._v(" "), _c('h3', [_vm._v("12. Unpaid accounts")]), _vm._v(" "), _vm._m(143), _vm._v(" "), _c('h2', [_vm._v("SCHEDULE OF FEES")]), _vm._v(" "), _c('h3', [_vm._v("1. Fee types")]), _vm._v(" "), _c('p', [_vm._v("a) Fixed Fee")]), _vm._v(" "), _vm._m(144), _vm._v(" "), _c('p', [_vm._v("b) Hourly Rates")]), _vm._v(" "), _vm._m(145), _vm._v(" "), _vm._m(146), _vm._v(" "), _c('h3', [_vm._v("2. Payment terms")]), _vm._v(" "), _c('ol', [(_vm.brand === 'pl') ? _c('span', [_c('li', [_vm._v("We require an initial deposit of $700 (plus GST) to cover the cost of our initial research and advice, and to commence preparation of your visa application.")])]) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('span', [_c('li', [_vm._v("We require an initial deposit of 50% of our professional fees to cover the cost of our initial research and advice, and to commence preparation of your visa application.")])]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("The remaining balance of your account will be invoiced at least 2 weeks prior to the lodgement of your application.")]), _vm._v(" "), _c('li', [_vm._v("Immigration matters can take many months to resolve, we may invoice you from time to time for work done to the date of the invoice.")]), _vm._v(" "), _c('li', [_vm._v("The Agent's professional fees can be invoiced on behalf of the Agent by the Agent's business entity, as listed on the MARA Register of Migration Agents. ")]), _vm._v(" "), _c('li', [_vm._v("Agent is not liable for delays in accounting if the Client fails to identify the payments appropriately and/or provide written confirmation of any payments made as soon as possible. ")])]), _vm._v(" "), _c('h3', [_vm._v("3. Disbursements")]), _vm._v(" "), _vm._m(147), _vm._v(" "), _c('h3', [_vm._v("4. Payment methods")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Payment should be made within 14 days upon receipt of invoice, via the " + _vm._s(_vm.brandname) + " website payment facility (credit card payment), or direct bank deposit where relevant.")]), _vm._v(" "), _c('li', [_vm._v("You are responsible for all banking fees and currency conversion costs. Please ensure the full amount invoiced reaches our account in Australia within the time specified and appropriately labeled to prevent additional administration fees.")])]), _vm._v(" "), _c('h3', [_vm._v("Processing Times")]), _vm._v(" "), _c('p', [_vm._v("Once applications have been lodged by " + _vm._s(_vm.brandname) + " with the DHA you can expect the following processing times. Your agent will speak with you about bridging or other visas to accommodate a stay in Australia during processing time if relevant.")]), _vm._v(" "), _c('div', {
    staticClass: "costAgreementTable"
  }, [_vm._m(148), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6"
  }, [_vm._v("\n                " + _vm._s(_vm.agreement.visatype) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-6"
  }, [(_vm.agreement.visatype === '482 - Primary (Short-Term Stream)') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Primary (Long-Term Stream)') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Nomination') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Sponsor') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Sponsorship and Primary') ? _c('span', [_vm._v("1 - 3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Primary') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Nomination') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Sponsor') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Skilled Independent Visa') ? _c('span', [_vm._v("6 - 12 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '186 - Primary') ? _c('span', [_vm._v("11 - 14 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '186 - Nomination') ? _c('span', [_vm._v("11 - 14 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '186 - Nomination and Primary') ? _c('span', [_vm._v("11 - 14 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '187 - Primary') ? _c('span', [_vm._v("6 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '187 - Nomination') ? _c('span', [_vm._v("22 - 25 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Partner Visa') ? _c('span', [_vm._v("15 - 24 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '801 - Partner Visa') ? _c('span', [_vm._v("18 - 25 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '820 - Partner Visa') ? _c('span', [_vm._v("15 - 24 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '300 - Prospective Marriage Visa') ? _c('span', [_vm._v("12 - 16 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Resident Return Visa') ? _c('span', [_vm._v("5 - 12 days")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Student Visa') ? _c('span', [_vm._v("14 days - 3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Student - Subsequent Entrant') ? _c('span', [_vm._v("21 - 45 days")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '600 - Visitor Visa') ? _c('span', [_vm._v("1 day - 1 month")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Tourist Visa') ? _c('span', [_vm._v("1 day - 1 month")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Ministerial Intervention') ? _c('span', [_vm._v("3 - 12 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '189') ? _c('span', [_vm._v("5 - 8 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '189 - NZ Stream') ? _c('span', [_vm._v("4 - 9 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '485 - Graduate Visa') ? _c('span', [_vm._v("3 - 4 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '407') ? _c('span', [_vm._v("66 - 80 days")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '407 - Sponsor') ? _c('span', [_vm._v("66 - 80 days")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '408') ? _c('span', [_vm._v("2 - 65 days")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '461 - NZ Citizen Family Relationship') ? _c('span', [_vm._v("11 - 15 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '802 - Child Visa') ? _c('span', [_vm._v("11 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Distinguished Talent Visa') ? _c('span', [_vm._v("Processing times vary")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Contributory Parent Visa') ? _c('span', [_vm._v("40 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'AAT Appeal') ? _c('span', [_vm._v("12 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Protection') ? _c('span', [_vm._v("18 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Waiver') ? _c('span', [_vm._v("1 - 4 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Medical Treatment Visa') ? _c('span', [_vm._v("30 - 60 days")]) : _vm._e()])])]), _vm._v(" "), _vm._m(149)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "costAgreementHeader"
  }, [_c('h1', [_vm._v("Cost Agreement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns bg-gray"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Item")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Cost")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Third Party")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thirdParties"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Visa Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,150")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (over 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,150")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (under 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$290")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)  ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thirdParties"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Visa Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$2,400")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (over 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$2,400")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (under 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$600")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)  ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thirdParties"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Visa Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,150 - $2,400"), _c('br'), _vm._v("Depending on occupation stream")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (over 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,150 - $2,400"), _c('br'), _vm._v("Depending on occupation stream")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (under 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$290 - $600"), _c('br'), _vm._v("Depending on occupation stream")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)  ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Training Levy"), _c('br'), _vm._v("\n            Businesses with annual turnover under $10mil")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,200"), _c('br'), _vm._v("(per number of years the visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1200"), _c('br'), _vm._v("(per number of years visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n            OR\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1800"), _c('br'), _vm._v("(per number of years visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Standard Business Sponsorship Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1200"), _c('br'), _vm._v("(per number of years visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n            OR\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1800"), _c('br'), _vm._v("(per number of years visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 - Standard Business Sponsorship Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Subsequent Entrant Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,150 - $2,400")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Standard Business Sponsorship Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,150 - $2,400"), _c('br'), _vm._v("Depending on occupation stream")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1200"), _c('br'), _vm._v("(per number of years visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n            OR\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1800"), _c('br'), _vm._v("(per number of years visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thirdParties"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("457 Visa Primary Application")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1060")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (over 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1060")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (under 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$265")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)  ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("457 Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("457 Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("457 Standard Business Sponsorship Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Training Benchmarks")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("1 - 2% annual payroll")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("457 Subsequent Entrant Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,080")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("187 Visa Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$540")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("RCB Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$600 - $2000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various Regional Bodies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n            OR\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$5,000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("187 Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,670")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,800")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,670")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,800")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skills Assessment")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$750-900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$540")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n            OR\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$5,000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$540")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n              OR\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$5,000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,670")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,800")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skills Assessment (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$750-900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Protection Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$35")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Protection Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$35")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Partner Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$7,160")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (where relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Partner Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$7,160")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (where relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (where relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Partner Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$7,160")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (where relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skilled Independent Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,600")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skilled Independent Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,800")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skilled Independent Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skills Assessment")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$750-900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (where relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Visitor Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$140")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Visitor Visa "), _c('em', [_vm._v("Frequent Traveller Stream")]), _vm._v(" Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,020")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Visitor Visa "), _c('em', [_vm._v("Where Applicant is in Australia")]), _vm._v(" Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,020")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Medical check (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Varies")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Visitor Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$140")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Visitor Visa "), _c('em', [_vm._v("Frequent Traveller Stream")]), _vm._v(" Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,020")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Visitor Visa "), _c('em', [_vm._v("Where Applicant is in Australia")]), _vm._v(" Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,020")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Medical check (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Varies")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Student Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$560")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Student Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Student Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$140")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Subsequent Temporary Application Charge (Applicable to each applicant) - Relevant when applying for a second temporary visa onshore")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$700")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Subsequent Entrant Student Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$560")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Student Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Student Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$140")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Subsequent Temporary Application Charge (Relevant when applying for a second temporary visa onshore)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$700")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("189 Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3670")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("189 Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1800")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("189 Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Medical check (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Varies")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,731 (50% returned if appeal succeeds)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Administrative Appeals Tribunal (AAT)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("408 Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$280")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Visa Sponsorship Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Visa Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$170")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Visa Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$285")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Visa Application Fee (dependant over 18)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$285")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Visa Application Fee (dependant under 18)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$70")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Medical check (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Varies")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Sponsorship Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Nomination Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$170")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("485 Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1470")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skills Assessment (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various Providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Citizenship Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$285")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Distinguished Talent Visa")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,310")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("802 Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$2,415")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Contributory Parent Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$19,750")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Medical check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_c('em', [_vm._v("Differs by provider")])]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various Providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("461 - NZ Citizen Family Relationship")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$340")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Resident Return visa (subclasses 155 & 157)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$375")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Medical Treatment Visa")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$290")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Client appoints the Agent to represent the Client and to perform the services described in this agreement.")]), _vm._v(" "), _c('li', [_vm._v("The Client acknowledges and consents to administrative services being provided by other staff. The Responsible Agent will properly supervise the work carried out by any staff working for the Agent. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Provide advice relating to the Client's migration goals and choice of visa category ")]), _vm._v(" "), _c('li', [_vm._v("Provide frank and candid advice regarding the prospects of success. An agent cannot guarantee the success of an application")]), _vm._v(" "), _c('li', [_vm._v("Analyse current Immigration Law relating to the nominated visa category or review application (may incur hourly fee)")]), _vm._v(" "), _c('li', [_vm._v("Assist in the completion and/or checking of relevant application forms")]), _vm._v(" "), _c('li', [_vm._v("Provide advice and assistance relating to documentation required to support the application ")]), _vm._v(" "), _c('li', [_vm._v("Prepare any necessary supporting submissions to the relevant Assessing Authority, Department or review body (may incur hourly fee)")]), _vm._v(" "), _c('li', [_vm._v("Submit the application to the relevant Assessing Authority, Department or review body for processing as soon as possible ")]), _vm._v(" "), _c('li', [_vm._v("Wherever possible, supply any further documentation or information requested by the Department on receipt of documents from the Client")]), _vm._v(" "), _c('li', [_vm._v("Wherever possible, assist the Client to comply with any request made by the Department or review body. ")]), _vm._v(" "), _c('li', [_vm._v("Keep the Client fully informed of all developments concerning the progress of the application")]), _vm._v(" "), _c('li', [_vm._v("Promptly advise the Client of any communications from the Department or review body")]), _vm._v(" "), _c('li', [_vm._v("During the processing of the application, advise the Client of any changes to the law affecting the visa application")]), _vm._v(" "), _c('li', [_vm._v("Advise the Client promptly of the outcome of the application")]), _vm._v(" "), _c('li', [_vm._v("Provide post-grant migration advice regarding visa conditions and requirements ")]), _vm._v(" "), _c('li', [_vm._v("The fixed fee does not include additional work required to resolves issues relating to character such as criminal convictions, health or provision of unsuitable documents or documents suspected of being false. If such issues arise, additional fees will be payable at the rate specified above or at an agreed fixed fee.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Agent is registered with the Migration Agents Registration Authority. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent maintains the required level of Professional Indemnity Insurance. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent has no conflict of interest in terms of Part 2 of the Code. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will act in accordance with the law and in the best interests of the Client, and deal with the Client competently, diligently and fairly. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent has sufficient knowledge of the relevant laws to be able to provide the agreed services. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will advise the Client in writing, if in the Agent's opinion, the application is vexatious or grossly unfounded. ")]), _vm._v(" "), _c('li', [_vm._v("Will, on request, provide the Client with a copy of their application and any related documents unless accounts are outstanding ($0.50 per page).")]), _vm._v(" "), _c('li', [_vm._v("No legal advice will be provided unless in accordance with a separate cost agreement.")]), _vm._v(" "), _c('li', [_vm._v("Clients may have access to an interpreter if requested and at their own expense. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Agent is able to advise the Client about immigration law at a particular point in time but is unable to predict future changes in the law or to individual circumstances. ")]), _vm._v(" "), _c('li', [_vm._v("The Client will respond promptly to requests by the Agent for further information or documents as necessary.")]), _vm._v(" "), _c('li', [_vm._v("The Client will not hold the Agent responsible for delays caused by the Client's failure to promptly provide information or documents. The Client is aware that failure to provide documents as required is likely to lead to an application being refused. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will be under no obligation to submit the Client's application to the Department or review body until payment has been made in full of all fees due and payable at that stage. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will provide the Client with a copy of the booklet titled Information on the Regulation of the Migration Advice Profession upon request. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent cannot guarantee the success of any application under any circumstance or at any stage or that the application will be approved by a specific date or within a specific period. ")]), _vm._v(" "), _c('li', [_vm._v("The final decision on an application submitted to DIAC is beyond the Agent's control. The Agent is under no obligation to provide any refund should the application be refused for reasons outside the Agent's control. ")]), _vm._v(" "), _c('li', [_vm._v("The Client bears the risk that changes in immigration law or their personal circumstances may cause an application to no longer be appropriate. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will not be liable for any loss arising from changes to the law affecting the Client's application. The Agent cannot predict changes in the law and will not be responsible if applications are affected as a result.")]), _vm._v(" "), _c('li', [_vm._v("The Client will not sell property, leave employment or finalise any business or personal affairs without first notifying the Agent of any material change.")]), _vm._v(" "), _c('li', [_vm._v("All information provided to the Agent is, to the best of the Client's knowledge and belief, true and current and that all documents supplied are genuine and authentic. The Client is aware that the provision of false information or documents is likely to lead to an application being refused. ")]), _vm._v(" "), _c('li', [_vm._v("The Client will, during the processing of an application, notify the Agent of any material changes in the circumstances of the Client or the Client's immediate family. If the application is for an employer-sponsored visa, the Client agrees that they will take no other employment apart from the employment that is the subject of the sponsorship agreement. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent's professional fees can be invoiced on behalf of the Agent by the Agent's business entity, as listed on the MARA Register. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will not be held responsible for any consequential issues resulting from a failure to deposit cleared funds into the Agent's trust account when requested. This includes transfer failures, delayed transfers and payment failures. The Client is aware that failure to make prompt payments to the Department, review body or skills assessment body may lead to\n          an application being refused. ")]), _vm._v(" "), _c('li', [_vm._v("The Client will not contact DIAC directly. The Client will notify the Agent if they are contacted by DIAC in relation to this or any other matter. The Client agrees that the Agent is the sole contact with the Department and the Client will not contact the Department without agreement from the Agent. ")]), _vm._v(" "), _c('li', [_vm._v("The Client will advise the Agent of any change of contact details within two weeks of the change. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Client may terminate this agreement by providing written advice of the termination to the Agent. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent may terminate the agreement at any time, provided they provide reasonable written notice to the Client. This notice\n            must comply with the requirements in Clause 10.1A of the Code. If the Agent terminates the agreement, they must comply with\n            the requirements of Clause 10.1B of the Code. ")]), _vm._v(" "), _c('li', [_vm._v("If the agreement is terminated, the Client must pay any fees outstanding for work already performed by the Agent. ")]), _vm._v(" "), _c('li', [_vm._v("When the agreement is terminated, the Agent must deal with the Client's file in accordance with Part 10 of the Code. ")]), _vm._v(" "), _c('li', [_vm._v("The Client agrees that if the Client breaches this agreement, the Agent has the right to terminate the contract and invoice for full fees as per the cost arrangement, or in the alternative, the Agent has the right to charge hourly fees at the rate of $400 per hour for any additional services required as a result of the breach.")]), _vm._v(" "), _c('li', [_vm._v("The Client is entitled to a five working day Cooling Off period from the date this agreement is signed, within which they can withdraw the Agent's services. The Agent will reimburse the entire initial amount after deducting any administrative costs or professional fees for the time spent on the visa application within that time frame. After the Cooling Off period, no refund applies and the Agent is considered as appointed by the Client. After this time however, no refunds will be provided, including if the Agent determines that the Client is ineligible to apply for any visa.")]), _vm._v(" "), _c('li', [_vm._v("If this Agreement is handed, emailed, posted or otherwise delivered to the Client and the Client does not sign the Agreement and return it to the Agent, the Client will nonetheless be taken to have accepted its terms and conditions if the Client does not notify the Agent within 21 days of any concern the Client may have or otherwise permits work by the Agent to be commenced or continued in relation to the subject matter of the Agreement.")]), _vm._v(" "), _c('li', [_vm._v("Only under the circumstances that the Client's visa application is rejected by the DHA, due to a mistake on part of the Agent, a refund of Agent's professional fee after deducting reasonable administrative costs will be reimbursed to the Client.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Agent agrees to keep securely and in a way which will ensure confidentiality all documents provided by, or on behalf of, the Client or paid for by, or on behalf of, the Client until the earlier of:\n            ")]), _vm._v(" "), _c('li', [_vm._v("(i) 7 years after the date of the last action on the file for the Client; or")]), _vm._v(" "), _c('li', [_vm._v("(ii) when the documents are given to the Client or dealt with in accordance with the Client's written instructions.")]), _vm._v(" "), _c('li', [_vm._v("The Agent agrees to keep all other records required by Clause 6.1 of the Code for 7 years after the date of the last action on the file for the Client. ")]), _vm._v(" "), _c('li', [_vm._v("After this date the Agent may destroy the documents and records above in a way which will ensure confidentiality. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Agent will preserve the confidentiality of the Client. The Agent will not disclose confidential information about the Client or the Client's business without the Client's written consent, unless required by law. ")]), _vm._v(" "), _c('li', [_vm._v("If applicable, the Agent will preserve the confidentiality of the Client's medical records and documents in accordance with the Privacy Act.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Client, after making diligent inquiry, at the date of signing this Contract agrees that no Conflict exists or is likely to arise in the performance of obligations under this Contract by the Agent or the Agent's employees, or if a Conflict does exist that Conflict has been disclosed to the Agent in writing prior to the date of signing of this Contract.")]), _vm._v(" "), _c('li', [_vm._v("The Agent will endeavour to avoid Conflicts but is permitted to use its discretion when collecting or revealing information to any third party, unless the Client notifies the Agent in writing that such information is confidential.")]), _vm._v(" "), _c('li', [_vm._v("If any Conflict or potential Conflict arises or becomes apparent, the Client will provide written notice to the Agent without unreasonable delay and the Agent will cease acting for one or both parties at its discretion.")]), _vm._v(" "), _c('li', [_vm._v("The Agent will notify the parties if a potential Conflict has arisen without unreasonable delay.")]), _vm._v(" "), _c('li', [_vm._v("The Agent is otherwise bound by the MARA Code of Conduct with respect to Conflicts.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Agent disclaims and waives any liability or responsibility whatsoever for interception or unintentional disclosure of emails transmitted by the Agent, or through correspondence and personal documentation being temporarily stored on any 3rd party servers.")]), _vm._v(" "), _c('li', [_vm._v("The Client agrees that the Agent shall bear no liability for any loss or damage to any person or entity resulting from the use of email transmissions, including any consequential, incidental, direct, indirect, or special damages, such as loss of revenues or anticipated profits, or disclosure or communication of confidential or proprietary information. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("These conditions and all aspects of the performance of our services for you are governed by, and you agree to be bound by, the law of the NSW and the Code of Conduct. The Client and Agent irrevocably submit to the exclusive jurisdiction of the courts of the NSW and/or the Migration Agents Registration Authority.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("If an account remains unpaid thirty (30) days after you receive it, we may charge you interest at 2% above the Cash Rate.")]), _vm._v(" "), _c('li', [_vm._v("If the Client does not pay the account within the time frame listed in the Schedule, the Agent may stop work until paid. If the account continues to remain unpaid the Agent may cease to act for the Client.")]), _vm._v(" "), _c('li', [_vm._v(" If the Agent stops acting or ceases to act for the Client:\n            ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will not incur any liability as a result.")]), _vm._v(" "), _c('li', [_vm._v("The Client will receive a final account, which will include all outstanding fees.")]), _vm._v(" "), _c('li', [_vm._v("The Client must pay the Agent's legal costs up until the date when the Agent ceased to act.")]), _vm._v(" "), _c('li', [_vm._v("The Agent retains the right to exercise a lien over the Client's documents until the Agent is paid.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("This fee is calculated based on your instructions. If at a later date, these instructions change, new information is provided, or your circumstances change with the result that there is a substantial increase in the amount of work to be performed, then we reserve the right to ask for additional fees.")]), _vm._v(" "), _c('li', [_vm._v("If you decide at any stage to withdraw the application or decide that you do not wish us to be your Migrant Agent, we will charge you a reasonable fee for the work we have completed up until that point. Disbursement fees are generally not refundable.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Our fixed price quote represents a discounted scale fee for an average application. We will keep you informed of progress on your application, however, should you delay the application, not provide the information as required, or unnecessarily and continually have further queries we reserve the right to charge an additional time based fee which we will notify you of at that time. Hourly rates will be charged as per the figures below.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "costAgreementTable"
  }, [_c('div', {
    staticClass: "columns bg-gray"
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n                Hourly Rates"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Only incurred upon request. Fees are inclusive of GST.")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6 col-sm-7"
  }, [_vm._v("\n                Solicitor / Migration Lawyer\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-6 col-sm-5"
  }, [_vm._v("\n                $330 / hour\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6 col-sm-7"
  }, [_vm._v("\n                Migration Agent\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-6 col-sm-5"
  }, [_vm._v("\n                $165 / hour\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6 col-sm-7"
  }, [_vm._v("\n                Legal Clerk\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-6 col-sm-5"
  }, [_vm._v("\n                $110 / hour\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Other costs that are often incurred when applying for a visa are listed above.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns bg-gray"
  }, [_c('div', {
    staticClass: "column col-6"
  }, [_vm._v("\n                Visa Type\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-6"
  }, [_vm._v("\n                Processing Time\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consumerGuide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(430),
      "alt": "Consumer Guide"
    }
  })])
}]}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('suggest', {
    attrs: {
      "suggestions": _vm.suggestions,
      "inputProps": _vm.inputProps,
      "getSuggestionValue": _vm.getSuggestionValue,
      "renderSuggestion": _vm.renderSuggestion
    },
    on: {
      "selected": _vm.selectHandler
    }
  })
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.inv && _vm.inv.paid) ? _c('div', [_c('div', {
    staticClass: "columns border-bottom-lg"
  }, [_c('div', {
    staticClass: "column col-6"
  }, [(_vm.brand === 'pl') ? _c('img', {
    staticClass: "invoiceLogo",
    attrs: {
      "src": __webpack_require__(54),
      "alt": "PocketLegal"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('img', {
    staticClass: "invoiceLogo",
    attrs: {
      "src": __webpack_require__(35),
      "alt": "Immigration Experts"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.brand === 'pl') ? _c('div', {
    staticClass: "column col-6"
  }, [_vm._v("\n        PocketLegal Pty Ltd"), _c('br'), _vm._v("\n        162 Redfern Street"), _c('br'), _vm._v("\n        Redfern 2016, NSW"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:accounts@pocketlegal.com.au"
    }
  }, [_vm._v("accounts@pocketlegal.com.au")]), _c('br'), _vm._v("\n        Phone: (02) 8385 1451"), _c('br'), _vm._v("\n        ABN: 12 613 908 124"), _c('br'), _vm._v("\n        ACN: 613 908 124\n      ")]) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('div', {
    staticClass: "column col-6"
  }, [_vm._v("\n        Immigration Experts Pty Ltd"), _c('br'), _vm._v("\n        162 Redfern Street"), _c('br'), _vm._v("\n        Redfern 2016, NSW"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@immiexperts.com.au"
    }
  }, [_vm._v("info@immiexperts.com.au")]), _c('br'), _vm._v("\n        Phone: (02) 9279 1289"), _c('br'), _vm._v("\n        ABN: 12 613 908 124"), _c('br'), _vm._v("\n        ACN: 613 908 124\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "columns border-bottom-lg"
  }, [_c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Reference")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v(_vm._s(_vm.inv.ref))]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Client")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v(_vm._s(_vm.inv.business ? _vm.inv.business : _vm.inv.firstname + ' ' + _vm.inv.lastname))]), _vm._v(" "), (_vm.inv.business) ? _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Attn")]) : _vm._e(), _vm._v(" "), (_vm.inv.business) ? _c('div', {
    staticClass: "column col-8"
  }, [_vm._v(_vm._s(_vm.inv.firstname) + " " + _vm._s(_vm.inv.lastname))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Invoice date")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v(_vm._s(_vm.date(_vm.inv.date)))]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Invoice status")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Paid " + _vm._s(_vm.paymentDate(_vm.inv)))])])]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-lg"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_c('h2', [_vm._v("Description")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.inv.matter_desc))])])]), _vm._v(" "), _vm._l((_vm.inv.items), function(item) {
    return _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column col-4"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('div', {
      staticClass: "column col-8"
    }, [_vm._v("$" + _vm._s(_vm.c2d(item.cost)))])])
  }), _vm._v(" "), (_vm.inv.gst) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-4"
  }, [_vm._v("GST (10%)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v("$" + _vm._s(_vm.c2d(_vm.inv.gst)))])]) : _vm._e(), _vm._v(" "), (_vm.inv.surcharge) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Surcharge (1.4%)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v("$" + _vm._s(_vm.c2d(_vm.inv.surcharge)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v("$" + _vm._s(_vm.c2d(_vm.inv.total)))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "columns border-bottom-sm invoicePrint"
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_c('button', {
    staticClass: "btn bg-gray",
    on: {
      "click": _vm.print
    }
  }, [_vm._v("Print this page")])])]), _vm._v(" "), (_vm.inv.plan) ? _c('div', {
    staticClass: "paymentPlanTable"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_vm._m(1), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Monthly payment amount: $" + _vm._s(_vm.c2d(_vm.inv.monthly)))]), _vm._v(" "), _c('th', [_vm._v("Remaining: $" + _vm._s(_vm.c2d(_vm.inv.outstanding)))]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.payments(_vm.inv)), function(payment) {
    return _c('tr', [(_vm.inv.last_payment) ? _c('td', [_vm._v(_vm._s(payment.date))]) : _c('td', [_vm._v("Upcoming")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(payment.amount)))]), _vm._v(" "), _c('td', [(payment.paid) ? _c('span', {
      staticClass: "label label-rounded label-success"
    }, [_vm._v("Paid")]) : _c('span', {
      staticClass: "label label-rounded label-warning"
    }, [_vm._v("Scheduled")])])])
  }), 0)])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-6 text-right"
  }, [_c('h1', [_vm._v("Receipt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h4', [_vm._v("Your payment plan")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Monthly amount")]), _vm._v(" "), _c('th', [_vm._v("Status")])])
}]}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.matters), function(m) {
    return _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column col-5"
    }, [_c('router-link', {
      attrs: {
        "to": '/matters/' + m._id
      }
    }, [_vm._v(_vm._s(m.mattername))])], 1), _vm._v(" "), _c('div', {
      staticClass: "column col-5"
    }, [_vm._v("\n      Due " + _vm._s(new Date(m.due).toDateString()) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "column col-2"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.del(m)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.view) ? _c('div', {
    staticClass: "columns",
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "column col-5 col-md-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.view.title))])]), _vm._v(" "), _c('div', {
    staticClass: "column col-1 col-md-2"
  }, [(_vm.chosenDay) ? _c('button', {
    staticClass: "btn btn-sm",
    class: {
      loading: _vm.loadingEvents
    },
    on: {
      "click": _vm.openNewEventModal
    }
  }, [_vm._v("\n        New\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column col-3 col-md-5"
  }, [_c('div', {
    staticClass: "btn-group btn-group-block"
  }, [_c('button', {
    staticClass: "btn btn-sm",
    class: {
      active: _vm.monthView
    },
    on: {
      "click": _vm.changeView
    }
  }, [_vm._v("Month")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    class: {
      active: !_vm.monthView
    },
    on: {
      "click": _vm.changeView
    }
  }, [_vm._v("Week")])])]), _vm._v(" "), _c('div', {
    staticClass: "column col-3 col-md-5"
  }, [_c('div', {
    staticClass: "btn-group btn-group-block"
  }, [_c('button', {
    staticClass: "btn btn-sm",
    on: {
      "click": _vm.today
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    on: {
      "click": _vm.prev
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    on: {
      "click": _vm.next
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "calendar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showNewEventModal
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('a', {
    staticClass: "btn btn-clear float-right",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showNewEventModal = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title h5"
  }, [_vm._v("New event")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.chosenDay) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_vm._v(_vm._s(_vm.calendar.formatDate(_vm.chosenDay, 'DD/MM/YYYY')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEvent.title),
      expression: "newEvent.title"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newEvent.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEvent, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEvent.allDay),
      expression: "newEvent.allDay"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newEvent.allDay) ? _vm._i(_vm.newEvent.allDay, null) > -1 : (_vm.newEvent.allDay)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newEvent.allDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newEvent, "allDay", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newEvent, "allDay", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newEvent, "allDay", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])]), _vm._v(" "), (!_vm.newEvent.allDay) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newEvent.startHour),
      expression: "newEvent.startHour",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-select picktime",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.newEvent, "startHour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.hours), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(v))])
  }), 0), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newEvent.startMin),
      expression: "newEvent.startMin",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-select picktime",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.newEvent, "startMin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.minutes), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(v))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.newEvent.allDay) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newEvent.endHour),
      expression: "newEvent.endHour",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-select picktime",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.newEvent, "endHour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.hours), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(v))])
  }), 0), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newEvent.endMin),
      expression: "newEvent.endMin",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-select picktime",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.newEvent, "endMin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.minutes), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(v))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEvent.details),
      expression: "newEvent.details"
    }],
    staticClass: "form-input",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.newEvent.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEvent, "details", $event.target.value)
      }
    }
  })])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      loading: _vm.saving
    },
    on: {
      "click": _vm.makeEvent
    }
  }, [_vm._v("Save")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showEventModal
    }
  }, [(_vm.chosenEvent) ? _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('a', {
    staticClass: "btn btn-clear float-right",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showEventModal = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title h5"
  }, [_vm._v(_vm._s(_vm.chosenEvent.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_vm._v(_vm._s(_vm.calendar.formatDate(_vm.chosenEvent.start, 'DD/MM/YYYY')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chosenEvent.title),
      expression: "chosenEvent.title"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.chosenEvent.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chosenEvent, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chosenEvent.allDay),
      expression: "chosenEvent.allDay"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.chosenEvent.allDay) ? _vm._i(_vm.chosenEvent.allDay, null) > -1 : (_vm.chosenEvent.allDay)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.chosenEvent.allDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.chosenEvent, "allDay", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.chosenEvent, "allDay", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.chosenEvent, "allDay", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])]), _vm._v(" "), (!_vm.chosenEvent.allDay) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.chosenEvent.startHour),
      expression: "chosenEvent.startHour",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-select picktime",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.chosenEvent, "startHour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.hours), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(v))])
  }), 0), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.chosenEvent.startMin),
      expression: "chosenEvent.startMin",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-select picktime",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.chosenEvent, "startMin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.minutes), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(v))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.chosenEvent.allDay) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.chosenEvent.endHour),
      expression: "chosenEvent.endHour",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-select picktime",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.chosenEvent, "endHour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.hours), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(v))])
  }), 0), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.chosenEvent.endMin),
      expression: "chosenEvent.endMin",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-select picktime",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.chosenEvent, "endMin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.minutes), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(v))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chosenEvent.details),
      expression: "chosenEvent.details"
    }],
    staticClass: "form-input",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.chosenEvent.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chosenEvent, "details", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      loading: _vm.saving
    },
    on: {
      "click": _vm.updateEvent
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.deleteEvent
    }
  }, [_vm._v("Delete")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "toast",
    class: {
      'd-none': !_vm.hovering, 'd-block': _vm.hovering
    },
    attrs: {
      "id": "hoverDetails"
    }
  }, [_c('h6', [_vm._v(_vm._s(_vm.hoverTitle))]), _vm._v("\n    " + _vm._s(_vm.hoverDetails) + "\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("All day")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Start")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v(":")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("End")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v(":")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("All day")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Start")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v(":")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("End")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v(":")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Details")])])
}]}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "panel"
  }, [(_vm.verified && _vm.user) ? _c('div', {
    staticClass: "panelContent"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Hi " + _vm._s(_vm.user.profile.firstname) + ".")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Please set a password for your account, then login")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password_a),
      expression: "password_a"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password_a)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password_a = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password_b),
      expression: "password_b"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "password",
      "placeholder": "Confirm password"
    },
    domProps: {
      "value": (_vm.password_b)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password_b = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.success) ? _c('button', {
    staticClass: "btn btn-primary btn-block",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": _vm.setPassword
    }
  }, [_vm._v("Set")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "toast toast-error",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "toast toast-success",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("Success")])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('a', {
    staticClass: "nextStep",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "icon icon-forward"
  })]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "mattertable"
    }
  }, [_c('div', {
    staticClass: "row rowHeader"
  }, [_c('div', {
    staticClass: "cell cell01",
    on: {
      "click": function($event) {
        return _vm.toggleCol(1)
      }
    }
  }, [_vm._v("Client"), _c('i', {
    staticClass: "icon icon-caret",
    class: _vm.colClasses[_vm.colState[1]]
  })]), _vm._v(" "), _c('div', {
    staticClass: "cell cell02",
    on: {
      "click": function($event) {
        return _vm.toggleCol(2)
      }
    }
  }, [_vm._v("Subclass"), _c('i', {
    staticClass: "icon icon-caret",
    class: _vm.colClasses[_vm.colState[2]]
  })]), _vm._v(" "), _c('div', {
    staticClass: "draftDocIcon"
  }, [_vm._v("Draft Document")]), _vm._v(" "), _c('div', {
    staticClass: "cell cell03",
    on: {
      "click": function($event) {
        return _vm.toggleCol(3)
      }
    }
  }, [_vm._v("Stage"), _c('i', {
    staticClass: "icon icon-caret",
    class: _vm.colClasses[_vm.colState[3]]
  })]), _vm._v(" "), _c('div', {
    staticClass: "cell cell04",
    on: {
      "click": function($event) {
        return _vm.toggleCol(4)
      }
    }
  }, [_vm._v("Due"), _c('i', {
    staticClass: "icon icon-caret",
    class: _vm.colClasses[_vm.colState[4]]
  })]), _vm._v(" "), _c('div', {
    staticClass: "cell cell05 text-center",
    on: {
      "click": function($event) {
        return _vm.toggleCol(5)
      }
    }
  }, [_vm._v("Who"), _c('i', {
    staticClass: "icon icon-caret",
    class: _vm.colClasses[_vm.colState[5]]
  })]), _vm._v(" "), _c('div', {
    staticClass: "cell cell06",
    on: {
      "click": function($event) {
        return _vm.toggleCol(6)
      }
    }
  }, [_vm._v("Next Step"), _c('i', {
    staticClass: "icon icon-caret",
    class: _vm.colClasses[_vm.colState[6]]
  })]), _vm._v(" "), _c('div', {
    staticClass: "cell cell07",
    on: {
      "click": function($event) {
        return _vm.toggleCol(7)
      }
    }
  }, [_vm._v("Deadline"), _c('i', {
    staticClass: "icon icon-caret",
    class: _vm.colClasses[_vm.colState[7]]
  })]), _vm._v(" "), _c('div', {
    staticClass: "cell cell08",
    on: {
      "click": function($event) {
        return _vm.toggleCol(8)
      }
    }
  }, [_vm._v("Deadline Note"), _c('i', {
    staticClass: "icon icon-caret",
    class: _vm.colClasses[_vm.colState[8]]
  })]), _vm._v(" "), _c('div', {
    staticClass: "cell cell09",
    on: {
      "click": function($event) {
        return _vm.toggleCol(9)
      }
    }
  }, [_vm._v("Sponsor"), _c('i', {
    staticClass: "icon icon-caret",
    class: _vm.colClasses[_vm.colState[9]]
  })]), _vm._v(" "), _c('div', {
    staticClass: "cell cell10"
  }, [_vm._v("Delete")])]), _vm._v(" "), _vm._l((_vm.filtered), function(row, n) {
    return _c('div', {
      staticClass: "row",
      class: _vm.rowClass(row)
    }, [_c('div', {
      staticClass: "cell cell01",
      on: {
        "click": function($event) {
          _vm.s_cell = [n, 1]
        }
      }
    }, [_vm._v("\n        " + _vm._s(row[1]) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "cell cell02",
      on: {
        "click": function($event) {
          _vm.s_cell = [n, 2]
        }
      }
    }, [_vm._v("\n        " + _vm._s(row[2]) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "draftDocIcon"
    }, [_c('router-link', {
      attrs: {
        "to": '/docs/choosetype/false/' + row[13] + '/' + row[0]
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Draft")])], 1), _vm._v(" "), _c('div', {
      staticClass: "cell cell03",
      on: {
        "click": function($event) {
          _vm.s_cell = [n, 3]
        }
      }
    }, [(_vm.isSelected(n, 3)) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (row[3]),
        expression: "row[3]",
        modifiers: {
          "number": true
        }
      }, {
        name: "focus",
        rawName: "v-focus.lazy",
        value: (true),
        expression: "true",
        modifiers: {
          "lazy": true
        }
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return _vm._n(val)
          });
          _vm.$set(row, 3, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          $event.preventDefault();
          return _vm.saveRow(row, true)
        }],
        "blur": function($event) {
          _vm.s_cell = [0, 0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v("Document Collection")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("Drafting Application")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("Client Application Review")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "3"
      }
    }, [_vm._v("Lodged")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "4"
      }
    }, [_vm._v("RFI")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "5"
      }
    }, [_vm._v("RFI Complete")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "6"
      }
    }, [_vm._v("Granted")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "7"
      }
    }, [_vm._v("Early")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "8"
      }
    }, [_vm._v("Finalised")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "9"
      }
    }, [_vm._v("Natural Justice")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "10"
      }
    }, [_vm._v("Paused")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "11"
      }
    }, [_vm._v("Refused")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "12"
      }
    }, [_vm._v("Withdrawn")])]) : _c('div', [_vm._v(_vm._s(_vm.stages[row[3]]))])]), _vm._v(" "), _c('div', {
      staticClass: "cell cell04",
      on: {
        "click": function($event) {
          return _vm.openDate(n, 4)
        }
      }
    }, [_vm._v(_vm._s(_vm.dateStr(row[4])))]), _vm._v(" "), _c('div', {
      staticClass: "cell cell05 text-center",
      on: {
        "click": function($event) {
          _vm.s_cell = [n, 5]
        }
      }
    }, [(_vm.isSelected(n, 5)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row[5]),
        expression: "row[5]"
      }, {
        name: "focus",
        rawName: "v-focus.lazy",
        value: (true),
        expression: "true",
        modifiers: {
          "lazy": true
        }
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (row[5])
      },
      on: {
        "change": function($event) {
          $event.preventDefault();
          return _vm.saveRow(row, false)
        },
        "blur": function($event) {
          _vm.s_cell = [0, 0]
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, 5, $event.target.value)
        }
      }
    }) : _c('div', [_vm._v(_vm._s(row[5]))])]), _vm._v(" "), _c('div', {
      staticClass: "cell cell06",
      on: {
        "click": function($event) {
          _vm.s_cell = [n, 6]
        }
      }
    }, [(_vm.isSelected(n, 6)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row[6]),
        expression: "row[6]"
      }, {
        name: "focus",
        rawName: "v-focus.lazy",
        value: (true),
        expression: "true",
        modifiers: {
          "lazy": true
        }
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (row[6])
      },
      on: {
        "change": function($event) {
          $event.preventDefault();
          return _vm.saveRow(row, false)
        },
        "blur": function($event) {
          _vm.s_cell = [0, 0]
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, 6, $event.target.value)
        }
      }
    }) : _c('div', [_vm._v(_vm._s(row[6]))])]), _vm._v(" "), _c('div', {
      staticClass: "cell cell07",
      on: {
        "click": function($event) {
          return _vm.openDate(n, 7)
        }
      }
    }, [_vm._v(_vm._s(_vm.dateStr(row[7])))]), _vm._v(" "), _c('div', {
      staticClass: "cell cell08",
      on: {
        "click": function($event) {
          _vm.s_cell = [n, 8]
        }
      }
    }, [(_vm.isSelected(n, 8)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row[8]),
        expression: "row[8]"
      }, {
        name: "focus",
        rawName: "v-focus.lazy",
        value: (true),
        expression: "true",
        modifiers: {
          "lazy": true
        }
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (row[8])
      },
      on: {
        "change": function($event) {
          $event.preventDefault();
          return _vm.saveRow(row, false)
        },
        "blur": function($event) {
          _vm.s_cell = [0, 0]
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, 8, $event.target.value)
        }
      }
    }) : _c('div', [_vm._v(_vm._s(row[8]))])]), _vm._v(" "), _c('div', {
      staticClass: "cell cell09",
      on: {
        "click": function($event) {
          _vm.s_cell = [n, 9]
        }
      }
    }, [(_vm.isSelected(n, 9)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row[9]),
        expression: "row[9]"
      }, {
        name: "focus",
        rawName: "v-focus.lazy",
        value: (true),
        expression: "true",
        modifiers: {
          "lazy": true
        }
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (row[9])
      },
      on: {
        "change": function($event) {
          $event.preventDefault();
          return _vm.saveRow(row, false)
        },
        "blur": function($event) {
          _vm.s_cell = [0, 0]
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, 9, $event.target.value)
        }
      }
    }) : _c('div', [_vm._v(_vm._s(row[9]))])]), _vm._v(" "), _c('div', {
      staticClass: "cell cell10"
    }, [_c('div', {
      staticClass: "archive-btn"
    }, [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.archive(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-archive-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showDateModal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    attrs: {
      "id": "datebox"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "btn btn-clear float-right",
    on: {
      "click": function($event) {
        _vm.showDateModal = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Change Date")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('datepicker', {
    attrs: {
      "inline": true
    },
    on: {
      "selected": _vm.setDate
    },
    model: {
      value: (_vm.chosenDate),
      callback: function($$v) {
        _vm.chosenDate = $$v
      },
      expression: "chosenDate"
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.matters) ? _c('div', {
    staticClass: "panel-nav"
  }, [_c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.matters), function(m, n) {
    return _c('li', {
      staticClass: "tab-item",
      class: {
        active: _vm.tab === n
      }
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.tab = n
        }
      }
    }, [_vm._v(_vm._s(m.visatype.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.matters), function(m, n) {
    return _c('matterdocs', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tab === n),
        expression: "tab === n"
      }],
      key: m.matter._id,
      attrs: {
        "matterdata": m
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6 col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-back"
  }), _c('span', [_vm._v("Back")])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [(_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.corporate),
      expression: "newUser.profile.corporate"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newUser.profile.corporate) ? _vm._i(_vm.newUser.profile.corporate, null) > -1 : (_vm.newUser.profile.corporate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newUser.profile.corporate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newUser.profile, "corporate", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newUser.profile, "corporate", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newUser.profile, "corporate", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.brand),
      expression: "newUser.profile.brand"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser.profile, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.brands), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(v))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.business),
      expression: "newUser.profile.business"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.profile.business)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser.profile, "business", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.firstname),
      expression: "newUser.profile.firstname"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.profile.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser.profile, "firstname", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.lastname),
      expression: "newUser.profile.lastname"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.profile.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser.profile, "lastname", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_d),
      expression: "dob_d"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "DD"
    },
    domProps: {
      "value": (_vm.dob_d)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_d = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_m),
      expression: "dob_m"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "MM"
    },
    domProps: {
      "value": (_vm.dob_m)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_m = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_y),
      expression: "dob_y"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "YYYY"
    },
    domProps: {
      "value": (_vm.dob_y)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_y = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.address1),
      expression: "newUser.profile.address1"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.profile.address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser.profile, "address1", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.address2),
      expression: "newUser.profile.address2"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.profile.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser.profile, "address2", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.suburb),
      expression: "newUser.profile.suburb"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.profile.suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser.profile, "suburb", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.postcode),
      expression: "newUser.profile.postcode"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.profile.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser.profile, "postcode", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.passport),
      expression: "newUser.profile.passport"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.profile.passport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser.profile, "passport", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.country),
      expression: "newUser.profile.country"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser.profile, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.countries), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(k))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.newUser.profile.country === 'AUSTRALIA') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.state),
      expression: "newUser.profile.state"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser.profile, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")])]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.state),
      expression: "newUser.profile.state"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.profile.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser.profile, "state", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.phone),
      expression: "newUser.profile.phone"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": (_vm.newUser.profile.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser.profile, "phone", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.source),
      expression: "newUser.profile.source"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser.profile, "source", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sources), function(s) {
    return _c('option', {
      domProps: {
        "value": s
      }
    }, [_vm._v(_vm._s(s))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.newClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.profile.details),
      expression: "newUser.profile.details"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.profile.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser.profile, "details", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.make($event)
      }
    }
  }, [_vm._v("Make")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.success) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Success")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Corporate")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Brand")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Business Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("First name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Last name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Date of birth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Address line 1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Address line 2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Suburb")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Postcode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Passport number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Country")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("State")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Phone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Client source")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("More details")])])
}]}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visatype) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "panel outer-panel"
  }, [_c('div', {
    staticClass: "panel-nav",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.secKey === -2
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.secKey = -2
      }
    }
  }, [_vm._v("Info")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.secKey === -1
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.secKey = -1
      }
    }
  }, [_vm._v("Documents")])]), _vm._v(" "), _vm._l((_vm.visatype.sections), function(section, key) {
    return _c('li', {
      staticClass: "tab-item",
      class: {
        active: _vm.secKey === key
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDocs = false;
          _vm.secKey = key
        }
      }
    }, [_vm._v(_vm._s(section.name))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "tab-item tab-action"
  }, [_c('div', {
    staticClass: "input-group input-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSectionName),
      expression: "newSectionName"
    }],
    staticClass: "form-input input-sm",
    attrs: {
      "type": "text",
      "placeholder": "New section"
    },
    domProps: {
      "value": (_vm.newSectionName)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addSection($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSectionName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm input-group-btn",
    on: {
      "click": _vm.addSection
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-inline"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.saving
    },
    on: {
      "click": _vm.saveType
    }
  }, [_vm._v("Save")])])])], 2)]), _vm._v(" "), (_vm.secKey === -2) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visatype.info),
      expression: "visatype.info"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "HTML",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.visatype.info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.visatype, "info", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visatype.checklist_id),
      expression: "visatype.checklist_id"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.visatype.checklist_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.visatype, "checklist_id", $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.secKey === -1) ? _c('div', {
    staticClass: "panel-body"
  }, [(!_vm.visatype.doctypes || !_vm.visatype.doctypes.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('h5', {
    staticClass: "empty-title"
  }, [_vm._v("There are no documents for this matter type")]), _vm._v(" "), _c('div', {
    staticClass: "empty-action"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.showDocModal = true
      }
    }
  }, [_vm._v("Make a document type")])])]) : _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Help text")]), _vm._v(" "), _c('th', [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showDocModal = true
      }
    }
  }, [_vm._v("New")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.visatype.doctypes), function(d, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(d.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(d.helptext))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.openEditDoc(d, i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.delDoc(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.moveDoc(i, 1)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-arrow-down"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.moveDoc(i, -1)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-arrow-up"
    })])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.secKey >= 0) ? _c('div', {
    staticClass: "panel-body"
  }, [(!_vm.visatype.sections.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('h4', {
    staticClass: "empty-title"
  }, [_vm._v("There are no sections for this matter type")])]) : (!_vm.visatype.sections[_vm.secKey].subsections.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('h4', {
    staticClass: "empty-title"
  }, [_vm._v("No subsections")])]) : _vm._l((_vm.visatype.sections[_vm.secKey].subsections), function(sub, subKey) {
    return _c('div', {
      staticClass: "panel subPanel"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('div', {
      staticClass: "panel-title",
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('p', {
      staticStyle: {
        "margin": "0"
      }
    }, [_vm._v(_vm._s(sub.name))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-clear",
      on: {
        "click": function($event) {
          return _vm.delSubsection(subKey)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "subControls"
    }, [_c('label', {
      staticClass: "form-checkbox",
      staticStyle: {
        "padding-right": "0"
      }
    }, [_vm._v("Repeatable\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sub.repeatable),
        expression: "sub.repeatable"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(sub.repeatable) ? _vm._i(sub.repeatable, null) > -1 : (sub.repeatable)
      },
      on: {
        "change": function($event) {
          var $$a = sub.repeatable,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(sub, "repeatable", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(sub, "repeatable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(sub, "repeatable", $$c)
          }
        }
      }
    }), _c('i', {
      staticClass: "form-icon"
    })]), _vm._v(" |\n            "), _c('label', {
      staticClass: "form-checkbox",
      staticStyle: {
        "padding-right": "0"
      }
    }, [_vm._v("For Client\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sub.for_client),
        expression: "sub.for_client"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(sub.for_client) ? _vm._i(sub.for_client, null) > -1 : (sub.for_client)
      },
      on: {
        "change": function($event) {
          var $$a = sub.for_client,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(sub, "for_client", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(sub, "for_client", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(sub, "for_client", $$c)
          }
        }
      }
    }), _c('i', {
      staticClass: "form-icon"
    })]), _vm._v(" |\n            "), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openDeps(sub, subKey)
        }
      }
    }, [_vm._v("Deps")]), _vm._v(" |\n            "), _c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.moveSub(subKey, 1)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-arrow-down"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.moveSub(subKey, -1)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-arrow-up"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [(!sub.questions.length) ? _c('div', {
      staticClass: "empty"
    }, [_c('h4', {
      staticClass: "empty-title"
    }, [_vm._v("No questions")]), _vm._v(" "), _c('div', {
      staticClass: "empty-action"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.openNewQ(subKey, 0)
        }
      }
    }, [_vm._v("Add a question")])])]) : _c('table', {
      staticClass: "table table-striped"
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', _vm._l((sub.questions), function(q, qKey) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(q.text))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "40%"
        }
      }, [_vm._v(_vm._s(q.helptext))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "5%"
        }
      }, [_vm._v(_vm._s(q.type))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "right",
          "width": "25%"
        }
      }, [_c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.openEditQ(subKey, qKey)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.delQ(subKey, qKey)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash-o",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.openNewQ(subKey, qKey)
          }
        }
      }, [_c('i', {
        staticClass: "icon icon-plus"
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.moveQ(subKey, qKey, 1)
          }
        }
      }, [_c('i', {
        staticClass: "icon icon-arrow-down"
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.moveQ(subKey, qKey, -1)
          }
        }
      }, [_c('i', {
        staticClass: "icon icon-arrow-up"
      })])])])
    }), 0)])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.secKey >= 0) ? _c('div', {
    staticClass: "panel-footer"
  }, [(_vm.visatype.sections.length) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "column col-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSubName),
      expression: "newSubName"
    }],
    staticClass: "form-input input-sm",
    attrs: {
      "type": "text",
      "placeholder": "New subsection"
    },
    domProps: {
      "value": (_vm.newSubName)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addSubsection($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSubName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary input-group-btn btn-sm",
    on: {
      "click": _vm.addSubsection
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticClass: "column col-2"
  }, [_c('button', {
    staticClass: "btn btn-sm float-right",
    on: {
      "click": _vm.delSection
    }
  }, [_vm._v("Delete section")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showQModal
    },
    attrs: {
      "id": "editQ"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "btn btn-clear float-right",
    on: {
      "click": _vm.closeQ
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.editingQ ? 'Edit question' : 'New question'))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.type),
      expression: "tempQ.type"
    }],
    staticClass: "form-select",
    attrs: {
      "id": "editqtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempQ, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "text"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yn"
    }
  }, [_vm._v("Y/N")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "select"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "date"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "number"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "textarea"
    }
  }, [_vm._v("Text area")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "language"
    }
  }, [_vm._v("Language")])])])]), _vm._v(" "), (_vm.tempQ.type === 'select') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectInput),
      expression: "selectInput"
    }],
    staticClass: "form-input",
    attrs: {
      "id": "editqtxt",
      "placeholder": "<display>, <value>"
    },
    domProps: {
      "value": (_vm.selectInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectInput = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.text),
      expression: "tempQ.text"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "id": "editqtxt",
      "placeholder": "Question text"
    },
    domProps: {
      "value": (_vm.tempQ.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempQ, "text", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.helptext),
      expression: "tempQ.helptext"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "id": "editqhelptxt",
      "placeholder": "Help text"
    },
    domProps: {
      "value": (_vm.tempQ.helptext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempQ, "helptext", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.dependent),
      expression: "tempQ.dependent"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tempQ.dependent) ? _vm._i(_vm.tempQ.dependent, null) > -1 : (_vm.tempQ.dependent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tempQ.dependent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tempQ, "dependent", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tempQ, "dependent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tempQ, "dependent", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])]), _vm._v(" "), (_vm.tempQ.dependent) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.depends.ref),
      expression: "tempQ.depends.ref"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempQ.depends, "ref", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Choose a question")]), _vm._v(" "), _vm._l((_vm.boolQuestions), function(q) {
    return _c('option', {
      domProps: {
        "value": q.ref
      }
    }, [_vm._v(_vm._s(q.text))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.tempQ.dependent) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.depends.atxt),
      expression: "tempQ.depends.atxt"
    }],
    attrs: {
      "type": "radio",
      "value": "y"
    },
    domProps: {
      "checked": _vm._q(_vm.tempQ.depends.atxt, "y")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempQ.depends, "atxt", "y")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v("Yes\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.depends.atxt),
      expression: "tempQ.depends.atxt"
    }],
    attrs: {
      "type": "radio",
      "value": "n"
    },
    domProps: {
      "checked": _vm._q(_vm.tempQ.depends.atxt, "n")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempQ.depends, "atxt", "n")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v("No\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editingQ) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.editQ
    }
  }, [_vm._v("Done")]) : _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addQ
    }
  }, [_vm._v("Save")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showDocModal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "btn btn-clear float-right",
    on: {
      "click": _vm.closeQ
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Edit document type")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempDoc.name),
      expression: "tempDoc.name"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tempDoc.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempDoc, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempDoc.helptext),
      expression: "tempDoc.helptext"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.tempDoc.helptext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempDoc, "helptext", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempDoc.dependent),
      expression: "tempDoc.dependent"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tempDoc.dependent) ? _vm._i(_vm.tempDoc.dependent, null) > -1 : (_vm.tempDoc.dependent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tempDoc.dependent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tempDoc, "dependent", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tempDoc, "dependent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tempDoc, "dependent", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])]), _vm._v(" "), (_vm.tempDoc.dependent) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempDoc.depends.ref),
      expression: "tempDoc.depends.ref"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempDoc.depends, "ref", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Choose a question")]), _vm._v(" "), _vm._l((_vm.boolQuestions), function(q) {
    return _c('option', {
      domProps: {
        "value": q.ref
      }
    }, [_vm._v(_vm._s(q.text))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.tempDoc.dependent) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempDoc.depends.atxt),
      expression: "tempDoc.depends.atxt"
    }],
    attrs: {
      "type": "radio",
      "value": "y"
    },
    domProps: {
      "checked": _vm._q(_vm.tempDoc.depends.atxt, "y")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempDoc.depends, "atxt", "y")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v("Yes\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempDoc.depends.atxt),
      expression: "tempDoc.depends.atxt"
    }],
    attrs: {
      "type": "radio",
      "value": "n"
    },
    domProps: {
      "checked": _vm._q(_vm.tempDoc.depends.atxt, "n")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempDoc.depends, "atxt", "n")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v("No\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editingDoc) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeQ
    }
  }, [_vm._v("Done")]) : _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addDoc
    }
  }, [_vm._v("Save")])])])])])])])]), _vm._v(" "), (_vm.visatype && _vm.subKey > -1) ? _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showDepsModal
    },
    attrs: {
      "id": "editDeps"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "btn btn-clear float-right",
    on: {
      "click": function($event) {
        _vm.showDepsModal = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Dependencies")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depRef),
      expression: "depRef"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.depRef = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Choose a question")]), _vm._v(" "), _vm._l((_vm.boolQuestions), function(q) {
    return _c('option', {
      domProps: {
        "value": q.ref
      }
    }, [_vm._v(_vm._s(q.text))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depVal),
      expression: "depVal"
    }],
    attrs: {
      "type": "radio",
      "value": "y"
    },
    domProps: {
      "checked": _vm._q(_vm.depVal, "y")
    },
    on: {
      "change": function($event) {
        _vm.depVal = "y"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v("Yes\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depVal),
      expression: "depVal"
    }],
    attrs: {
      "type": "radio",
      "value": "n"
    },
    domProps: {
      "checked": _vm._q(_vm.depVal, "n")
    },
    on: {
      "change": function($event) {
        _vm.depVal = "n"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v("No\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addDep($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetDep
    }
  }, [_vm._v("Reset")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        _vm.showDepsModal = false
      }
    }
  }, [_vm._v("Close")])])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Matter Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Checklist ID")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Question")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Help text")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "editqtype"
    }
  }, [_vm._v("Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "editqtxt"
    }
  }, [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Text")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "editqhelptxt"
    }
  }, [_vm._v("Help text")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Conditional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Display if")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("is")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Help text")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Conditional?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Display if")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("is")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Display if")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("is")])])
}]}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-8 col-md-12"
  }, [_c('form', {
    staticClass: "float-left"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTypeField),
      expression: "newTypeField"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "id": "visaTypeName",
      "placeholder": "Create new visa type"
    },
    domProps: {
      "value": (_vm.newTypeField)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTypeField = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary input-group-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.addType
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn input-group-btn",
    staticStyle: {
      "color": "#136efb",
      "border-color": "#136efb"
    },
    on: {
      "click": _vm.importType
    }
  }, [_c('i', {
    staticClass: "icon icon-upload"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-8 col-md-12"
  }, _vm._l((_vm.visatypes), function(type, index) {
    return _c('div', [_c('div', {
      staticClass: "visatype"
    }, [_c('h3', [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editType(type)
        }
      }
    }, [_vm._v(_vm._s(type.name))])]), _vm._v(" "), _c('div', {
      staticClass: "tile-action"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.editType(type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.exportType(type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.delType(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "column col-6 col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-8"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('searchClients', {
    on: {
      "selected": _vm.selectClient
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.visatype),
      expression: "agreement.visatype"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.agreement, "visatype", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.visatypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type.name
      }
    }, [_vm._v(_vm._s(type.name))])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column col-8 col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.no_gst),
      expression: "agreement.no_gst"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreement.no_gst) ? _vm._i(_vm.agreement.no_gst, null) > -1 : (_vm.agreement.no_gst)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agreement.no_gst,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.agreement, "no_gst", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.agreement, "no_gst", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.agreement, "no_gst", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.description),
      expression: "newItem.description"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newItem, "description", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.selDesc]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Standard Business Sponsorship"
    }
  }, [_vm._v("Standard Business Sponsorship")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "482 Primary"
    }
  }, [_vm._v("482 Primary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "482 Nomination"
    }
  }, [_vm._v("482 Nomination")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Labour Market Testing (LMT)"
    }
  }, [_vm._v("Labour Market Testing (LMT)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "186 Primary"
    }
  }, [_vm._v("186 Primary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "186 Nomination"
    }
  }, [_vm._v("186 Nomination")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skills Assessment"
    }
  }, [_vm._v("Skills Assessment")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dependant O18"
    }
  }, [_vm._v("Dependant (Family Member over 18)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dependant U18"
    }
  }, [_vm._v("Dependant (Family Member under 18)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Visitor Visa (subclass 600)"
    }
  }, [_vm._v("Visitor Visa (subclass 600)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Onshore Partner Visa Application (sublass 820)"
    }
  }, [_vm._v("Onshore Partner Visa Application (sublass 820)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Offshore Partner Visa Application (sublass 309)"
    }
  }, [_vm._v("Offshore Partner Visa Application (sublass 309)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australian Citizenship Application"
    }
  }, [_vm._v("Australian Citizenship Application")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "189 Application"
    }
  }, [_vm._v("189 Application")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "190 Application"
    }
  }, [_vm._v("190 Application")]), _vm._v(" "), (_vm.otheritem) ? _c('option', {
    domProps: {
      "value": _vm.otheritem
    }
  }, [_vm._v(_vm._s(_vm.otheritem))]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newItem.cost),
      expression: "newItem.cost",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newItem.cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "cost", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newItem.quantity),
      expression: "newItem.quantity",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "value": "1"
    },
    domProps: {
      "value": (_vm.newItem.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "quantity", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItem($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  })])])]), _vm._v(" "), _vm._l((_vm.agreement.items), function(item, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(item.cost)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.delItem(i)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-minus"
    })])])])
  }), _vm._v(" "), (_vm.total) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.total)))]), _vm._v(" "), _c('td')]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.withInvoice) ? _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.withInvoice = false
      }
    }
  }, [_vm._v("Remove Invoice")])]) : (_vm.newAgreement) ? _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSendModal = true
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Agreement created")]), _vm._v(" "), (_vm.newAgreement && _vm.newAgreement.sent) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Agreement sent")]) : _vm._e()]) : _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.isLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.make($event)
      }
    }
  }, [_vm._v("Make")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.withInvoice = true
      }
    }
  }, [_vm._v("Add Invoice")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), (_vm.agreementErr) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.agreementErr))]) : _vm._e()]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.withInvoice),
      expression: "withInvoice"
    }],
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInvItem.description),
      expression: "newInvItem.description"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newInvItem, "description", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.selItem]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.descriptions), function(d) {
    return _c('option', {
      domProps: {
        "value": d
      }
    }, [_vm._v(_vm._s(d))])
  })], 2)]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newInvItem.cost),
      expression: "newInvItem.cost",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.newInvItem.cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInvItem, "cost", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addInvItem($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  })])])]), _vm._v(" "), _vm._l((_vm.invoice.items), function(item, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(item.cost)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.delInvItem(i)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-minus"
    })])])])
  }), _vm._v(" "), (_vm.totals[0]) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("GST")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.totals[0])))])]) : _vm._e(), _vm._v(" "), (_vm.totals[1]) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Surcharge")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.totals[1])))])]) : _vm._e(), _vm._v(" "), (_vm.totals[2]) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.totals[2])))])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-9 flexcol"
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan),
      expression: "plan"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.plan) ? _vm._i(_vm.plan, null) > -1 : (_vm.plan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plan = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-5 col-ml-auto"
  }, [(_vm.plan) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Initial payment $")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.plan_initial),
      expression: "plan_initial",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.plan_initial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan_initial = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.plan) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Monthly payment $")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.plan_monthly),
      expression: "plan_monthly",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.plan_monthly)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan_monthly = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }), _vm._v(" "), (_vm.newAgreement) ? _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSendModal = true
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Clear")]), _vm._v(" "), (_vm.newAgreement.sent) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Agreement and invoice sent")]) : _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Agreement and invoice created")])]) : _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.isLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.make($event)
      }
    }
  }, [_vm._v("Make")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), (_vm.invoiceErr) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.invoiceErr))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.othermodal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Item description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otheritem),
      expression: "otheritem"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.otheritem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otheritem = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.othermodal = false;
        _vm.newItem.description = _vm.otheritem
      }
    }
  }, [_vm._v("Done")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.otherInvModal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Item description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInvDesc),
      expression: "newInvDesc"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.newInvDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newInvDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInvItem.surcharge),
      expression: "newInvItem.surcharge"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newInvItem.surcharge) ? _vm._i(_vm.newInvItem.surcharge, null) > -1 : (_vm.newInvItem.surcharge)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newInvItem.surcharge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newInvItem, "surcharge", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newInvItem, "surcharge", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newInvItem, "surcharge", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" Surcharge\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addInvDesc($event)
      }
    }
  }, [_vm._v("Done")])])])]), _vm._v(" "), _c('sendModal', {
    attrs: {
      "show": _vm.showSendModal,
      "agreement": _vm.newAgreement,
      "invoice": _vm.newInvoice
    },
    on: {
      "close": function($event) {
        _vm.showSendModal = false
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Client")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Service Category")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-4 col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("No GST")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Cost")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Items")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Cost")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Payment plan")])])
}]}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "navbar"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(54),
      "alt": "PocketLegal"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-hand",
    attrs: {
      "id": "username"
    }
  }, [_c('avatar', {
    staticClass: "headerAvatar",
    attrs: {
      "user": _vm.user
    }
  }), _vm._v("\n        " + _vm._s(_vm.user.profile.firstname) + " " + _vm._s(_vm.user.profile.lastname) + "\n        "), _c('span', {
    staticClass: "chevron"
  }), _vm._v(" "), _c('div', {
    staticClass: "usernameMenu"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Edit Profile\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "logout c-hand",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Logout\n          ")])])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar-toggle"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.invoices), function(inv, i) {
    return _c('div', {
      staticClass: "tile ClientPayment"
    }, [_c('div', {
      staticClass: "tile-content"
    }, [_c('span', {
      staticClass: "tile-title c-hand",
      on: {
        "click": function($event) {
          return _vm.setInv(inv)
        }
      }
    }, [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column col-2"
    }, [_vm._v(_vm._s(inv.ref))]), _vm._v(" "), _c('div', {
      staticClass: "column col-2"
    }, [_vm._v(_vm._s(_vm.date(inv.date)))]), _vm._v(" "), _c('div', {
      staticClass: "column col-4"
    }, [_vm._v(_vm._s(inv.matter_desc))]), _vm._v(" "), _c('div', {
      staticClass: "column col-1 col-ml-auto"
    }, [_c('div', {
      staticClass: "tile-icon"
    }, [(inv.paid) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Paid")]) : _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Unpaid")])])])])])]), _vm._v(" "), (_vm.sel_inv === inv) ? _c('div', [_c('table', {
      staticClass: "table"
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', [_vm._l((inv.items), function(item) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(item.cost)))])])
    }), _vm._v(" "), (inv.gst) ? _c('tr', [_c('td', [_vm._v("GST (10%)")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(inv.gst)))])]) : _vm._e(), _vm._v(" "), (inv.surcharge) ? _c('tr', [_c('td', [_vm._v("Surcharge (1.4%)")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(inv.surcharge)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(inv.total)))])]), _vm._v(" "), (!inv.paid) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [(_vm.showPayBtn) ? _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.showPay = true
        }
      }
    }, [_vm._v("Pay")]) : _vm._e()])]) : _vm._e()], 2)]), _vm._v(" "), (inv.plan) ? _c('div', {
      staticClass: "paymentPlanTable"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [_vm._m(2, true), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Monthly payment amount: $" + _vm._s(_vm.c2d(inv.monthly)))]), _vm._v(" "), _c('th', [_vm._v("Remaining: $" + _vm._s(_vm.c2d(inv.outstanding)))]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._m(3, true)]), _vm._v(" "), _c('tbody', _vm._l((_vm.payments(inv)), function(payment) {
      return _c('tr', [(inv.last_payment) ? _c('td', [_vm._v(_vm._s(payment.date))]) : _c('td', [_vm._v("Upcoming")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(payment.amount)))]), _vm._v(" "), _c('td', [(payment.paid) ? _c('span', {
        staticClass: "label label-rounded label-success"
      }, [_vm._v("Paid")]) : _c('span', {
        staticClass: "label label-rounded label-warning"
      }, [_vm._v("Scheduled")])])])
    }), 0)])]) : _vm._e()]) : _vm._e()])])
  }), _vm._v(" "), _c('payment', {
    attrs: {
      "invoice": _vm.sel_inv,
      "active": _vm.showPay
    },
    on: {
      "hide": function($event) {
        _vm.showPay = false
      },
      "payment": _vm.getInvoices
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-2 text-bold"
  }, [_vm._v("\n        Reference\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-2 text-bold"
  }, [_vm._v("\n        Date\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4 text-bold"
  }, [_vm._v("\n        Description\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-1 col-ml-auto text-bold"
  }, [_vm._v("\n        Status\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Item description")]), _vm._v(" "), _c('th', [_vm._v("Cost")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h4', [_vm._v("Your payment plan")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Monthly amount")]), _vm._v(" "), _c('th', [_vm._v("Status")])])
}]}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.doctypes), function(doctype) {
    return _c('div', {
      staticClass: "panel"
    }, [_c('div', {
      staticClass: "col-7 col-md-12"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('div', {
      staticClass: "panel-title h5"
    }, [_vm._v(_vm._s(doctype.name))]), _vm._v(" "), (doctype.helptext) ? _c('div', {
      staticClass: "tooltipz",
      domProps: {
        "innerHTML": _vm._s(doctype.helptext)
      }
    }) : _vm._e(), _vm._v(" "), _c('upload', {
      attrs: {
        "matter": _vm.matter,
        "doctype": doctype
      },
      on: {
        "new": _vm.addFile
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, _vm._l((_vm.files[doctype.ref]), function(file, index) {
      return _c('file-item', {
        key: file.id,
        attrs: {
          "file": file,
          "matter": _vm.matter
        },
        on: {
          "deleted": function($event) {
            return _vm.delFile(doctype.ref, index)
          }
        }
      })
    }), 1)])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.validated) ? _c('div', [_c('app-header'), _vm._v(" "), _c('sidebar'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.isAdmin) ? _c('router-view') : (_vm.clientReady) ? _c('router-view', {
    attrs: {
      "name": "client"
    }
  }) : _vm._e()], 1)], 1) : (_vm.agreement) ? _c('agreement') : (_vm.setpwd) ? _c('setpassword') : (_vm.invoice) ? _c('invoice') : (_vm.receipt) ? _c('receipt') : _c('login')], 1)
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.to_editor === 'true') ? _c('ul', {
    staticClass: "docCreation"
  }, _vm._l((_vm.matterTypes), function(t) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/docs/choosetype/true/' + t._id + '/none'
      }
    }, [_vm._v(_vm._s(t.name))])], 1)
  }), 0) : _c('ul', {
    staticClass: "docCreation"
  }, _vm._l((_vm.matterTypes), function(t) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/docs/choosetype/false/' + t._id + '/' + _vm.matter_id
      }
    }, [_vm._v(_vm._s(t.name))])], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.file.name) ? _c('div', {
    staticClass: "tile tile-centered"
  }, [_c('div', {
    staticClass: "tile-icon"
  }, [(_vm.file.accepted) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Approved")]) : _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Pending approval")])]), _vm._v(" "), _c('div', {
    staticClass: "tile-content"
  }, [_c('p', {
    staticClass: "tile-title"
  }, [_vm._v(_vm._s(_vm.file.name))]), _vm._v(" "), (_vm.error) ? _c('label', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tile-action"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      loading: _vm.saving
    },
    on: {
      "click": _vm.del
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-7 col-md-12"
  }, [_c('h1', [_vm._v("Hey " + _vm._s(_vm.user.profile.firstname) + "!")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.matterinfo)
    }
  }, [_vm._v("fff")]), _vm._v(" "), _c('p', [_vm._v("Welcome!")]), _vm._v(" "), _c('p', [_vm._v("Using the PocketLegal service is easy, and starts with two steps. Firstly, answer the questions in the visa tab. Then upload the relevant documents in the documents tab.")]), _vm._v(" "), _c('p', [_vm._v("After we review your documents, we will draft the application, then send it to you for a final review before submitting it.")]), _vm._v(" "), _c('h4', [_vm._v("Office Details")]), _vm._v(" "), _c('p', [_vm._v("Please contact us at any stage throughout the process. We're here to help!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-phone-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" (02) 8385 1451")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@pocketlegal.com.au"
    }
  }, [_vm._v("info@pocketlegal.com.au")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-building",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Office: 162 Redfern Street, Redfern 2016, NSW")])
}]}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('avatar', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), (_vm.editing && _vm.user.profile.avatar) ? _c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.delAvatar
    }
  }, [_vm._v("Delete")]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('image-uploader', {
    attrs: {
      "maxWidth": 128,
      "maxHeight": 128,
      "quality": 0.9,
      "preview": true,
      "className": ['form-input']
    },
    on: {
      "input": _vm.setPic
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.brand),
      expression: "user.profile.brand"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user.profile, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.brands), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(v))])
  }), 0)]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.getBrand()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.firstname),
      expression: "user.profile.firstname"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "firstname", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.firstname))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.lastname),
      expression: "user.profile.lastname"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "lastname", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.lastname))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_d),
      expression: "dob_d"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "DD"
    },
    domProps: {
      "value": (_vm.dob_d)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_d = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_m),
      expression: "dob_m"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "MM"
    },
    domProps: {
      "value": (_vm.dob_m)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_m = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_y),
      expression: "dob_y"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "YYYY"
    },
    domProps: {
      "value": (_vm.dob_y)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_y = $event.target.value
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.dob))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.email))])])])]), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.phone),
      expression: "user.profile.phone"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": (_vm.user.profile.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "phone", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.phone))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.business),
      expression: "user.profile.business"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.business)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "business", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.business))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.corporate),
      expression: "user.profile.corporate"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.profile.corporate) ? _vm._i(_vm.user.profile.corporate, null) > -1 : (_vm.user.profile.corporate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.profile.corporate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user.profile, "corporate", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user.profile, "corporate", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user.profile, "corporate", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.corporate ? 'Yes' : 'No'))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.address1),
      expression: "user.profile.address1"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "address1", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.address1))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.address2),
      expression: "user.profile.address2"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "address2", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.address2))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.suburb),
      expression: "user.profile.suburb"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "suburb", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.suburb))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.postcode),
      expression: "user.profile.postcode"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "postcode", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.postcode))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [(_vm.user.profile.country === 'AUSTRALIA') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.state),
      expression: "user.profile.state"
    }],
    staticClass: "form-select",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user.profile, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")])]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.state),
      expression: "user.profile.state"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "state", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.state))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.passport),
      expression: "user.profile.passport"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.passport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "passport", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.passport))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.country),
      expression: "user.profile.country"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user.profile, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.countries), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(k))])
  })], 2)]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.country))])])])]) : _vm._e(), _vm._v(" "), (_vm.isEdAdmin && _vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [(_vm.user.agreement) ? _c('div', [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.unlinkAgreement
    }
  }, [_vm._v("Unlink")])]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAgreement),
      expression: "newAgreement"
    }],
    staticClass: "form-select",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newAgreement = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.agreements), function(a) {
    return _c('option', {
      domProps: {
        "value": a._id
      }
    }, [_vm._v(_vm._s(a.name) + " (" + _vm._s(a.email) + ")")])
  }), 0)]) : _c('div', [(_vm.user.agreement) ? _c('router-link', {
    attrs: {
      "to": '/agreements/' + _vm.user.agreement
    }
  }, [_vm._v("View")]) : _c('label', {
    staticClass: "form-label"
  }, [_vm._v("N/A")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.source),
      expression: "user.profile.source"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user.profile, "source", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sources), function(s) {
    return _c('option', {
      domProps: {
        "value": s
      }
    }, [_vm._v(_vm._s(s))])
  })], 2)]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.source))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.details),
      expression: "user.profile.details"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "details", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.details))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.successMsg) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.successMsg))]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), (_vm.showButtons) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.isEdAdmin) ? _c('div', {
    staticClass: "col-12 adminControls"
  }, [(!_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editMode($event)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.wait1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (!_vm.user.verified && !_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.wait2
    },
    on: {
      "click": _vm.invite
    }
  }, [_vm._v("\n          Invite\n        ")]) : _vm._e(), _vm._v(" "), (_vm.user.level === 6) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toLevel(5)
      }
    }
  }, [_vm._v("Make full client")]) : _vm._e(), _vm._v(" "), (_vm.user.level === 5) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toLevel(6)
      }
    }
  }, [_vm._v("Make prospect")]) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.archiveUser($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.user.archived ? 'Unarchive' : 'Archive') + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showDelModal = true
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()]) : _c('div', {
    staticClass: "col-12"
  }, [(!_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editMode($event)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.wait1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showDelModal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.delUser
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showDelModal = false
      }
    }
  }, [_vm._v("No")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("New avatar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Brand")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("First name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Last name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Date of birth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Phone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Business")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Corporate client")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Address line 1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Address line 2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Suburb")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Postcode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("State")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Passport number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Country")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Cost agreement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Client source")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("More details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n          Are you sure?\n        ")])])
}]}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.doc && _vm.user) ? _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.show
    }
  }, [_c('a', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('a', {
    staticClass: "btn btn-clear float-right",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title h5"
  }, [_vm._v("Send to " + _vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "input-example-3"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('quillEditor', {
    attrs: {
      "id": "editor",
      "options": _vm.editorOptions
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Format")]), _vm._v(" "), _c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.format),
      expression: "format"
    }],
    attrs: {
      "type": "radio",
      "name": "format"
    },
    domProps: {
      "value": 'pdf',
      "checked": _vm._q(_vm.format, 'pdf')
    },
    on: {
      "change": function($event) {
        _vm.format = 'pdf'
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" PDF\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.format),
      expression: "format"
    }],
    attrs: {
      "type": "radio",
      "name": "format"
    },
    domProps: {
      "value": 'word',
      "checked": _vm._q(_vm.format, 'word')
    },
    on: {
      "change": function($event) {
        _vm.format = 'word'
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" Word\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-9"
  }, [(_vm.sendError) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v("Something went wrong")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Success")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      loading: _vm.sending
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send($event)
      }
    }
  }, [_vm._v("Send")])])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ })
],[256]);


// WEBPACK FOOTER //
// static/js/app.bad2c967f241238a25dd.js